export const es = {
  // Common
  common: {
    envBannerPrefix: 'Estás en',
    envBannerUnverified: 'Entorno no verificado',
    versionBadgeTitle: 'Ver notas de la versión',
    versionBadgeDev: 'dev',
    ok: 'OK',
    save: 'Guardar',
    cancel: 'Cancelar',
    delete: 'Eliminar',
    edit: 'Editar',
    readOnly: 'Solo lectura',
    none: 'Ninguno',
    change: 'Cambiar',
    add: 'Agregar',
    search: 'Buscar',
    filter: 'Filtrar',
    export: 'Exportar',
    import: 'Importar',
    submit: 'Enviar',
    go: 'Ir',
    reset: 'Restablecer',
    confirm: 'Confirmar',
    verify: 'Verificar',
    close: 'Cerrar',
    clickToViewDetails: 'Clic para ver detalles',
    done: 'Listo',
    cancelled: 'Cancelado',
    print: 'Imprimir',
    back: 'Atrás',
    goBack: 'Regresar',
    dismiss: 'Cerrar',
    dismissed: 'descartado',
    noResults: 'No se encontraron resultados',
    transfer: 'Transferencia',
    session: 'Sesión',
    next: 'Siguiente',
    previous: 'Anterior',
    loading: 'Cargando...',
    processing: 'Procesando...',
    error: 'Error',
    success: 'Éxito',
    warning: 'Advertencia',
    info: 'Información',
    yes: 'Sí',
    no: 'No',
    select: 'Seleccionar',
    selectAll: 'Seleccionar Todo',
    actions: 'Acciones',
    status: 'Estado',
    station: 'Estación',
    active: 'Activo',
    inactive: 'Inactivo',
    enabled: 'Habilitado',
    disabled: 'Deshabilitado',
    total: 'Total',
    of: 'de',
    showing: 'Mostrando',
    logout: 'Cerrar Sesión',
    settings: 'Configuración',
    location: 'Ubicación',
    lot: 'Lote',
    lotNumber: 'Número de Lote',
    case: 'caja',
    cases: 'cajas',
    selectLot: 'Seleccionar lote...',
    selectProductFirst: 'Seleccione un producto primero...',
    transferNumber: 'Número de Transferencia',
    saving: 'Guardando',
    deleting: 'Eliminando',
    view: 'Ver',
    viewAll: 'Ver Todo',
    optional: 'Opcional',
    accept: 'Aceptar',
    refresh: 'Actualizar',
    moreActions: 'Más acciones',
    linked: 'Vinculado',
    records: 'registros',
    all: 'Todos',
    continue: 'Continuar',
    filters: 'Filtros',
    exportCsv: 'Exportar CSV',
    clear: 'Limpiar',
    packer: 'Empacador',
    startedAt: 'Iniciado',
    completedAt: 'Completado',
  },

  // Print / Label Preview
  print: {
    previewTitle: 'Vista Previa de Etiqueta',
    previewDescription: 'Así se vería la etiqueta al imprimirla.',
    copy: 'copia',
    copies: 'copias',
    willBePrinted: 'se imprimirán',
  },

  // Status labels for sessions (WCO-2146)
  status: {
    pending: 'Pendiente',
    submitted: 'Enviado',
    received: 'Recibido',
    ready: 'Listo',
    active: 'Activo',
    paused: 'Pausado',
    completed: 'Completado',
    cancelled: 'Cancelado',
    // Legacy alias for pre-WCO-2146 'planned' rows
    planned: 'Recibido',
  },

  // OAuth - Autenticación de dominio WayFong
  oauth: {
    validating: 'Validando acceso organizacional...',
    redirecting: 'Redirigiendo a inicio de sesión organizacional...',
    error: 'Autenticación organizacional fallida',
    retry: 'Intentar de Nuevo',
    sessionExpired: 'Su sesión organizacional ha expirado.',
    loggedInAs: 'Conectado como',
    accessDenied: {
      title: 'Sin acceso a HTE Producción',
      message: 'Su cuenta no está autorizada para usar HTE Producción. Contacte a su gerente para solicitar acceso.',
      signOut: 'Cerrar sesión',
    },
    signedOut: {
      title: 'Sesión cerrada',
      message: 'Ha cerrado sesión en HTE Producción.',
      signIn: 'Iniciar sesión',
    },
  },

  // Authentication
  auth: {
    login: 'Iniciar Sesión',
    username: 'Usuario',
    password: 'Contraseña',
    rememberMe: 'Recordarme',
    forgotPassword: '¿Olvidó su contraseña?',
    loginButton: 'Iniciar Sesión',
    loginError: 'Usuario o contraseña inválidos',
    sessionExpired: 'Su sesión ha expirado. Por favor inicie sesión nuevamente.',
    unauthorized: 'No está autorizado para acceder a este recurso',
    // Password confirmation modal (WCO-2706)
    loggedInAs: 'Sesión iniciada como',
  },

  // Navigation
  nav: {
    clockIn: 'Registrar Entrada',
    dashboard: 'Panel de Control',
    users: 'Usuarios',
    locations: 'Ubicaciones',
    inventory: 'Inventario',
    stations: 'Estaciones',
    settings: 'Configuración',
    supervisor: 'Panel de Control',
    operator: 'Cola de Tareas',
    production: 'Producción',
    productionEntry: 'Entrada de Producción',
    mobileView: 'Vista Móvil',
    desktopView: 'Vista de Escritorio',
    reports: 'Reportes',
    productCatalog: 'Catálogo de Artículos',
    itemCatalog: 'Catálogo de Artículos',
    cameraManagement: 'Gestión de Cámaras',
    cameraMonitoringDashboard: 'Panel de Monitoreo de Cámaras',
    labelManagement: 'Gestión de Etiquetas',
    transferVerification: 'Recepción',
    transferHistory: 'Historial de Transferencias',
    productionAssignments: 'Asignaciones de Producción',
    materialConsumption: 'Consumo de Materiales',
    dailyGuide: 'Guía de Producción',
    managerDashboard: 'Panel de Control',
    endOfDaySummary: 'Resumen del Día',
    overrideHistory: 'Historial de Anulaciones',
    warehouseTransfer: 'Transferencia',
    approvalQueue: 'Cola de Aprobación',
    boxSearch: 'Búsqueda de Cajas',
    yieldVariance: 'Variación de Rendimiento',
    approvalHistory: 'Historial de Aprobaciones',
    itemSummaryReport: 'Resumen de Artículos',
    logout: 'Cerrar Sesión',
    language: 'Idioma',
    dailyWorkQueue: 'Cola de Trabajo Diaria',
    workSchedule: 'Horario de Trabajo',
    schedule: 'Horario',
    byproductMapping: 'Mapeo de Productos',
    productionRecords: 'Registros de Producción',
    productionProgress: 'Progreso de Producción',
    devTools: 'Herramientas Dev',
    tutorial: 'Tutorial',
    notifications: 'Notificaciones',
    noNotifications: 'Sin notificaciones',
  },

  // Schedule page (combined view)
  schedule: {
    weeklyView: 'Vista Semanal',
    dailyQueue: 'Cola Diaria',
  },

  dailyWorkQueue: {
    title: 'Cola de Trabajo Diaria',
    subtitle: 'Ver y rastrear sub-sesiones de producción diarias',
    status: 'Estado',
    station: 'Estación',
    operator: 'Operador',
    packer: 'Empacador',
    product: 'Producto',
    expectedBoxes: 'Cajas Esperadas',
    producedBoxes: 'Cajas Producidas',
    scheduledDate: 'Fecha Programada',
    subSession: 'Sub-Sesión #',
    sessionNumber: 'Sesión #',
    noData: 'No se encontraron sub-sesiones para el rango de fechas seleccionado.',
    unassigned: 'Sin Asignar',
    today: 'Hoy',
    allStatuses: 'Todos los Estados',
    scheduledWorkforce: 'Personal Programado',
    operators: 'Operadores',
    packers: 'Empacadores',
    stations: 'Estaciones',
    availableOf: 'disponibles',
    noStation: 'Sin estación',
    assigned: 'Asignado',
    scheduledStations: 'Programadas para hoy',
    clickToAssign: 'Asignar',
    assignStation: 'Asignar Estación',
    assignOperator: 'Asignar Operador',
    assignPacker: 'Asignar Empacador',
    selectStation: 'Seleccionar estación',
    selectOperator: 'Seleccionar operador',
    selectPacker: 'Seleccionar empacador',
    assignedSuccess: 'Asignado exitosamente',
    noAvailable: 'Sin opciones disponibles',
    clickToReassign: 'Clic para reasignar',
    reassignStation: 'Reasignar Estación',
    reassignOperator: 'Reasignar Operador',
    reassignPacker: 'Reasignar Empacador',
    currentAssignee: 'Actual',
  },

  // Manager
  manager: {
    dashboard: 'Panel de Control',
    dashboardSubtitle: 'Monitorear producción y gestionar sesiones',
    vb6TransferReminders: 'Transferencias VB6 pendientes de eliminar',
    vb6TransferRemindersDesc: 'Las siguientes sesiones canceladas tienen transferencias enviadas que deben eliminarse en el sistema VB6.',
    transferReminderDismissed: 'Recordatorio descartado',
    transferReminderResolved: 'Transferencia confirmada eliminada',
    markResolved: 'Resolver',
    excessiveReprintsAlert: 'Reimpresiones excesivas de etiquetas detectadas',
    reprints: 'reimpresiones',
    reprintAlertResolved: 'Alerta de reimpresión resuelta',
    draftTransferReminder: 'Transferencia a HTE aún no enviada',
    todaysSessions: 'Sesiones de Hoy',
    plannedSessions: 'Enviadas',
    activeSessions: 'Activas',
    completedSessions: 'Completadas',
    quickActions: 'Acciones Rápidas',
    manageSessionsDesc: 'Crear y gestionar sesiones de producción',
    stationsActive: 'activas',
    viewInventoryDesc: 'Ver materiales e inventario',
    todaysWorkforce: 'Personal de Hoy',
    operators: 'Operadores',
    packers: 'Empacadores',
    stations: 'Estaciones',
    remainingMaterialLots: 'Lotes de Material',
    lots: 'Lotes',
    weight: 'Peso',
    sessions: 'Sesiones',
    stationOverview: 'Resumen de Estaciones',
    sessionOverview: 'Resumen de Sesiones',
    stationView: 'Vista de Estaciones',
    sessionView: 'Vista de Sesiones',
    productionProgressOverview: 'Progreso de Producción',
    overall: 'General',
    noSessionsToday: 'No hay sesiones de producción programadas para hoy',
    operator: 'Operador',
    packer: 'Empacador',
    boxes: 'cajas',
    lbs: 'lbs',
    noActiveSession: 'Sin sesión activa',
    todaysOutput: 'Producción de Hoy',
    input: 'Entrada',
    output: 'Salida',
    avgYield: 'Rend. Prom.',
    expected: 'Esperado',
    completion: 'Completado',
    // KPI detail modal
    kpiDetail: {
      sessionsTitle: 'Desglose de Sesiones de Hoy',
      workforceTitle: 'Desglose del Personal de Hoy',
      lotsTitle: 'Desglose de Lotes de Material',
      outputTitle: 'Desglose de Producción de Hoy',
      sessionNumber: 'Sesión #',
      product: 'Producto',
      status: 'Estado',
      subSessions: 'Sub-Sesiones',
      submitted: 'Enviadas',
      received: 'Recibidas',
      planned: 'Recibidas',
      active: 'Activas',
      completed: 'Completadas',
      employeeNumber: 'Empleado #',
      name: 'Nombre',
      role: 'Rol',
      stationName: 'Estación',
      type: 'Tipo',
      itemNumber: 'Artículo #',
      itemName: 'Nombre del Artículo',
      weightLbs: 'Peso (lbs)',
      location: 'Ubicación',
      receivedDate: 'Recibido',
      outputBoxes: 'Producción (CS)',
      expectedBoxes: 'Esperado (CS)',
      completionPct: '% Completado',
      noData: 'Sin datos disponibles',
      clickToViewDetails: 'Clic para ver detalles',
      loading: 'Cargando...',
      operatorsSection: 'Operadores',
      packersSection: 'Empacadores',
      stationsSection: 'Estaciones',
      rowNumber: '#',
      cases: 'Cajas',
    },
  },

  // Transfer History
  transferHistory: {
    subtitle: 'Ver historial de transferencias verificadas',
  },

  productionProgress: {
    activeStations: 'Estaciones Activas',
    boxesPacked: 'Cajas Empacadas',
    totalWeight: 'Peso Total',
    avgOutput: 'Prod. Prom.',
    all: 'Todos',
    station: 'Estación',
    queue: 'Cola',
    product: 'Producto',
    operator: 'Operador',
    packer: 'Empacador',
    status_header: 'Estado',
    boxes: 'Cajas',
    progress: 'Progreso',
    weight: 'Peso (lbs)',
    elapsed: 'Tiempo',
    noSessions: 'No hay sesiones de producción para esta fecha',
    status: {
      active: 'Activa',
      paused: 'Pausada',
      ready: 'Lista',
      received: 'Recibida',
      submitted: 'Enviada',
      planned: 'Recibida',
      pending: 'Pendiente',
      completed: 'Completada',
      cancelled: 'Cancelada',
    },
  },

  productionRecords: {
    subtitle: 'Ver registros de producción ICS y datos de preparación HTE',
    source: 'Fuente',
    syncStatus: 'Estado de Sincronización',
    pending: 'Pendiente',
    synced: 'Sincronizado',
    failed: 'Fallido',
    allSources: 'Todas las Fuentes',
    inputMaterials: 'Materiales de Entrada',
    outputProducts: 'Productos de Salida',
    weightEntries: 'registros de peso',
    noRecords: 'No se encontraron registros de producción',
    sessionLink: 'Ver Sesión',
    detailCount: 'Líneas de Detalle',
    productionNumber: 'Producción #',
    dateRange: 'Rango de Fechas',
    operator: 'Operador',
    location: 'Ubicación',
    createdBy: 'Creado Por',
    // Detail view
    title: 'Registro de Producción',
    productionNo: 'No. de Producción',
    printBarcodes: 'Imprimir Códigos',
    printBarcodesPopupBlocked: 'Ventana emergente bloqueada — permita ventanas emergentes para imprimir códigos',
    printBarcodesFailed: 'No se pudieron cargar los códigos',
    requestDate: 'Fecha de Solicitud',
    finishDate: 'Fecha de Finalización',
    productionComplete: 'Producción Completa',
    productionLocation: 'Lugar de Producción',
    memo: 'Nota',
    inputTab: 'Material de Entrada',
    outputTab: 'Producto Terminado',
    quantity: 'Cant. Sol.',
    quantityShipped: 'Cant. Env.',
    weightShipped: 'Peso',
    warehouseCol: 'Almacén',
    locationCol: 'Ubic.',
    referenceNo: 'No. de Referencia',
    unitPrice: 'Precio Unit.',
    amount: 'Monto',
    materialDocNo: 'No. Doc. Material',
    materialDocType: 'Tipo Doc. Material',
    eItem: 'E-Artículo',
    backToList: 'Volver a la Lista',
    notFound: 'Registro de producción no encontrado',
    loadFailed: 'Error al cargar el registro de producción',
  },

  // Dashboard
  dashboard: {
    title: 'Panel de Control',
    welcome: 'Bienvenido',
    overview: 'Resumen del Sistema',
    activeUsers: 'Usuarios Activos',
    activeStations: 'Estaciones Activas',
    todayProduction: 'Producción de Hoy',
    alerts: 'Alertas',
    recentActivity: 'Actividad Reciente',
    statistics: 'Estadísticas',
    performance: 'Rendimiento',
  },

  // Users
  users: {
    title: 'Gestión de Usuarios',
    addUser: 'Agregar Usuario',
    editUser: 'Editar Usuario',
    deleteUser: 'Eliminar Usuario',
    userDetails: 'Detalles del Usuario',
    userId: 'ID de Usuario',
    fullName: 'Nombre Completo',
    userLevel: 'Nivel de Usuario',
    location: 'Ubicación',
    department: 'Departamento',
    email: 'Correo Electrónico',
    phone: 'Teléfono',
    createdAt: 'Fecha de Creación',
    lastLogin: 'Último Inicio de Sesión',
    permissions: 'Permisos',
    role: 'Rol',
    admin: 'Administrador',
    supervisor: 'Supervisor',
    operator: 'Operador',
    userCount: 'Total de Usuarios',
    activeCount: 'Usuarios Activos',
    searchUsers: 'Buscar usuarios...',
  },

  // Locations
  locations: {
    title: 'Gestión de Ubicaciones',
    addLocation: 'Agregar Ubicación',
    editLocation: 'Editar Ubicación',
    deleteLocation: 'Eliminar Ubicación',
    locationDetails: 'Detalles de Ubicación',
    locationId: 'ID de Ubicación',
    locationCode: 'Código de Ubicación',
    locationName: 'Nombre de Ubicación',
    description: 'Descripción',
    address: 'Dirección',
    manager: 'Gerente',
    capacity: 'Capacidad',
    stationCount: 'Estaciones',
    searchLocations: 'Buscar ubicaciones...',
  },

  // Stations
  stations: {
    title: 'Gestión de Estaciones',
    addStation: 'Agregar Estación',
    editStation: 'Editar Estación',
    deleteStation: 'Eliminar Estación',
    stationDetails: 'Detalles de Estación',
    stationId: 'ID de Estación',
    stationName: 'Nombre de Estación',
    stationType: 'Tipo de Estación',
    location: 'Ubicación',
    assignedOperator: 'Operador Asignado',
    currentProduction: 'Producción Actual',
    targetProduction: 'Producción Objetivo',
    efficiency: 'Eficiencia',
    searchStations: 'Buscar estaciones...',
    printerMac: 'Dirección MAC de Impresora',
    printerMacDesc: 'Dirección MAC de la impresora Zebra asignada a esta estación',
    printerStatus: 'Estado de Impresora',
    printerConnected: 'Conectada',
    printerNotFound: 'No Encontrada',
    printerNotAssigned: 'Sin Impresora Asignada',
    assignPrinter: 'Asignar Impresora',
    removePrinter: 'Quitar Impresora',
    discoverPrinters: 'Descubrir Impresoras',
    testPrint: 'Prueba de Impresión',
    testPrintSuccess: 'Etiqueta de prueba enviada a la impresora exitosamente',
    testPrintFailed: 'Prueba de impresión fallida',
    printerMacPlaceholder: 'XX:XX:XX:XX:XX:XX',
    discovering: 'Descubriendo...',
    noPrintersFound: 'No se encontraron impresoras en la red',
    selectPrinter: 'Seleccione una impresora para asignar',
    printerAssigned: 'Impresora asignada exitosamente',
    printerRemoved: 'Impresora removida',
    printerLinkError: 'Error al guardar la asignación de la impresora — es posible que la estación no tenga una impresora asignada',
  },

  // Inventory
  inventory: {
    title: 'Gestión de Inventario',
    dashboard: 'Panel de Inventario',
    productCatalog: 'Catálogo de Artículos',
    itemCatalog: 'Catálogo de Artículos',
    browseManageItems: 'Explorar y gestionar todos los artículos del inventario',
    addNewItem: 'Agregar Nuevo Artículo',
    itemType: 'Tipo de Artículo',
    allItems: 'Todos los Artículos',
    rawMaterials: 'Materias Primas',
    finishedProducts: 'Productos Terminados',
    searchItems: 'Buscar Artículos',
    searchByItemNumber: 'Buscar por Número de Artículo o Nombre...',
    allLocations: 'Todas las Ubicaciones',
    itemName: 'Nombre del Artículo',
    itemNumber: 'Artículo #',
    stock: 'Existencias',
    outOfStock: 'Agotado',
    lowStock: 'Stock Bajo',
    inStock: 'En Stock',
    viewDetails: 'Ver Detalles',
    loadingItems: 'Cargando artículos...',
    failedToLoadItems: 'Error al cargar artículos',
    noItemsFound: 'No se encontraron artículos',
    finishedGoods: 'Productos Terminados',
    stockLevel: 'Nivel de Stock',
    reorderPoint: 'Punto de Reorden',
    supplier: 'Proveedor',
    category: 'Categoría',
    sku: 'SKU',
    barcode: 'Código de Barras',
    quantity: 'Ctd',
    unit: 'Unidad',
    weight: 'Peso',
    price: 'Precio',
    cost: 'Costo',
    lastUpdated: 'Última Actualización',
    updatedAt: 'Actualizado El',
    updatedBy: 'Actualizado Por',
    searchInventory: 'Buscar inventario...',
    // Lot inventory
    availableLots: 'Lotes Disponibles',
    expiringSoon: 'Por Vencer',
    within7Days: 'Dentro de 7 días',
    packedBoxes: 'Cajas Empacadas',
    boxesToday: 'Cajas Hoy',
    shipped: 'enviadas',
    rawMaterialLots: 'Lotes de Materia Prima',
    allStatuses: 'Todos los Estados',
    statusRemaining: 'Restantes (en existencia)',
    statusAvailable: 'Disponible',
    statusReserved: 'Reservado',
    statusDepleted: 'Agotado',
    statusPacked: 'Empacado',
    statusShipped: 'Enviado',
    statusVoided: 'Anulado',
    statusRejected: 'Rechazado',
    statusOn_hold: 'En Espera',
    statusConsumed: 'Consumido',
    statusRemainder: 'Remanente',
    statusByProduct: 'Subproducto',
    statusByProductM: 'Subproducto (Comercializable)',
    statusByProductP: 'Subproducto (Para Producción)',
    statusFinishProductNi: 'Producto Terminado - No Intacto',
    marketableByproduct: 'Subproducto Comercializable',
    onHoldApproved: 'En espera (aprobado)',
    onHoldPending: 'En espera (pendiente)',
    lotNumber: 'Número de Lote',
    currentWeight: 'Peso Act.',
    allocatedToSession: 'Asignado a Sesión',
    expiryDate: 'Fecha de Vencimiento',
    receivedDate: 'Fecha de Recepción',
    receivedBy: 'Recibido Por',
    productName: 'Nombre del Producto',
    packedAt: 'Empacado En',
    boxCount: 'Cantidad de Cajas',
    boxCountNote: 'Incluye cajas canceladas',
    expectedCount: 'Esperado',
    totalWeight: 'Peso Total',
    lastPacked: 'Último Empaque',
    yieldFactor: 'Factor de Rendimiento',
    // Raw Material Receiving
    addRawMaterial: 'Agregar Materia Prima',
    receiveRawMaterial: 'Recibir Materia Prima',
    scanTransferNumber: 'Escanear Número de Transferencia',
    enterTransferNumber: 'Ingrese o escanee número de transferencia...',
    transferInfo: 'Información de Transferencia',
    transferNumber: 'Número de Transferencia',
    transferDate: 'Fecha de Transferencia',
    fromLocation: 'Ubicación Origen',
    toLocation: 'Ubicación Destino',
    noTransferFound: 'No se encontró transferencia con este número',
    transferNotFound: 'Transferencia No Encontrada',
    startScanningBoxes: 'Comenzar a Escanear Cajas',
    scanBoxes: 'Escanear Cajas',
    scanBoxBarcode: 'Escanear código de barras de caja...',
    boxesScanned: 'Cajas Escaneadas',
    removeBox: 'Eliminar',
    confirmReceiving: 'Confirmar Recepción',
    confirmReceivingMessage: 'Está a punto de recibir la siguiente materia prima:',
    receivingSuccess: 'Materia prima recibida exitosamente',
    receivingError: 'Error al recibir materia prima',
    invalidTransfer: 'Número de transferencia inválido',
    selectExpiryDate: 'Seleccionar fecha de vencimiento',
    boxes: 'cajas',
    lbs: 'lbs',
    back: 'Atrás',
    confirmAndSave: 'Confirmar y Guardar',
    scanningBoxesFor: 'Escaneando cajas para',
    noBoxesScanned: 'Ninguna caja escaneada aún',
    scanBoxToAdd: 'Escanee un código de barras de caja para agregarlo a la lista',
    itemsInTransfer: 'Artículos en Transferencia',
    expectedQuantity: 'Cantidad Esperada',
    expectedWeight: 'Peso Esperado',
    productNotInTransfer: 'Producto no encontrado en esta transferencia',
    invalidBarcode: 'Formato de código de barras inválido',
    alreadyReceived: 'Recibido',
    pending: 'Pendiente',
    itemAlreadyReceived: 'Este artículo ya ha sido recibido de esta transferencia',
    // Box Lookup
    boxLookup: 'Búsqueda de Caja',
    boxLookupSearchPlaceholder: 'Ingrese o escanee código de barras...',
    boxLookupSearch: 'Buscar',
    boxLookupNoResults: 'No se encontró caja con este código de barras',
    boxLookupError: 'Error al buscar código de barras',
    boxLookupProductSku: 'Número de Artículo',
    boxLookupRawMaterial: 'Materia Prima',
    boxLookupBoxNumber: 'Número de Caja',
    boxLookupWeight: 'Peso',
    boxLookupStation: 'Estación',
    boxLookupOperator: 'Operador',
    boxLookupPacker: 'Empacador',
    boxLookupEmployeeNumber: 'Empleado #',
    boxLookupSession: 'Sesión',
    boxLookupLot: 'Número de Lote',
    boxLookupPackedAt: 'Empacado',
    boxLookupPrintedAt: 'Etiqueta Impresa',
    boxLookupPackedAndLabeledAt: 'Empacado y Etiquetado',
    boxLookupStatus: 'Estado',
    boxLookupBarcode: 'Código de Barras',
    boxLookupNotAvailable: 'N/D',
    // Marketable By-Product (buffer / case) Lookup
    bufferFound: 'Subproducto Comercializable (Búfer)',
    caseFound: 'Subproducto Comercializable (Caja)',
    bufferSourceMaterial: 'Material de Origen',
    bufferReservedWeight: 'Peso',
    bufferSubSession: 'Subsesión',
    bufferProductionDate: 'Fecha de Producción',
    // Raw Material Lookup
    rawMaterialFound: 'Materia Prima',
    rawMaterialItemNumber: 'Número de Artículo',
    rawMaterialGtin: 'GTIN',
    rawMaterialLot: 'Número de Lote',
    rawMaterialWeight: 'Peso Escaneado',
    rawMaterialBrand: 'Marca',
    rawMaterialYieldFactor: 'Factor de Rendimiento',
    // Transaction History tab
    transactionHistory: 'Historial de Transacciones',
    transactionType: 'Tipo',
    allTypes: 'Todos los Tipos',
    change: 'Cambio',
    balance: 'Saldo',
    noTransactions: 'No se encontraron transacciones',
    transactionSessionStart: 'Inicio de Sesión',
    transactionSessionCancel: 'Cancelación de Sesión',
    transactionSessionComplete: 'Sesión Completada',
    transactionCasePacked: 'Caja Empacada',
    transactionCaseCancelled: 'Caja Cancelada',
    transactionCaseVoided: 'Caja Anulada',
    transactionCasePending: 'Caja Pendiente',
    transactionWasteRecorded: 'Desperdicio Registrado',
    transactionManualAdjustment: 'Ajuste Manual',
    transactionOracleSync: 'Sincronización Oracle',
    transactionMaterialIssue: 'Despacho de Material',
    transactionLotReceived: 'Lote Recibido',
    transactionLotRejected: 'Lote Rechazado',
    transactionLotReserved: 'Lote Reservado',
    transactionByProductReceived: 'Subproducto',
    transactionByProductMarketableReceived: 'Subproducto (Comercial)',
    transactionByProductProductionReceived: 'Subproducto (Producción)',
    transactionRemainderReceived: 'Remanente',
    transactionRemainderIntactReceived: 'Remanente (Intacto)',
    transactionRemainderNotIntactReceived: 'Remanente (No Intacto)',
    transactionByProductMarketablePrinted: 'Subproducto Comercial — Etiqueta Impresa',
    transactionByProductCasePrinted: 'Subproducto Comercial — Etiqueta de Caja Impresa',
    transactionFinishProductNotIntactReserved: 'Producto Terminado NI — Reservado para Transferencia',
    transactionFinishProductNotIntactReceived: 'Producto Terminado NI — Recibido',

    scanDetails: 'Detalles de Escaneo',
    box: 'Caja',
    noScanDetails: 'No hay detalles de escaneo disponibles para este lote',
    remark: 'Observación',
    scannedAt: 'Escaneado',

    // Packing Materials tab
    packingMaterials: 'Materiales de Empaque',
    totalPackingItems: 'Artículos de Empaque',
    totalPackingLots: 'Lotes de Empaque',
    lowStockItems: 'Stock Bajo/Cero',
    linkedProducts: 'Productos Vinculados',
  },

  // Production
  production: {
    title: 'Producción',
    assignments: 'Asignaciones de Producción',
    schedule: 'Programación de Producción',
    batch: 'Lote',
    batchNumber: 'Número de Lote',
    startTime: 'Hora de Inicio',
    endTime: 'Hora de Fin',
    duration: 'Duración',
    producedQuantity: 'Cantidad Producida',
    targetQuantity: 'Cantidad Objetivo',
    progress: 'Progreso',
    materials: 'Materiales',
    consumption: 'Consumo de Materiales',
    yield: 'Rendimiento',
    expectedYield: 'Rendimiento Esperado',
    actualYield: 'Rendimiento Real',
    waste: 'Desperdicio',
    notes: 'Notas',
    remnantAvailable: 'Remanente disponible',
  },

  // Settings
  settings: {
    title: 'Configuración',
    general: 'Configuración General',
    system: 'Configuración del Sistema',
    appearance: 'Apariencia',
    language: 'Idioma',
    theme: 'Tema',
    notifications: 'Notificaciones',
    security: 'Seguridad',
    backupRestore: 'Respaldo y Restauración',
    about: 'Acerca de',
    version: 'Versión',
  },

  // Validation
  validation: {
    required: 'Este campo es obligatorio',
    invalidEmail: 'Dirección de correo inválida',
    invalidPhone: 'Número de teléfono inválido',
    minLength: 'La longitud mínima es {{min}} caracteres',
    maxLength: 'La longitud máxima es {{max}} caracteres',
    passwordMismatch: 'Las contraseñas no coinciden',
    invalidFormat: 'Formato inválido',
    mustBeNumber: 'Debe ser un número',
    mustBePositive: 'Debe ser un número positivo',
  },

  // Messages
  messages: {
    saveSuccess: 'Guardado exitosamente',
    deleteSuccess: 'Eliminado exitosamente',
    updateSuccess: 'Actualizado exitosamente',
    createSuccess: 'Creado exitosamente',
    deleteConfirm: '¿Está seguro de que desea eliminar este elemento?',
    unsavedChanges: 'Tiene cambios sin guardar. ¿Desea salir?',
    operationFailed: 'La operación falló',
    networkError: 'Error de red. Por favor verifique su conexión.',
    serverError: 'Error del servidor. Por favor intente más tarde.',
    loadFailed: 'No se pudo cargar {item}. Algunas funciones pueden usar valores predeterminados.',
    refreshFailed: 'No se pudo actualizar los datos. Por favor recargue la página.',
    noData: 'No hay datos disponibles',
    noResults: 'No se encontraron resultados',
  },

  // Date & Time
  dateTime: {
    date: 'Fecha',
    time: 'Hora',
    today: 'Hoy',
    yesterday: 'Ayer',
    thisWeek: 'Esta Semana',
    thisMonth: 'Este Mes',
    lastWeek: 'Semana Pasada',
    lastMonth: 'Mes Pasado',
    customRange: 'Rango Personalizado',
    from: 'Desde',
    to: 'Hasta',
  },

  // Operator
  operator: {
    // Production Entry
    packBoxes: 'Empacar Cajas',
    stationAssigned: 'Estación Asignada',
    productionSessionAssigned: 'Sesión de producción asignada a su estación',
    noStationAssignment: 'Sin Asignación de Estación',
    noSessionAssigned: 'Actualmente no tiene una sesión de producción asignada a su estación.',
    contactSupervisor: 'Por favor contacte a su supervisor para asignar una sesión de producción.',
    enterPackageWeight: 'Ingrese Peso del Paquete',
    printAndPackBox: 'Imprimir y Empacar Caja',
    printAndPackSubUnit: 'Imprimir y Empacar Sub-unidad',
    packSubUnit: 'Empacar Sub-Unidad',
    subUnit: 'Sub-unidad',
    masterBox: 'Caja Principal',
    weighMasterBoxPrompt: 'Todas las sub-unidades pesadas. Ahora pese la caja principal.',
    nowWeighTheBox: 'Ahora pese la caja con todas las sub-unidades adentro',
    continue: 'Continuar',
    subUnitWeightMissing: 'Datos del producto incompletos - sub_unit_weight no configurado. Contacte al supervisor.',
    subUnitPacked: 'Sub-unidad empacada!',
    printing: 'Imprimiendo...',
    target: 'Objetivo',
    scaleReading: 'Lectura de Báscula',
    readyForWeighing: 'Listo para pesar',
    acceptable: 'Aceptable',
    productionPausedResume: 'Producción Pausada - Haz clic en "Reanudar" para continuar',
    clickStartProduction: 'Haz clic en "Iniciar" para comenzar la producción',

    // Scale Weight component
    targetWeightScale: 'Peso Objetivo',
    tareButton: 'Tara/Cero Báscula (Restablecer Peso del Empaque)',
    targetReachedMsg: 'Objetivo alcanzado - No se permite más empaque',
    targetUnreachedMsg: 'Coloque el empaque vacío en la báscula y haga clic para ponerla en cero',
    weightAcceptable: 'El peso es aceptable',
    invalidWeightNegative: 'Peso inválido (negativo)',
    overTarget: 'SOBRE el objetivo',
    underTarget: 'BAJO el objetivo',
    acceptableRangeLabel: 'Aceptable',
    removeContentsReweigh: 'Retire contenido y vuelva a pesar',
    addContentsReweigh: 'Agregue contenido y vuelva a pesar',

    // Metrics
    boxesPacked: 'Cajas Empacadas',
    estimated: 'Estimado',
    totalOutput: 'Producción Total',
    outputProgress: 'Progreso de Producción',
    recentBoxes: 'Cajas Recientes',
    boxNumber: 'Caja #',
    weight: 'Peso',
    time: 'Hora',
    tolerance: 'Tolerancia',

    // Session Info
    sessionInfo: 'Info de Sesión',
    product: 'Producto',
    itemNumber: 'Número de Artículo',
    station: 'Estación',
    lot: 'Lote',
    supervisor: 'Supervisor',
    initialMaterial: 'Material Inicial',
    usableMaterial: 'Material Utilizable',
    rawMaterial: 'Materia Prima',
    targetWeight: 'Peso Objetivo/Caja',
    targetOutput: 'Objetivo',

    // Session Time & Material Details
    sessionTime: 'Tiempo de Sesión',
    startedAt: 'Iniciado',
    materialDetails: 'Detalles del Material',
    initialMaterialWeight: 'Peso del Material Inicial',
    targetOutputWeight: 'Peso de Producción Objetivo',
    actualOutputWeight: 'Peso de Producción Real',
    yieldRate: 'Tasa de Rendimiento',
    yield: 'Rendimiento',
    completionRate: 'Tasa de Completado',
    weightModeChanged: 'Modo de peso cambiado a',

    // Quality Control
    qualityControlCheck: 'Control de Calidad',
    completeAllChecks: 'Complete todas las verificaciones de calidad antes de empacar la caja',
    visualInspection: 'Inspección Visual',
    weightVerified: 'Peso Verificado',
    labelingCorrect: 'Etiquetado Correcto',
    packagingIntact: 'Empaque Intacto',
    checkAll: 'Marcar Todo',
    uncheckAll: 'Desmarcar Todo',
    qualityChecksCompleted: 'Verificaciones de Calidad Completadas',

    // Quality descriptions
    qualityDescVisual: 'El producto luce fresco, sin decoloración ni daños',
    qualityDescWeight: 'El peso es',
    qualityDescLabeling: 'Etiqueta impresa claramente con número de lote y peso correctos',
    qualityDescPackaging: 'Sin rasgaduras, perforaciones o defectos en el empaque',

    // Packing Confirmation
    confirmPacking: 'Confirmar Empaque',
    labelPrinted: 'La etiqueta se ha impreso exitosamente',
    verifyBeforePacking: 'Por favor verifique lo siguiente antes de confirmar',
    boxWeight: 'Peso de la Caja',
    withinTolerance: 'Dentro de Tolerancia',
    allQualityChecksPassed: 'Todas las verificaciones de calidad aprobadas',
    confirmAndPack: 'Confirmar y Empacar',

    // Label Applied Confirmation
    confirmLabelApplied: 'Confirmar Etiqueta Aplicada',
    labelsPrinted: '{{count}} copias de etiqueta han sido impresas',
    confirmLabelAppliedDescription: 'Por favor confirme que la etiqueta ha sido aplicada correctamente a la caja antes de continuar.',

    // Shipping/Transfer
    ship: 'Listo para Transferir/Recoger',
    shipped: 'Enviado',
    selectShippingLocation: 'Seleccione la ubicación de destino para enviar esta caja.',
    shippingLocationRequired: 'Seleccione ubicación de envío (requerido)...',
    confirmShip: 'Confirmar Envío',
    shipping: 'Enviando...',
    shippedTo: 'A',

    // Locations
    warehouseA: 'Almacén A',
    warehouseB: 'Almacén B',
    warehouseC: 'Almacén C',
    distributionCenter1: 'Centro de Distribución 1',
    distributionCenter2: 'Centro de Distribución 2',
    coldStorage: 'Almacén Frío',
    retailStore: 'Tienda Minorista',
    customerDirect: 'Cliente Directo',

    // Session Control
    start: 'Iniciar',
    pause: 'Pausar',
    resume: 'Reanudar',
    complete: 'Completar',
    startSession: 'Iniciar Sesión',
    pauseSession: 'Pausar Sesión',
    resumeSession: 'Reanudar Sesión',
    completeSession: 'Completar Sesión',
    starting: 'Iniciando...',
    pausing: 'Pausando...',
    resuming: 'Reanudando...',
    completing: 'Completando...',
    pauseProductionSession: 'Pausar Sesión de Producción',
    reviewProgressAndReason: 'Revise el progreso actual y proporcione una razón para pausar la sesión.',
    selectPauseReason: 'Seleccione razón de pausa (requerido)...',
    selectCompletionReason: 'Seleccione razón de completado...',
    addFinalNotes: 'Agregue notas finales u observaciones (opcional)...',

    // Status Messages
    sessionStarted: 'Sesión iniciada exitosamente',
    sessionPaused: 'Sesión pausada',
    sessionResumed: 'Sesión reanudada',
    sessionCompleted: 'Sesión completada exitosamente',
    missionAccomplished: '¡Misión Cumplida!',
    betterThanExpected: '¡Mejor de lo Esperado!',
    ofTargetCompleted: 'del objetivo completado',
    unassign: 'Desasignar',
    unassignConfirm: '¿Desasignar de la sesión?',
    unassignMessage: '¿Estás seguro de que deseas desasignarte? La sesión volverá al Pool To Do.',
    unassignSuccess: 'Desasignado exitosamente',
    cancelAssignment: 'Cancelar',
    cancelAssignmentConfirm: '¿Cancelar asignación?',
    cancelAssignmentMessage: '¿Estás seguro de que deseas cancelar esta asignación? Puedes reasignarte desde Pool To Do.',
    cancelAssignmentSuccess: 'Asignación cancelada',
    boxMarkedAsShipped: 'Caja marcada como enviada',
    providePauseReason: 'Por favor proporcione una razón de pausa',
    selectShippingLocationError: 'Por favor seleccione una ubicación de envío',
    noBoxSelected: 'Ninguna caja seleccionada',

    // Pause Reasons
    breakTime: 'Hora de Descanso',
    equipmentIssue: 'Problema de Equipo',
    materialShortage: 'Escasez de Material',
    qualityIssue: 'Problema de Calidad',
    shiftChange: 'Cambio de Turno',
    maintenance: 'Mantenimiento',
    other: 'Otro',

    // Complete Reasons
    targetReached: 'Producción Objetivo Alcanzada',
    notYetReached: 'Aún no alcanzado',
    endOfShift: 'Fin de Turno',
    materialDepleted: 'Material Agotado',
    qualityIssues: 'Problemas de Calidad',
    maintenanceRequired: 'Mantenimiento de Equipo Requerido',
    orderComplete: 'Orden de Producción Completa',

    // Waste Tracking
    wasteTracking: 'Seguimiento de Desperdicios',
    recordWaste: 'Registrar Desperdicio',
    recording: 'Registrando...',
    totalWaste: 'Desperdicio Total',
    wastePercentage: '% Desperdicio',
    ofMaterial: 'del material',
    materialUsed: 'Material Usado',
    wasteType: 'Tipo de Desperdicio',
    wasteTypeRequired: 'Tipo de Desperdicio *',
    weightLbs: 'Peso (lbs)',
    weightLbsRequired: 'Peso (lbs) *',
    disposalMethod: 'Método de Disposición',
    disposalMethodRequired: 'Método de Disposición *',
    reasonNotes: 'Razón / Notas',
    optionalDescription: 'Descripción opcional...',
    wasteRecords: 'Registros de Desperdicio',
    wasteSummary: 'Resumen de Desperdicios',
    noWasteRecorded: 'No se registró desperdicio para esta sesión',
    remainingMaterial: 'Material restante',
    totalRemaining: 'Total Restante',
    recorded: 'Registrado',
    entries: 'entradas',
    deleteWasteConfirm: '¿Está seguro de que desea eliminar este registro de desperdicio?',
    deleteWasteRecord: 'Eliminar registro de desperdicio',
    wasteRecordedSuccess: 'Desperdicio registrado exitosamente',
    wasteRecordedFailed: 'Error al registrar desperdicio',
    wasteDeletedSuccess: 'Registro de desperdicio eliminado',
    wasteDeletedFailed: 'Error al eliminar registro de desperdicio',
    enterValidWeight: 'Por favor ingrese un peso válido',
    finishSession: 'Finalizar Sesión',
    sessionSummary: 'Resumen de Sesión',
    completionReason: 'Razón de Completado',
    recordWasteFirst: 'Por favor registre al menos una entrada de desperdicio antes de finalizar',

    // Waste Types
    trim: 'Recorte',
    damagedProduct: 'Producto Dañado',
    processingLoss: 'Pérdida de Procesamiento',
    wasteTypeByProduct: 'Subproducto',
    wasteTypeDisposable: 'Desechable',
    wasteTypeHumanError: 'Error Humano',
    humanErrorTrackingOnly: 'Solo seguimiento',
    wasteTypeWaterLiquid: 'Agua/Líquido',
    wasteTypeRemainder: 'Sobrante',
    wasteTypeRemainderIntact: 'Sobrante - Intacto',
    wasteTypeRemainderNotIntact: 'Sobrante - Abierto',
    remainderIntactDesc: 'Todavía sellado en cajas originales',
    remainderNotIntactDesc: 'Materiales abiertos/parciales',
    // Waste tracking sections
    actualWaste: 'Desperdicio Real',
    countsAsWaste: 'Cuenta como desperdicio',
    returnsToInventory: 'Regresa al Inventario',
    productionRemainder: 'Remanente de Producción',
    notWaste: 'No es desperdicio',
    createsNewLot: 'Crea nuevo lote',
    addsBackToLot: 'Agrega al lote original',
    selectMaterial: 'Seleccionar material...',
    autoCalculated: 'Calculado automáticamente',
    enterAllWasteWeights: 'Ingrese peso para todos los tipos de desperdicio (requerido, ingrese 0 si no hay)',
    fillAllWasteFields: 'Por favor complete todos los campos de peso de desperdicio',

    // Yield Variance Approval (supervisor verification when variance > 2%)
    yieldVarianceDetected: 'Variación de Rendimiento Detectada',
    yieldVarianceMessage: 'El rendimiento real difiere del esperado en más del 2%. Se requiere aprobación del supervisor.',
    expectedYield: 'Rendimiento Esperado',
    actualYield: 'Rendimiento Real',
    supervisorApproval: 'Aprobación del Supervisor',
    scanSupervisorBadge: 'Escanee la credencial del supervisor para aprobar',
    waitingForBadgeScan: 'Esperando escaneo de credencial...',
    supervisorVerified: 'Supervisor Verificado',
    invalidSupervisorBadge: 'Credencial de supervisor inválida',
    supervisorLogin: 'Inicio de Sesión de Supervisor',
    supervisorUsername: 'Usuario',
    supervisorPassword: 'Contraseña',
    varianceReason: 'Razón de la Variación',
    varianceReasonPlaceholder: 'Explique por qué el rendimiento difiere de lo esperado...',
    approveAndComplete: 'Aprobar y Completar',
    invalidSupervisorCredentials: 'Credenciales de supervisor inválidas',
    notAuthorizedSupervisor: 'El usuario no está autorizado como supervisor',
    reasonRequired: 'La razón es requerida',
    verifyingCredentials: 'Verificando...',
    yieldVariance: 'Variación',

    // Remainder-specific (raw material selection) - deprecated
    unusedRawMaterial: 'Materia Prima Sin Usar',
    selectRawMaterial: 'Seleccionar materia prima',
    selectRawMaterialRequired: 'Por favor seleccione una materia prima para el sobrante',
    allRemaindersRecorded: 'Todas las materias primas ya tienen sobrante registrado',
    noRawMaterialsLinked: 'No hay materias primas vinculadas a esta sesión',

    // Disposal Methods
    compost: 'Composta',
    animalFeed: 'Alimento para Animales',
    landfill: 'Relleno Sanitario',
    incineration: 'Incineración',
    recycling: 'Reciclaje',

    // Session Pool
    availableSessions: 'Sesiones Disponibles',
    selectSessionToWork: 'Seleccione una sesión para comenzar a trabajar',
    availableSessionsCount: 'sesiones disponibles',
    refresh: 'Actualizar',
    loadingAvailableSessions: 'Cargando sesiones disponibles...',
    noAvailableSessions: 'No Hay Sesiones Disponibles',
    noSessionsInPool: 'Actualmente no hay sesiones disponibles en la cola.',
    checkBackLater: 'Vuelva más tarde o contacte a su supervisor.',
    sessionNumber: 'Sesión #',
    available: 'Disponible',
    assignToMe: 'Asignarme',
    inQueue: 'En Cola',
    sessionReady: 'Listo',
    waitingInQueue: 'En Cola',
    waitingForAssignment: 'Esperando asignación',
    assigning: 'Asignando...',
    youHaveActiveSession: 'Tiene una Sesión Activa',
    completeCurrentSession: 'Complete su sesión actual antes de tomar una nueva de la cola.',
    goToProductionEntry: 'Ir a Entrada de Producción',
    confirmAssignment: 'Confirmar Asignación de Sesión',
    confirmAssignmentMessage: '¿Está seguro de que desea asignarse esta sesión?',
    oneSessionOnly: 'Solo puede tener una sesión activa a la vez.',
    authorizedBy: 'Autorizado Por',
    created: 'Creado',
    scheduledDate: 'Fecha Programada',
    weekOf: 'Semana del',
    sessionNotScheduledToday: 'Esta sesion no esta programada para hoy',
    viewDetails: 'Ver',
    hideDetails: 'Ocultar',
    confirm: 'Confirmar',

    // Session History
    sessionHistory: 'Historial de Sesiones',
    viewPastSessions: 'Ver sus sesiones de producción pasadas y rendimiento',
    pastSessions: 'Sesiones Pasadas',
    page: 'Página',
    noSessionHistory: 'No se encontró historial de sesiones',
    outputProduced: 'Producción Generada',
    wasteGenerated: 'Desperdicio Generado',
    started: 'Iniciado',
    completed: 'Completado',

    // Performance Dashboard
    performanceDashboard: 'Panel de Rendimiento',
    welcomeBack: 'Bienvenido de nuevo,',
    loadingPerformanceData: 'Cargando datos de rendimiento...',
    period: 'Período',
    week: 'Semana',
    month: 'Mes',
    sessions: 'Sesiones',
    sessionsCompleted: 'Sesiones completadas',
    output: 'Producción',
    totalWeightProduced: 'Peso total producido',
    averageYield: 'Porcentaje de rendimiento promedio',
    averageYieldPercentage: 'Porcentaje de rendimiento promedio',
    wasteRatio: 'Proporción de desperdicio',
    products: 'Productos',
    differentProducts: 'Productos diferentes',
    personalBest: 'Mejor Personal',
    recentSessions: 'Sesiones Recientes',
    duration: 'Duración',
    noSessionsFound: 'No se encontraron sesiones',

    // Operator Dashboard
    operatorDashboard: 'Panel del Operador',
    currentSession: 'Sesión Actual',
    noActiveSession: 'Sin Sesión Activa',
    noSessionYet: 'Aún no tiene una sesión de producción asignada. Por favor contacte a su supervisor.',
    noAssignedSession: 'No tiene ninguna sesión de producción asignada en este momento.',
    contactSupervisorForSession: 'Por favor contacte a su supervisor para que le asigne una sesión.',
    boxesCompleted: 'Cajas Completadas',
    timeRunning: 'Tiempo en Ejecución',
    recordProduction: 'Registrar Producción',
    sessionsToday: 'Sesiones Hoy',
    notStarted: 'No iniciado',
    loading: 'Cargando...',
    performanceStats: 'Estadísticas de Rendimiento',
    today: 'Hoy',
    thisWeek: 'Esta Semana',
    thisMonth: 'Este Mes',
    sessionsWorked: 'Sesiones Trabajadas',
    avgYield: 'Rendimiento Promedio',
    waste: 'Desperdicio',
    productInfo: 'Información del Producto',
    sku: 'SKU',
    material: 'Material',
    initialWeight: 'Peso Inicial',
    productionProgress: 'Progreso de Producción',
    actual: 'Real',
    pauseSessionDescription: 'Por favor proporcione una razón para pausar la sesión',
    selectReason: 'Seleccione una razón...',
    sessionStartedSuccess: 'Sesión iniciada exitosamente',
    sessionStartedFailed: 'Error al iniciar sesión',
    sessionPausedSuccess: 'Sesión pausada',
    sessionPausedFailed: 'Error al pausar sesión',
    sessionResumedSuccess: 'Sesión reanudada',
    sessionResumedFailed: 'Error al reanudar sesión',

    // Status
    packed: 'Empacado',
    cancelled: 'Cancelado',
    pending: 'Pendiente',
    submitted: 'Enviado',
    received: 'Recibido',
    planned: 'Recibido',

    // Common
    lbs: 'lbs',
    boxes: 'cajas',
    session: 'Sesión',
    noStationAssigned: 'Sin estación asignada',

    // Scale Connection
    scaleConnecting: 'Conectando a la báscula...',
    scaleConnected: 'Báscula conectada',
    scaleDisconnected: 'Báscula desconectada',
    scaleConnectionError: 'Error de conexión de báscula',
    scaleReconnecting: 'Reconectando a la báscula...',
    scaleConnectionLost: 'Conexión perdida. Se alcanzó el máximo de intentos de reconexión.',
    scaleWeightStable: 'El peso es estable',
    scaleWeightUnstable: 'El peso está fluctuando',
    scaleLastUpdate: 'Última actualización',
    scaleTareCommand: 'Tara',
    scaleNotConnected: 'Báscula no conectada',
    autoMode: 'Modo Automático',
    manualMode: 'Modo Manual',
    scaleMode: 'Báscula',
    captureWeight: 'Capturar',
    scaleConnectedWaste: 'Báscula Conectada',
    scaleDisconnectedWaste: 'Báscula Desconectada',
    stable: 'Estable',
    unaccountedMaterial: 'Material Sin Contabilizar',
    allMaterialAccounted: '¡Todo el material ha sido contabilizado!',
    trackRemainingWaste: 'Registre los residuos restantes para finalizar la sesión',
  },

  // Supervisor
  supervisor: {
    supervisor: 'Supervisor',
    dashboard: 'Panel del Supervisor',
    realtimeMonitoring: 'Monitoreo y control de producción en tiempo real',
    activeStations: 'Estaciones Activas',
    totalStations: 'estaciones totales',
    activeSessions: 'Sesiones Activas',
    plannedSessions: 'Sesiones Enviadas',
    completedSessions: 'Sesiones Completadas',
    cancelledSessions: 'Sesiones Canceladas',
    productionInProgress: 'Producción en progreso',
    awaitingStart: 'Esperando inicio',
    todaysProduction: 'Producción de Hoy',
    boxes: 'cajas',
    totalWeight: 'peso total',
    yieldRate: 'Tasa de Rendimiento',
    productionVsTarget: 'Producción vs Objetivo',
    pendingAlerts: 'Alertas Pendientes',
    requiresAttention: 'Requiere atención',
    dismissAlerts: 'Descartar alertas',
    clickToShowAlerts: 'Clic para mostrar alertas',
    supervisorDashboard: 'Panel del Supervisor',
    allLocations: 'Todas las Ubicaciones',
    refresh: 'Actualizar',
    quickActions: 'Acciones Rápidas',
    quickStats: 'Estadísticas Rápidas',
    setWeeklyOperatorSchedule: 'Establecer Horario Semanal de Operadores',
    openStations: 'Abrir Estaciones',
    openStationsDescription: 'Ejecutar auto-promoción en todas las estaciones',
    promotionResults: 'Resultados de Promoción',
    promotedSessions: 'Las siguientes sesiones fueron promovidas a listo:',
    noPromotions: 'No hay sesiones listas para ser promovidas. Todas las estaciones están ocupadas, no tienen sesiones en cola, o las sesiones no tienen operadores/materiales asignados.',
    alert: 'Alerta',
    plural: 's',
    requireAttention: 'Requieren Atención',
    is: 'está',
    hasNoAssignedProduct: 'no tiene producto asignado',
    loadingStationData: 'Cargando datos de estación...',
    noStationsFound: 'No se encontraron estaciones',
    station: 'Estación',
    active: 'activo',
    progress: 'Progreso',
    type: 'Tipo',
    production: 'Producción',
    targetWeight: 'Peso Objetivo',
    assignedProduct: 'Producto Asignado',
    rawMaterial: 'Materia Prima',
    initialWeight: 'Peso Inicial',
    targetOutput: 'Producción Objetivo',
    actualOutput: 'Producción Real',
    startedAt: 'Iniciado',
    yield: 'Rendimiento',
    parentSession: 'Sesión Principal',
    finishedProduct: 'Producto Terminado',
    operator: 'Operador',
    packer: 'Empacador',
    notAssigned: 'No asignado',
    reassignOperator: 'Reasignar Operador',
    isCurrentlyAssignedTo: 'está actualmente asignado a',
    doYouWantToReassignTo: '¿Desea reasignarlo a',
    reassign: 'Reasignar',
    viewDetails: 'Ver Detalles',
    pause: 'Pausar',
    recentActivity: 'Actividad Reciente',
    loadingActivities: 'Cargando actividades...',
    noRecentActivity: 'Sin actividad reciente',
    systemEventsWillAppear: 'Los eventos del sistema aparecerán aquí en tiempo real',
    recentActivityUnderDevelopment: 'La función de Actividad Reciente está en desarrollo',
    checkBackSoon: 'Vuelva pronto para ver actualizaciones de actividad en tiempo real',

    // Gestión de sesiones móvil
    sessions: 'sesiones',
    activeAndPlanned: 'Activas y Enviadas',
    paused: 'Pausadas',
    completed: 'Completadas',
    noSessionsFound: 'No se encontraron sesiones',

    // Camera Monitoring
    cameraMonitoringDashboard: 'Panel de Monitoreo de Cámaras',
    monitorAllCCTV: 'Monitorear todas las transmisiones CCTV de todas las estaciones',
    totalCameras: 'cámaras totales',
    refreshAll: 'Actualizar Todo',
    loadingCameras: 'Cargando cámaras...',
    configureFirstCamera: 'Aún no se han configurado cámaras. Configure cámaras para sus estaciones para comenzar a monitorear.',
    stopViewing: 'Dejar de ver',
    startViewing: 'Comenzar a ver',
    fullscreen: 'Pantalla completa',
    stream: 'transmisión',
    requiresMediaServer: 'Requiere servidor de medios',
    clickEyeToView: 'Clic en ojo para ver',
    closeESC: 'Cerrar (ESC)',

    // Override History
    overrideHistory: 'Historial de Anulaciones',
    overrideHistoryDesc: 'Ver todas las anulaciones y aprobaciones de supervisores',
    overrideTypes: 'Tipos de Anulación',
    filters: 'Filtros',
    dateFrom: 'Fecha Desde',
    dateTo: 'Fecha Hasta',
    overrideType: 'Tipo de Anulación',
    searchSupervisor: 'Buscar supervisor...',
    exportCSV: 'Exportar CSV',
    timestamp: 'Fecha/Hora',
    session: 'Sesión',
    details: 'Detalles',
    reason: 'Razón',
    noOverridesFound: 'No se encontraron anulaciones',
    additionalDetails: 'Detalles Adicionales',
    showingResults: 'Mostrando {{from}}-{{to}} de {{total}}',
    page: 'Página',
    labelReprintDesc: 'Reimpresión de etiqueta de caja',
    manualWeightDesc: 'Entrada de peso manual',
    yieldSignoffDesc: 'Aprobación de variación de rendimiento',
    eodSignoffDesc: 'Aprobación de fin de día',
    sessionCompletionDesc: 'Finalización anticipada de sesión',
    override_session_completion: 'Anulación de Finalización de Sesión',
    override_eod_signoff: 'Anulación de Cierre de Día',

    // Station Management Page
    loadingStations: 'Cargando estaciones...',
    monitorStationsAssignSessions: 'Monitorear estaciones, asignar sesiones y gestionar operadores',
    location: 'Ubicación',
    product: 'Producto',
    itemNumber: 'Número de Artículo',
    target: 'Objetivo',
    started: 'Iniciado',
    noSessionAssigned: 'Sin sesión asignada',
    assignedOperator: 'Operador Asignado',
    noOperatorAssigned: 'Sin operador asignado',
    assignSession: 'Asignar Sesión',
    changeOperator: 'Cambiar Operador',
    assignOperator: 'Asignar Operador',
    startSession: 'Iniciar Sesión',
    pauseSession: 'Pausar Sesión',
    resumeSession: 'Reanudar Sesión',
    completeSession: 'Completar Sesión',
    starting: 'Iniciando...',
    pausing: 'Pausando...',
    resuming: 'Reanudando...',
    completing: 'Completando...',
    assigning: 'Asignando...',
    assignSessionTo: 'Asignar Sesión a',
    warning: 'Advertencia',
    stationAlreadyHasSession: 'Esta estación ya tiene una sesión asignada. Asignar una nueva sesión reemplazará la actual.',
    selectPlannedSession: 'Seleccionar Sesión Enviada',
    onlyPlannedSessionsShown: 'Solo se muestran las sesiones enviadas sin estación. Cada estación solo puede tener una sesión activa a la vez.',
    selectASession: '-- Seleccione una sesión --',
    assignOperatorTo: 'Asignar Operador a',
    selectOperator: 'Seleccionar Operador',
    selectAnOperator: '-- Seleccione un operador --',
    sessionAssignedSuccess: 'Sesión asignada a estación exitosamente',
    failedToAssignSession: 'Error al asignar sesión',
    operatorAssignedSuccess: 'Operador asignado exitosamente',
    failedToAssignOperator: 'Error al asignar operador',
    sessionStartedSuccess: 'Sesión iniciada exitosamente',
    failedToStartSession: 'Error al iniciar sesión',
    sessionPausedSuccess: 'Sesión pausada exitosamente',
    failedToPauseSession: 'Error al pausar sesión',
    sessionResumedSuccess: 'Sesión reanudada exitosamente',
    failedToResumeSession: 'Error al reanudar sesión',
    sessionCompletedSuccess: 'Sesión completada exitosamente',
    failedToCompleteSession: 'Error al completar sesión',
    sessionUnplannedSuccess: 'Sesión eliminada exitosamente',
    failedToUnplanSession: 'Error al eliminar sesión',
    removeSession: 'Quitar Sesión',
    removingSession: 'Quitando...',
    showDisabledStations: 'Mostrar Deshabilitadas',
    hideDisabledStations: 'Ocultar Deshabilitadas',

    // Operator Assignment
    assignOperatorNow: '¿Asignar Operador Ahora?',
    sessionAssignedToStation: 'La sesión ha sido asignada a {station}.',
    operatorRequiredToStart: 'Se debe asignar un operador antes de iniciar la sesión.',
    assignLater: 'Asignar Después',
    noOperator: 'Sin Operador',
    assignOperatorFirst: 'Por favor asigne un operador antes de iniciar la sesión',

    // Queue and Ready Status
    inQueue: 'en cola',
    sessionReady: 'Listo',
    queueCount: '{{count}} en cola',
    waitingForAssignment: 'Esperando asignación',
    waitingInQueue: 'En cola',

    // Material Restriction
    allowedMaterialType: 'Tipo de Material Permitido',
    selectMaterialType: '-- Sin Restricción --',
    materialTypeChicken: 'Pollo Crudo',
    materialTypeBeef: 'Res',
    materialTypePork: 'Cerdo',
    materialTypeGoatLamb: 'Cabra/Cordero',
    restrictedTo: 'Restringido a',
    materialTypeUpdated: 'Restricción de tipo de material actualizada exitosamente',
    cleaningConfirmationRequired: 'Confirmación de Limpieza Requerida',
    materialChangeWarning: 'Cambiar el tipo de materia prima requiere limpieza de la estación para prevenir contaminación cruzada.',
    previousType: 'Tipo Anterior',
    newType: 'Nuevo Tipo',
    confirmCleaning: '¿Se ha limpiado correctamente la estación?',
    cleaningStep1: 'Todo el equipo y superficies desinfectados',
    cleaningStep2: 'Residuos de material anterior removidos',
    cleaningStep3: 'Inspección de estación completada',
    cleaningStep4: 'Listo para nuevo tipo de material',
    confirmCleaningComplete: 'Sí, Limpieza Completa',
    materialTypeMismatch: 'Tipo de material no coincide',
    sessionUses: 'Esta sesión usa',
    cannotDetermineMaterialType: 'No se puede determinar el tipo de material',

    // Production Planning
    productionPlanning: 'Planificación de Producción',
    createManageSessions: 'Crear y gestionar sesiones de producción',
    newProductionSession: 'Nueva Sesión de Producción',
    createProductionSession: 'Crear Sesión de Producción',
    validationErrors: 'Errores de Validación',

    // Multi-Station Mode
    stationAssignment: 'Asignación de Estación',
    singleStation: 'Individual',
    multiStation: 'Multi-Estación',
    multiStationMode: 'Modo Multi-Estación',
    multiStationModeDescription: 'Dividir materiales entre múltiples estaciones. Cada estación trabajará como una sub-sesión independiente.',
    materialAllocationStatus: 'Estado de Asignación de Material',
    fullyAllocated: 'Completamente asignado',
    unallocated: 'sin asignar',
    addStation: 'Agregar Estación',
    materialAllocation: 'Asignación de Material',
    stationSubSessions: 'Sub-Sesiones de Estación',
    stationsCount: 'estaciones',
    addRawMaterialsFirst: 'Agregue materias primas arriba antes de configurar las asignaciones de estación',
    eachStationMustHaveMaterial: 'Cada estación debe tener al menos algo de material asignado',
    allMaterialMustBeAllocated: 'Todo el peso del material debe asignarse a las estaciones. Verifique los totales de asignación.',
    selectStationForAllAllocations: 'Por favor seleccione una estación para todas las asignaciones',
    eachStationCanOnlyBeAssignedOnce: 'Cada estación solo puede asignarse una vez',
    atLeastOneStationRequired: 'Se debe asignar al menos una estación en modo multi-estación',

    // Station Details Modal
    stationId: 'ID de Estación',
    locationInformation: 'Información de Ubicación',
    locationName: 'Nombre de Ubicación',
    locationCode: 'Código de Ubicación',
    warehouseCode: 'Código de Almacén',
    configuration: 'Configuración',
    stationType: 'Tipo de Estación',
    notSet: 'No establecido',
    sessionStatus: 'Estado de Sesión',
    close: 'Cerrar',

    // Camera Management
    cameraManagement: 'Gestión de Cámaras',
    configureCCTVCameras: 'Configurar cámaras CCTV para monitoreo de estaciones',
    addCamera: 'Agregar Cámara',
    camera: 'cámara',
    noCamerasConfigured: 'No Hay Cámaras Configuradas',
    addFirstCamera: 'Agregue su primera cámara para comenzar a monitorear estaciones',
    status: 'Estado',
    position: 'Posición',
    resolution: 'Resolución',
    cameraAddedSuccessfully: 'Cámara agregada exitosamente',
    failedToAddCamera: 'Error al agregar cámara',
    cameraUpdatedSuccessfully: 'Cámara actualizada exitosamente',
    failedToUpdateCamera: 'Error al actualizar cámara',
    cameraDeletedSuccessfully: 'Cámara eliminada exitosamente',
    failedToDeleteCamera: 'Error al eliminar cámara',
    pleaseFillRequiredFields: 'Por favor complete todos los campos requeridos',
    confirmDeleteCamera: '¿Está seguro de que desea eliminar esta cámara?',
    editCamera: 'Editar Cámara',
    addNewCamera: 'Agregar Nueva Cámara',
    selectStation: 'Seleccione una estación',
    cameraName: 'Nombre de Cámara',
    cameraNamePlaceholder: 'ej., Estación 1 - Superior',
    cameraURL: 'URL de Cámara',
    supportsStreamURLs: 'Soporta URLs de transmisión RTSP, HTTP, MJPEG o HLS',
    cameraType: 'Tipo de Cámara',
    positionPlaceholder: 'ej., superior, lado-izquierdo',
    notes: 'Notas',
    notesPlaceholder: 'Notas adicionales sobre esta cámara...',
    updateCamera: 'Actualizar Cámara',

    // Label Management
    labelManagement: 'Gestión de Etiquetas',
    manageAndReprintLabels: 'Gestionar y reimprimir etiquetas para cajas empacadas',
    productionDate: 'Fecha de Producción',
    selectSession: 'Seleccionar Sesión',
    selectSessionPlaceholder: '-- Seleccione una sesión --',
    noSessionsForDate: 'No se encontraron sesiones para esta fecha',
    filterByStatus: 'Filtrar por Estado',
    allBoxes: 'Todas las Cajas',
    readyBoxes: 'Cajas Empacadas',
    shippedBoxes: 'Cajas Enviadas',
    totalBoxes: 'Total de Cajas',
    boxesWithReprints: 'Cajas con Reimpresiones',
    boxNumber: 'Número de Caja',
    weight: 'Peso',
    packedBy: 'Empacado Por',
    labelStatus: 'Estado de Etiqueta',
    lastPrinted: 'Última Impresión',
    noActiveLabel: 'Sin Etiqueta Activa',
    reprinted: 'Reimpreso',
    original: 'Original',
    viewHistory: 'Ver Historial',
    reprintLabel: 'Reimprimir Etiqueta',
    noBoxesFound: 'No se encontraron cajas para la sesión y estado seleccionados.',
    labelPrintHistory: 'Historial de Impresión de Etiquetas',
    printNumber: 'Impresión #',
    printedAt: 'Impreso El',
    printedBy: 'Impreso Por',
    discardedAt: 'Descartado El',
    discardedBy: 'Descartado Por',
    discardReason: 'Razón de Descarte',
    noLabelHistory: 'No se encontró historial de impresión de etiquetas para esta caja.',
    reprintWarning: 'Esto marcará la etiqueta actual como descartada e imprimirá una nueva.',
    reprintReason: 'Razón de Reimpresión',
    selectReprintReason: 'Seleccione una razón...',
    reprintReasonPlaceholder: 'Ingrese la razón para reimprimir la etiqueta...',
    confirmReprint: 'Confirmar Reimpresión',
    pleaseProvideReason: 'Por favor proporcione una razón para reimprimir',
    labelReprintedSuccess: 'Etiqueta reimpresa exitosamente',
    failedToReprintLabel: 'Error al reimprimir etiqueta',

    // Printer Configuration
    labelPrinterConnected: 'Impresora de Etiquetas Conectada',
    noLabelPrinter: 'Sin Impresora de Etiquetas',
    directPrintingEnabled: 'Impresión directa habilitada',
    willUseBrowserDialog: 'Usará el diálogo de impresión del navegador',
    connectPrinter: 'Conectar Impresora',
    detecting: 'Detectando...',
    printDirect: 'Imprimir Directo',

    // Station Management
    stationManagement: 'Gestión de Estaciones',
    manageStations: 'Gestionar estaciones de producción en todas las ubicaciones',
    bulkAssignProducts: 'Asignación Masiva de Productos',
    totalStationsCount: 'Total de Estaciones',
    warehouse: 'Almacén',
    allStatuses: 'Todos los Estados',
    idle: 'Inactivo',
    idleStations: 'Estaciones Inactivas',
    unassignedSessions: 'Sesiones Sin Asignar',
    noStationAssigned: 'Sin Estación Asignada',
    materialOnHold: 'Material En Espera',
    cannotDeactivate: 'No se puede desactivar estación con sesión activa. Producto:',
    pleaseCompleteSession: 'Por favor complete o cancele la sesión primero.',
    deactivate: 'Desactivar',
    activate: 'Activar',

    // Station Enable/Disable
    stationEnabled: 'Estación habilitada',
    stationDisabled: 'Estación deshabilitada',
    failedToToggleStation: 'Error al cambiar estado de estación',
    cannotDisableWithActiveSession: 'No se puede deshabilitar estación con sesión activa',
    clickToEnable: 'Clic para habilitar estación',
    clickToDisable: 'Clic para deshabilitar estación',
    disabled: 'Deshabilitada',
    stationsEnabled: 'estaciones habilitadas',
    assign: 'Asignar',

    // Schedule View
    addNewSchedule: 'Agregar Nueva Sesión de Producción',
    byWeight: 'Por Peso',
    byBoxes: 'Por Cajas',
    sessionCode: 'Código de Sesión',
    scheduleDate: 'Fecha',
    transferDate: 'Fecha de Transferencia',
    dateRangeHint: 'La fecha puede establecerse desde hoy hasta 3 semanas adelante',
    manpowerForDate: 'Personal Programado',
    operators: 'Operadores',
    packers: 'Empacadores',
    stations: 'Estaciones',
    noManpowerScheduled: 'No hay personal programado para esta fecha',
    noManpowerWarning: 'Esperando que el supervisor programe operadores',
    sourceWarehouse: 'Ubicación de Origen',
    sourceWarehouseHint: 'Si se selecciona, se creará automáticamente una transferencia de entrada',
    sourceWarehouseTooltip: 'Se creará automáticamente una transferencia de entrada',
    sourceWarehouseRequiredHint: 'Se creará automáticamente una transferencia de entrada',
    noInboundTransferNeeded: 'No se necesita transferencia de entrada para esta sesión de producción. Hay suficiente materia prima en las instalaciones para cubrirla.',
    transferBackDestination: 'Destino de Transferencia',
    transferBackDestinationHint: 'Una transferencia de salida se creará automáticamente el día programado',
    transferBackDestinations: 'Destinos de Transferencia',
    addDestination: 'Agregar destino',
    selectDestination: 'Seleccionar…',
    duplicateDestination: 'Cada destino solo una vez por sesión.',
    transferBackDestinationsHint: 'Cada uno crea una transferencia de salida',
    transferBackRebalanceAfterReduce: 'Se redujeron los materiales. Reequilibre los destinos de transferencia de regreso.',
    casesUnit: 'cajas',
    scheduleItemNumber: 'Producto Terminado',
    scheduleProductName: 'Nombre del Producto',
    packing: 'Empaque',
    cases: 'Producto Terminado cs',
    targetBoxes: 'Cajas Objetivo',
    targetCases: 'Cajas Objetivo',
    estimatedLbs: 'Lbs Est.',
    material: 'Materia Prima #',
    primaryMaterial: 'Producto Principal',
    selectedMaterials: 'Materiales Seleccionados',
    laborFactor: 'Mano de Obra',
    selectMaterialForLaborFactor: 'Seleccione una materia prima para ver el Factor de Mano de Obra',
    labourEstimatedOutput: 'Producción Estimada',
    labourEstimatedOutputCases: '≈ {{count}} cajas',
    labourMaxForDay: 'Máx. del día',
    labourWithAllowance: 'Con margen (−{{pct}}%)',
    labourMaxApplyHint: 'Haga clic para establecer Cajas Objetivo',
    labourRemainder: 'Remanente',
    labourWorkers: 'Trabajadores',
    labourSessions: 'Sesiones',
    labourDuration: 'Duración (h)',
    labourBasedOnInput: 'Basado en {{weight}} lbs de entrada',
    labourNoFactor: 'Sin Factor de Mano de Obra',
    labourYieldOnlyEstimate: 'solo rendimiento',
    meanProduction: 'Prod Prom #',
    scheduleBrand: 'Marca',
    multipleBrands: 'Múltiple',
    scheduleLocation: 'Ubicación',
    noScheduledSessions: 'No hay sesiones programadas para esta fecha',

    // Formulario multi-material
    lbsInput: 'Peso (lbs)',
    unitWeight: 'Peso Unitario',
    estOutput: 'Prod. Est. lbs',
    estInput: 'Entrada Est. lbs',
    estUsableMaterial: 'Est. Usable (lbs)',
    estimatedBoxes: 'Cajas Est.',
    byproducts: 'Producto Secundario / Subproducto',
    estCases: 'Materia Prima cs',
    caseWeight: 'Peso por Caja',
    requiredWeight: 'Peso Req. (lbs)',
    addMaterial: 'Agregar Material',
    exceedsStock: 'Excede stock disponible',
    partialTransferNeeded: 'Transferencia requerida',
    yieldNotConfigured: 'Sin Rendimiento',
    totalLbs: 'Peso Total',
    totalCases: 'Total de Cajas',
    totalInputWeight: 'Peso Total de Entrada',
    totalOutputWeight: 'Peso Total de Salida',
    totalEstUsable: 'Est. Usable',
    availableStock: 'Disponible HTE',
    icsBalance: 'Inventario',
    frozen: 'Congelado',
    fresh: 'Fresco',
    availableAtHte: 'en HTE',
    insufficientSourceStock: 'Stock insuficiente en',
    onlyHas: 'solo tiene',
    needed: 'necesario',
    belowSafeStockAt: 'Por debajo de la cantidad segura en',
    csUsable: 'utilizables',
    csSafetyStock: 'stock de seguridad',
    outOfStockTitle: 'Sin Existencias',
    belowSafeQtyTitle: 'Por Debajo de la Cantidad Segura',
    outOfStockBodyPrefix: 'Los siguientes artículos están sin existencias en',
    outOfStockBodySuffix: 'según el servicio de inventario. Los datos de stock pueden ser inexactos — puede anular y continuar si ha verificado la disponibilidad en persona.',
    safeQtyIntroPrefix: 'Tomar la cantidad completa dejaría',
    safeQtyIntroSuffix: 'por debajo de su cantidad segura. La solicitud se reducirá:',
    csOnHand: 'en existencia',
    casesAvailable: 'CS disponibles',
    override: 'Anular',
    overrideAndProceed: 'Anular y Continuar',
    onHold: 'en espera',
    materialsOnHold: 'Materiales aprobados (en espera)',
    materialsInHTE: 'Materiales disponibles (en HTE)',
    totalAvailable: 'Total disponible',
    totalAvailableAtHte: 'Total Disponible en HTE:',
    includingOnHold: 'Incluyendo en espera',
    onHoldApprovedBadge: 'Aprobado',
    selectProductError: 'Por favor seleccione un producto',
    pastDateError: 'La fecha programada no puede ser en el pasado',
    weekendWarningProduction: 'La Fecha de Producción seleccionada es un {{day}}',
    weekendWarningTransfer: 'La Fecha de Transferencia seleccionada es un {{day}}',
    selectMaterialError: 'Por favor agregue al menos una materia prima con peso',
    exceedsStockError: 'Uno o más materiales exceden el stock disponible',

    // Vinculación de materia prima en línea
    otherProducts: 'Otros Productos (sin materiales vinculados)',
    noMaterials: 'NUEVO',
    noMaterialsLinked: 'No hay materias primas vinculadas a este producto',
    addMaterialsPrompt: 'Busque y agregue materias primas para continuar creando una sesión.',
    searchRawMaterials: 'Buscar materias primas por nombre o código...',
    materialLinked: 'Vinculado',
    materialLinkError: 'Error al vincular material',
    materialLinkSuccess: 'Material vinculado exitosamente',
    materialUnlinked: 'Material removido',
    setPreference: 'Establecer preferencia para',

    // Opciones de ordenamiento de materiales
    sortPreference: 'Preferencia',
    sortYieldHigh: 'Rendimiento ↓',
    sortYieldLow: 'Rendimiento ↑',
    sortLaborHigh: 'Mano de obra ↓',
    sortLaborLow: 'Mano de obra ↑',
    sortAvailabilityHigh: 'Stock ↓',
    sortAvailabilityLow: 'Stock ↑',

    // Exportar
    exportToExcel: 'Exportar a Excel',
    exportSessions: 'Exportar Sesiones',
    selectDateRange: 'Seleccionar Rango de Fechas',
    startDate: 'Fecha de Inicio',
    endDate: 'Fecha de Fin',
    sessionsToExport: 'Sesiones a exportar',
    noSessionsInRange: 'No hay sesiones en este rango de fechas',
    exporting: 'Exportando...',

    // Editar/Eliminar sesión
    editSession: 'Editar Sesión',
    editProductionSession: 'Editar Sesión de Producción',
    sessionUpdatedSuccess: 'Sesión actualizada exitosamente',
    failedToUpdateSession: 'Error al actualizar sesión',
    confirmCancelSession: '¿Cancelar Sesión?',
    cancelSessionWarning: 'Esta acción no se puede deshacer. La sesión será marcada como cancelada.',
    forceCancelActiveSession: '¿Forzar Cancelación de Sesión Activa?',
    forceCancelWarning: 'Esta sesión está actualmente en progreso. Cancelar liberará la estación y desasignará al operador. Todo el progreso no guardado se perderá.',
    sessionCancelledSuccess: 'Sesión cancelada exitosamente',
    failedToCancelSession: 'Error al cancelar sesión',

    // Alerta de Sesiones Incompletas
    incompleteSessionsAlert: 'Sesiones Incompletas de Días Anteriores',
    incompleteSessionsCount: 'sesión(es) incompleta(s) de días anteriores requieren atención',
    incompleteSessionsDescription: 'Las siguientes sesiones no fueron completadas y pueden necesitar resolución:',
    scheduledFor: 'Programado para',
    viewInPlanning: 'Ver en Planificación de Producción',
    dismissIncompleteAlert: 'Descartar',

    // Alerta de Aprobaciones Pendientes
    pendingApprovalsAlert: 'Aprobaciones Pendientes',

    // Etiquetas de sub-tarjetas del panel
    todaysSessions: 'Sesiones de Hoy',
    planned: 'Enviadas',
    activeLabel: 'Activas',
    completedLabel: 'Completadas',
    avgYield: 'Rend. Promedio',
    enabledLabel: 'Habilitadas',
    stationOverview: 'Resumen de Estaciones',

    // Progreso de Producción
    productionProgressOverview: 'Progreso de Producción',
    overall: 'General',
    noSessionsToday: 'No hay sesiones de producción programadas para hoy',
    lbs: 'lbs',
  },

  // Vista Móvil de Supervisor
  mobileSupervisor: {
    title: 'Supervisor',
    subtitle: 'Panel Móvil',
    stationOverview: 'Vista de Estaciones',
    stationOverviewDesc: 'Ver estado de todas las estaciones',
    sessionManagement: 'Sesiones',
    sessionManagementDesc: 'Gestionar sesiones de producción',
    productionPlanning: 'Nueva Sesión',
    productionPlanningDesc: 'Crear sesión de producción',
    transferVerification: 'Recepción',
    transferVerificationDesc: 'Verificar transferencias de cajas',
    receiveVerify: 'Transferencias',
    receiveVerifyDesc: 'Recibir transferencias entrantes',
    transfers: 'Transferencias',
    transfersDesc: 'Recibir y ver transferencias',
    receive: 'Recibir',
    receiveDesc: 'Recibir transferencias entrantes',
    transferOption: 'Enviar',
    transferOptionDesc: 'Transferir de vuelta al almacén',
    allTransfers: 'Todas las Transferencias',
    allTransfersDesc: 'Ver todas las transferencias',
    inventoryDesc: 'Ver materiales e inventario',
    // Modal de opciones de escaneo
    scanOptions: '¿Qué desea escanear?',
    labelLookup: 'Buscar Etiqueta',
    labelLookupDesc: 'Escanee una etiqueta de caja para ver detalles',
    scanStation: 'Escanear Estación',
    scanStationDesc: 'Escanee QR de estación para ver estado',
    endOfDaySummary: 'Resumen Diario',
    endOfDaySummaryDesc: 'Estadísticas de producción',
    overrideHistory: 'Historial de Anulaciones',
    overrideHistoryDesc: 'Ver anulaciones pasadas',
    // Tipos de anulación
    manualWeight: 'Peso Manual',
    labelReprint: 'Reimpresión de Etiqueta',
    sessionCompletion: 'Completar Sesión',
    stationManagement: 'Config. Estaciones',
    stationManagementDesc: 'Habilitar/deshabilitar estaciones',
    scanBoxBarcode: 'Escanear Código de Caja',
    scanBoxHint: 'Apunte el escáner al código de barras GS1 en la caja',
    boxFound: 'Caja encontrada',
    boxNotFound: 'Caja no encontrada',
    reprintLabel: 'Reimprimir Etiqueta',
    reprintingLabel: 'Reimprimiendo etiqueta...',
    labelReprinted: 'Etiqueta enviada a la impresora',
    scanAnother: 'Escanear Otra',
    scanToVerify: 'Escanear Caja para Verificar',
    scanTransferBoxHint: 'Escanee el código de caja para verificar transferencia',
    pendingTransfers: 'pendientes',
    verifiedThisSession: 'verificadas',
    transferVerified: 'Transferencia verificada',
    transferRejected: 'Transferencia rechazada',
    boxesVerified: 'cajas verificadas esta sesión',
    verify: 'Verificar',
    reject: 'Rechazar',
    from: 'Desde',
    to: 'Hasta',
    stationEnabled: 'Estación habilitada',
    stationDisabled: 'Estación deshabilitada',
    cannotDisableActiveStation: 'No se puede deshabilitar mientras hay sesión activa',
    selectProduct: 'Seleccionar Producto',
    selectStation: 'Seleccionar Estación',
    selectMaterial: 'Seleccionar Material',
    confirmSession: 'Confirmar Sesión',
    noAvailableStations: 'No hay estaciones disponibles',
    createSession: 'Crear Sesión',
    sessionCreated: 'Sesión creada',
  },

  // Monitor de Producción
  productionMonitor: {
    title: 'Monitor de Producción',
    scheduleView: 'Vista de Programación',
    sessionManagement: 'Gestión de Sesiones',
    activeSessions: 'Sesiones Activas',
    operatorsWorking: 'Operadores Trabajando',
    todaysOutput: 'Producción de Hoy',
    sessionsAtRisk: 'Sesiones en Riesgo',
    activeSessionsTable: 'Sesiones Activas',
    autoRefreshNote: 'Se actualiza automáticamente cada 30 segundos',
    noActiveSessions: 'No hay sesiones activas en este momento',
    session: 'Sesión',
    product: 'Producto',
    operator: 'Operador',
    station: 'Estación',
    elapsed: 'Transcurrido',
    progress: 'Progreso',
    output: 'Producción',
    pace: 'Ritmo',
    status: 'Estado',
    estCompletion: 'Est. Finalización',
    projOutput: 'Prod. Proyectada',
    projRemaining: 'Restante Proyectado',
    actualOutput: 'Producción Real',
    remaining: 'Restante',
    onTrack: 'En Tiempo',
    atRisk: 'En Riesgo',
    behind: 'Atrasado',
    subSessions: 'sub-sesiones',
    multiple: 'Múltiples',
    columns: 'Columnas',
    completedSessions: 'Sesiones Completadas',
    cancelledSessions: 'Sesiones Canceladas',
    reason: 'Razón',
  },

  // Admin Pages
  admin: {
    // Users Page
    users: 'Usuarios',
    manageUserAccounts: 'Gestionar cuentas de usuario y permisos',
    addUser: 'Agregar Usuario',
    searchUsers: 'Buscar usuarios...',
    allRoles: 'Todos los Roles',
    admin: 'Administrador',
    supervisor: 'Supervisor',
    manager: 'Gerente',
    operator: 'Operador',
    warehouse: 'Almacén',
    route: 'Ruta',
    user: 'Usuario',
    role: 'Rol',
    lastLogin: 'Último Acceso',
    active: 'Activo',
    inactive: 'Inactivo',
    editUser: 'Editar Usuario',
    deactivateUser: 'Desactivar Usuario',
    activateUser: 'Activar Usuario',
    deleteUser: 'Eliminar Usuario',
    noUsersFound: 'No se encontraron usuarios',
    tryAdjustingSearch: 'Intente ajustar sus criterios de búsqueda.',
    getStartedCreatingUser: 'Comience creando un nuevo usuario.',
    totalUsers: 'Total de Usuarios',
    activeUsers: 'Usuarios Activos',
    admins: 'Administradores',
    confirmDeleteUser: '¿Está seguro de que desea eliminar a',
    actionCannotBeUndone: 'Esta acción no se puede deshacer.',
    userDeletedSuccess: 'Usuario eliminado exitosamente',
    failedToDeleteUser: 'Error al eliminar usuario',
    userStatusUpdated: 'Estado de usuario actualizado exitosamente',
    failedToUpdateUserStatus: 'Error al actualizar estado de usuario',
    failedToLoadUsers: 'Error al cargar usuarios',
    pleaseRefresh: 'Por favor actualice e intente de nuevo.',

    // Settings Page
    systemSettings: 'Configuración del Sistema',
    configureSystemPreferences: 'Configurar preferencias y opciones del sistema',
    reset: 'Restablecer',
    saveChanges: 'Guardar Cambios',
    saving: 'Guardando...',
    general: 'General',
    notifications: 'Notificaciones',
    security: 'Seguridad',
    production: 'Producción',
    system: 'Sistema',
    generalSettings: 'Configuración General',
    companyName: 'Nombre de la Empresa',
    timezone: 'Zona Horaria',
    dateFormat: 'Formato de Fecha',
    currency: 'Moneda',
    language: 'Idioma',
    notificationPreferences: 'Preferencias de Notificación',
    emailNotifications: 'Notificaciones por Correo',
    emailNotificationsDesc: 'Recibir actualizaciones importantes por correo',
    lowStockAlerts: 'Alertas de Stock Bajo',
    lowStockAlertsDesc: 'Notificación cuando el inventario esté bajo',
    stationOfflineAlerts: 'Alertas de Estación Fuera de Línea',
    stationOfflineAlertsDesc: 'Alerta cuando las estaciones de producción estén fuera de línea',
    productionAlerts: 'Alertas de Producción',
    productionAlertsDesc: 'Notificaciones para hitos de producción',
    dailyReports: 'Reportes Diarios',
    dailyReportsDesc: 'Recibir reportes de producción diarios automatizados',
    securitySettings: 'Configuración de Seguridad',
    sessionTimeout: 'Tiempo de Espera de Sesión (minutos)',
    sessionTimeoutDesc: 'Los usuarios serán desconectados después de este período de inactividad',
    passwordMinLength: 'Longitud Mínima de Contraseña',
    maxLoginAttempts: 'Máximo de Intentos de Inicio de Sesión',
    maxLoginAttemptsDesc: 'La cuenta será bloqueada después de estos intentos fallidos',
    requireStrongPassword: 'Requerir Contraseñas Seguras',
    requireStrongPasswordDesc: 'Exigir mayúsculas, minúsculas, números y caracteres especiales',
    enableTwoFactor: 'Habilitar Autenticación de Dos Factores',
    enableTwoFactorDesc: 'Requerir verificación adicional para todos los usuarios',
    labelPrinting: 'Impresión de Etiquetas',
    productionSettings: 'Configuración de Producción',
    defaultTargetWeight: 'Peso Objetivo Predeterminado (kg)',
    autoAssignOperators: 'Auto-Asignar Operadores',
    autoAssignOperatorsDesc: 'Asignar automáticamente operadores disponibles a estaciones',
    allowManualWeightEntry: 'Permitir Entrada Manual de Peso',
    allowManualWeightEntryDesc: 'Permitir a los operadores ingresar pesos manualmente',
    simulatePrinter: 'Simular Impresora',
    simulatePrinterDesc: 'Cuando está activado, la impresión se omite — no se envían etiquetas a la impresora física',
    simulatePrinterPrintSkipped: 'Modo simulación: Impresión omitida — vista previa de etiqueta mostrada',
    labelCopies: 'Copias de Etiqueta',
    labelCopiesDesc: 'Número de copias de etiqueta a imprimir por caja',
    printerSubnet: 'Subred de Red de Impresoras',
    printerSubnetDesc: 'Primeros 3 octetos de su red (ej. 192.168.1)',
    printServiceUrl: 'URL del Servicio de Impresión',
    printServiceUrlDesc: 'URL HTTPS del servicio de impresión de fábrica (ej. https://192.168.1.100:3010). Dejar vacío para desarrollo local.',
    registeredPrinters: 'Impresoras Registradas',
    registeredPrintersDesc: 'Registre impresoras y asígnelas a estaciones. Los cambios se reflejan en Gestión de Estaciones.',
    addPrinter: 'Agregar Impresora',
    printerName: 'Nombre de Impresora',
    printerNamePlaceholder: 'ej. printer_1',
    printerMacValue: 'Dirección MAC',
    noPrintersRegistered: 'No hay impresoras registradas aún',
    printerAdded: 'Impresora registrada exitosamente',
    printerDeleted: 'Impresora removida',
    printerStaticIp: 'IP estática (opcional)',
    printerStaticIpPlaceholder: 'ej. 172.168.36.179',
    printerIpSaved: 'IP de impresora guardada',
    printerIpCleared: 'IP de impresora eliminada',
    invalidIpAddress: 'Formato de dirección IP no válido',
    confirmDeletePrinter: '¿Remover esta impresora?',
    assignStationToPrinter: 'Asignar estación...',
    noStationsAvailable: 'No hay estaciones disponibles',
    assignedElsewhere: 'asignada a otra impresora',
    supervisorOffice: 'Oficina del Supervisor',
    noStationAssigned: 'Sin estación asignada',
    printerNickname: 'Nombre',
    printerIpAddress: 'Dirección IP',
    printerPort: 'Puerto',
    printerStation: 'Estación',
    selectStation: 'Seleccionar estación...',
    selectPrinter: 'Seleccionar impresora...',
    showMac: 'Mostrar MAC',
    hideMac: 'Ocultar MAC',
    noIpSet: 'Sin IP configurada',
    printerTestPanel: 'Prueba de Impresión',
    printerTestPanelDesc: 'Enviar una etiqueta de prueba para verificar la conectividad de la impresora.',
    printTestLabel: 'Imprimir Etiqueta de Prueba',
    // Batch Label Print
    batchLabelPrint: 'Impresión de Etiquetas en Lote',
    batchLabelPrintDesc: 'Pre-imprimir etiquetas en lote para un producto terminado sin iniciar una sesión de producción.',
    batchProduct: 'Producto',
    batchSelectProduct: 'Seleccionar un producto...',
    batchNumberOfBoxes: 'Número de Cajas',
    batchDateTime: 'Fecha y Hora',
    batchPrinter: 'Impresora',
    batchTotalLabels: 'Total de etiquetas',
    batchBoxes: 'cajas',
    batchCopies: 'copias',
    batchPrintButton: 'Imprimir Etiquetas',
    batchPrinting: 'Imprimiendo...',
    batchPrintingBox: 'Imprimiendo caja',
    batchPrintSuccess: 'Impresión en lote completada exitosamente',
    batchPrintSimulated: 'Impresión en lote simulada exitosamente',
    batchPrintFailed: 'Error en la impresión en lote',
    batchPrintLabels: 'etiquetas',
    printerNotConfigured: 'No hay impresora asignada a esta estación. Asigne una en Configuración → Impresión de etiquetas.',
    stationServiceDown: 'No se puede conectar al servicio de estación para buscar la impresora. Intente de nuevo.',
    arpLookupFailed: 'No se encontró la impresora en la red. Asegúrese de que esté encendida y conectada.',

    advancedSettings: 'Avanzado',

    // Scale Management (Settings → Scales tab)
    scales: 'Balanzas',
    registeredScales: 'Balanzas Registradas',
    registeredScalesDesc: 'Registrar balanzas de red y asignarlas a estaciones. Una balanza por estación.',
    addScale: 'Agregar Balanza',
    scaleNickname: 'Nombre',
    scaleNicknamePlaceholder: 'ej. Balanza Principal',
    scaleIpAddress: 'Dirección IP',
    scaleIpPlaceholder: '172.168.110.227',
    scalePort: 'Puerto',
    scalePortPlaceholder: '1701',
    scaleStation: 'Estación',
    noScalesRegistered: 'No hay balanzas registradas',
    scaleAdded: 'Balanza registrada exitosamente',
    scaleDeleted: 'Balanza eliminada',
    confirmDeleteScale: '¿Eliminar esta balanza?',
    scaleTestConnection: 'Probar Conexión',
    scaleTestSuccess: 'Conexión exitosa',
    scaleTestFailed: 'Conexión fallida',
    scaleTestPanel: 'Prueba de Balanza',
    scaleTestPanelDesc: 'Probar conectividad de la balanza y ver lecturas de peso en vivo.',
    selectScale: 'Seleccionar balanza...',
    scaleDeviceInfo: 'Info del Dispositivo',
    scaleLiveWeight: 'Peso en Vivo',
    scaleRawLog: 'Registro sin Procesar',
    scaleNoMessages: 'Sin mensajes aún',
    scaleTesting: 'Probando...',
    scaleReadMode: 'Modo de Lectura',
    scaleModeContinuous: 'Continuo',
    scaleModeOnPrint: 'Al Imprimir',
    scaleModeContinuousDesc: 'Lee el peso cada 500ms',
    scaleModeOnPrintDesc: 'Lee solo cuando se presiona el botón Imprimir en la balanza',
    scaleReconnect: 'Reconectar',
    scaleReconnectStarted: 'Reconexión iniciada',
    scaleStableWeight: 'Peso Estable (S)',

    requireQualityCheck: 'Requerir Control de Calidad',
    requireQualityCheckDesc: 'Exigir verificación de calidad antes de completar',
    dataRetentionDays: 'Retención de Datos (días)',
    dataRetentionDaysDesc: 'Tiempo para mantener datos históricos antes de archivar',
    backupFrequency: 'Frecuencia de Respaldo',
    daily: 'Diario',
    weekly: 'Semanal',
    monthly: 'Mensual',
    maintenanceMode: 'Modo de Mantenimiento',
    maintenanceModeDesc: 'Deshabilitar acceso al sistema para mantenimiento',
    debugMode: 'Modo de Depuración',
    debugModeDesc: 'Habilitar registro detallado para solución de problemas',
    automaticBackups: 'Respaldos Automáticos',
    automaticBackupsDesc: 'Habilitar respaldos automáticos de base de datos',
    warning: 'Advertencia',
    settingsWarning: 'Cambiar la configuración del sistema puede afectar a todos los usuarios. Asegúrese de comprender las implicaciones antes de guardar.',
    unsavedChanges: 'Tiene cambios sin guardar',
    settingsSavedSuccess: 'Configuración guardada exitosamente',
    failedToSaveSettings: 'Error al guardar configuración',

    // Locations Page
    locationsAndWarehouses: 'Ubicaciones y Almacenes',
    manageProductionLocations: 'Gestionar ubicaciones de producción y almacenes conectados',
    searchLocations: 'Buscar ubicaciones, direcciones o almacenes...',
    allStatus: 'Todos los Estados',
    capacity: 'Capacidad',
    noLocationsFound: 'No se encontraron ubicaciones',
    getStartedCreatingLocation: 'Comience creando una nueva ubicación.',
    totalLocations: 'Total de Ubicaciones',
    activeLocations: 'Ubicaciones Activas',
    totalCapacity: 'Capacidad Total',
    highCapacity: 'Alta Capacidad',
    confirmDeleteLocation: '¿Está seguro de que desea eliminar la ubicación',
    locationCreatedSuccess: 'Ubicación creada exitosamente',
    failedToCreateLocation: 'Error al crear ubicación',
    locationUpdatedSuccess: 'Ubicación actualizada exitosamente',
    failedToUpdateLocation: 'Error al actualizar ubicación',
    locationDeletedSuccess: 'Ubicación eliminada exitosamente',
    failedToDeleteLocation: 'Error al eliminar ubicación',
    locationStatusUpdated: 'Estado de ubicación actualizado',
    failedToUpdateStatus: 'Error al actualizar estado',

    // Feature Flags
    featureFlags: 'Funciones',
    featureFlagsDesc: 'Habilitar o deshabilitar funciones globalmente para todos los usuarios.',
    materialTypeRestriction: 'Restricción de Tipo de Material',
    materialTypeRestrictionDesc: 'Restringir estaciones a tipos de material específicos (Pollo, Res, Cerdo, Cabra/Cordero)',
    scannerIntegration: 'Integración de Escáner',
    scannerIntegrationDesc: 'Habilitar funciones de escáner de código de barras para verificación por escaneo',
    saveAndReload: 'Guardar y Recargar',
    featureFlagsNote: 'Las funciones se almacenan en su navegador. Los cambios recargarán la página para aplicarse.',
    featureFlagsNoteGlobal: 'Las funciones se almacenan globalmente en la base de datos y aplican a todos los usuarios. Los cambios surten efecto inmediatamente.',
    featureFlagsSaved: 'Funciones guardadas exitosamente',
    databaseToggles: 'Configuraciones de Base de Datos',
    databaseTogglesDesc: 'Estas configuraciones se almacenan en la base de datos y surten efecto inmediatamente para todos los usuarios.',
    enableInputOutputEditing: 'Edición de Mapeo Entrada/Salida',
    enableInputOutputEditingDesc: 'Permitir a supervisores agregar nuevas vinculaciones de materia prima en la pestaña de Mapeo Entrada/Salida',
    requirePostPrintScan: 'Escaneo de Credencial y Etiqueta Post-Impresión',
    requirePostPrintScanDesc: 'Requiere escaneo doble de credencial del empacador y etiqueta de caja después de imprimir antes de registrar la producción',

    // Pestaña Producción (Gerente/Admin)
    productionTab: 'Producción',
    yieldVarianceThresholds: 'Umbrales de Variación de Rendimiento',
    yieldVarianceThresholdsDesc: 'Configure los umbrales de variación utilizados en el sistema para el monitoreo de rendimiento.',
    yieldThresholdLabel: 'Umbral de Variación de Rendimiento',
    yieldThresholdDesc: 'La variación de rendimiento por encima de este valor activa advertencias, requiere aprobación del supervisor y marca sub-sesiones en los reportes.',
    yieldThresholdsSaved: 'Umbrales de rendimiento guardados exitosamente',
    yieldThresholdsSaveFailed: 'Error al guardar los umbrales de rendimiento',

    // Configuración de Modo de Peso y Tolerancia
    defaultWeightMode: 'Modo de Peso Predeterminado',
    defaultWeightModeDesc: 'Modo de peso predeterminado global para la vista del empacador cuando no hay un ajuste a nivel de sesión.',
    weightModeFixed: 'Fijo',
    weightModeCatch: 'Variable',
    weightModeScale: 'Báscula',
    weightTolerance: 'Tolerancia de Peso',
    weightToleranceDesc: 'Peso máximo (en lbs) por encima del peso unitario objetivo aceptado para una caja.',
    weightSettingsSaved: 'Configuración de peso guardada exitosamente',
    weightSettingsSaveFailed: 'Error al guardar la configuración de peso',
    autoTareTitle: 'Auto-Tara (Modo Báscula)',
    autoTareDesc: 'Restar automáticamente el peso del empaque de las lecturas de la báscula. Solo aplica cuando el modo de peso es Báscula.',
    bagTare: 'Tara de Bolsa',
    bagTareDesc: 'Peso del empaque de bolsa a restar durante el empaque de sub-unidades.',
    caseTare: 'Tara de Caja',
    caseTareDesc: 'Peso del empaque de caja a restar durante el empaque final de la caja.',
    tareGross: 'Bruto',
    tareTare: 'Tara',
    tareNet: 'Neto',

    // Pestaña HTE Stock (Gerente)
    hteStock: {
      title: 'HTE Stock',
      lotsTitle: 'Stock de Lotes',
      itemNumber: 'Número de Artículo',
      itemName: 'Nombre del Artículo',
      currentAmount: 'Cantidad Actual (lbs)',
      receivedDate: 'Recibido',
      bufferTitle: 'Buffer de Subproductos Comercializables',
      byproduct: 'Subproducto',
      reservedWeight: 'Peso Reservado (lbs)',
      confirmPassword: 'Confirmar Cambio',
      password: 'Contraseña',
      reason: 'Razón',
      reasonPlaceholder: '¿Por qué se necesita este cambio?',
      updateConfirmMsg: 'Ingrese una razón y su contraseña para confirmar esta actualización.',
      deleteConfirmMsg: 'Ingrese una razón y su contraseña para confirmar esta eliminación.',
      lotUpdated: 'Cantidad del lote actualizada',
      bufferUpdated: 'Peso del buffer actualizado',
      bufferDeleted: 'Fila del buffer eliminada',
      updateFailed: 'Error al actualizar',
      deleteFailed: 'Error al eliminar',
      invalidCredentials: 'Credenciales inválidas',
      invalidValue: 'El valor debe ser un número >= 0',
    },
    packingMaterials: {
      title: 'Materiales de Empaque',
      autoTransferSettings: 'Configuración de Transferencia Automática',
      autoTransferMode: 'Modo de Transferencia Automática',
      modeDraft: 'Borrador (Gerente revisa)',
      modeAutoSubmit: 'Envío Automático',
      modeDraftDesc: 'Cuando los materiales están bajos, se crea un borrador de transferencia. Debe revisarlo y enviarlo manualmente.',
      modeAutoSubmitDesc: 'Cuando los materiales están bajos, se crea y envía una transferencia automáticamente. Recibirá una notificación.',
      sourceLocation: 'Almacén de Origen',
      sourceLocationDesc: 'Ubicación del almacén desde donde se ordenan los materiales de empaque.',
      autoTransferWhen: 'Cuándo',
      whenSameDay: 'Mismo Día',
      whenNextBusinessDay: 'Siguiente Día Hábil',
      whenNextMonday: 'Próximo Lunes',
      thresholds: 'Umbrales de Materiales',
      noMaterials: 'No se encontraron materiales de empaque en el inventario. Agregue materiales de empaque a través de la pestaña de Mapeo de Productos.',
      itemNumber: 'N° Artículo',
      itemName: 'Nombre del Artículo',
      currentStock: 'Stock Actual',
      safeQuantity: 'Cantidad Segura',
      reorderQuantity: 'Cantidad de Reorden',
      unitsAbbrev: 'u',
      thresholdSaved: 'Umbral guardado',
      thresholdSaveFailed: 'Error al guardar el umbral',
      thresholdDeleted: 'Umbral eliminado',
      noThresholds: 'No hay umbrales de material configurados',
      addThresholdHint: 'Haga clic en (+) para agregar un umbral de material de empaque',
      addMaterial: 'Agregar Material de Empaque',
      typeToSearch: 'Escriba para buscar materiales...',
      settingSaved: 'Configuración guardada',
      packingUnit: 'Empaque',
      pcs: 'pzas',
      draftTransferAlert: 'Reabastecimiento de material de empaque — revisar y enviar',
      autoTransferCreatedTitle: 'Transferencia de material de empaque creada automáticamente',
      autoTransferCreatedBody: 'El stock alcanzó su nivel seguro. Revise y envíe el borrador de transferencia.',
      viewTransfer: 'Ver transferencia',
      pendingTransferAlert: 'Reabastecimiento de material de empaque enviado',
      cancelTransferTitle: 'Cancelar Transferencia',
      confirmCancelTransfer: '¿Cancelar esta transferencia borrador? Esta acción no se puede deshacer.',
      confirmCancel: 'Sí, Cancelar',
      transferCancelled: 'Transferencia cancelada',
    },
  },

  // Confirmación de Caja (doble escaneo)
  boxConfirm: {
    scanBadgePrompt: 'Escanee su credencial para confirmar',
    scanLabelPrompt: 'Ahora escanee la etiqueta de la caja',
    confirmed: 'Caja confirmada',
    badgeMismatch: 'La credencial no coincide con el empacador asignado',
    labelNotFound: 'Etiqueta de caja no encontrada',
    step1: 'Paso 1: Escanee Su Credencial',
    step2: 'Paso 2: Escanee la Etiqueta',
    waitingForBadge: 'Esperando escaneo de credencial...',
    waitingForLabel: 'Esperando escaneo de etiqueta...',
    verifying: 'Verificando...',
    success: '¡Caja Confirmada!',
    badgeScanned: 'Credencial escaneada',
    scanBadgeFirst: 'Por favor escanee su credencial primero',
    alreadyScannedBadge: 'Credencial ya escaneada. Por favor escanee la etiqueta de la caja.',
    skipScan: 'Omitir Escaneo',
    manualConfirmHint: 'Usar si el escáner no funciona',
    helpText: 'Escanee su credencial, luego escanee la etiqueta impresa en la caja para confirmar',
  },

  // Material
  material: {
    initialWeight: 'Peso Inicial',
    rawMaterial: 'Materia Prima',
    brand: 'Marca',
    yieldFactor: 'Rendimiento',
  },

  // Fichar Entrada
  clockIn: {
    title: 'Fichar Entrada',
    scanStation: 'Escanear Código de Estación',
    scanStationHint: 'Apunte el escáner al código de la estación',
    scanBadge: 'Escanear Su Credencial',
    scanBadgeHint: 'Apunte el escáner a su credencial de empleado',
    selectRole: 'Seleccione Su Rol',
    operator: 'Operador',
    packer: 'Empacador',
    welcome: 'Bienvenido',
    currentAssignments: 'Asignaciones Actuales',
    noActiveSession: 'No hay sesión activa en esta estación',
    employeeNotFound: 'Empleado no encontrado',
    employeeDeactivated: 'El empleado está desactivado',
    stationNotFound: 'Estación no encontrada',
    alreadyAssigned: 'Ya está asignado como {role}',
    relieveConfirm: '¿Relevar a {name} como {role}?',
    relieveDescription: '{name} ha estado trabajando desde {time}',
    transferConfirm: '¿Transferir Estación?',
    transfer: 'Transferir',
    clockedIn: 'Escaneado exitosamente',
    clockingInAsPacker: 'Registrando como Empacador...',
    redirecting: 'Redirigiendo a producción...',
    scanDifferentStation: 'Escanear Otra Estación',
    skipToProduction: 'Ir a Producción →',
    clockOut: 'Escanear Salida',
    clockOutConfirm: '¿Escanear salida de {station}?',
    clockedOut: 'Salida escaneada exitosamente',
    orEnterManually: 'O ingrese manualmente:',
  },

  // Vistas Móviles
  mobile: {
    // Escanear Salida
    scanOut: 'Escanear Salida',

    // Fichar Entrada
    scanStation: 'Escanear Estación',
    scanBadge: 'Escanear Credencial',
    selectRole: 'Seleccionar Rol',
    confirmRelief: 'Confirmar Relevo',
    success: 'Éxito',
    scanStationBarcode: 'Escanear Código de Estación',
    scanStationHint: 'Apunte el escáner al código de la estación',
    scanYourBadge: 'Escanear Su Credencial',
    scanBadgePlaceholder: 'Escanear o ingresar credencial...',
    scanBadgeAbove: 'Escanee su credencial',
    orEnterManually: 'O ingrese manualmente:',
    noActiveSession: 'No hay sesión activa en esta estación',
    sessionCompleted: 'Esta sesión ya ha sido completada',
    sessionCancelled: 'Esta sesión ha sido cancelada',
    materialsNotReceived: 'Las materias primas para la sub-sesión {subSessionNumber} aún no han sido recibidas. La producción no puede comenzar.',
    awaitingAssignment: 'La transferencia para la sub-sesión {subSessionNumber} ha sido recibida, pero la sub-sesión está esperando la asignación de Operador/Empacador.',
    scheduledFuture: 'La sub-sesión {subSessionNumber} está programada para una fecha futura y aún no puede iniciarse.',
    currentAssignments: 'Trabajando Actualmente',
    operator: 'Operador',
    packer: 'Empacador',
    selectYourRole: 'Seleccione Su Rol',
    relieveWorker: '¿Relevar Trabajador?',
    currentlyWorkingAs: 'está trabajando actualmente como',
    yesRelieve: 'Sí, Relevar',
    clockedIn: '¡Fichado!',

    // Vista del Operador
    operatorView: 'Vista del Operador',
    confirmBackToStation: '¿Volver a escanear estación?',
    clockOut: 'Escanear Salida',
    clockedOut: 'Salida escaneada exitosamente',
    clockedOutFromAnotherDevice: 'Ha sido desconectado desde otro dispositivo',
    loggedInFromAnotherDevice: 'Ha iniciado sesión desde otro dispositivo',
    youHaveBeenRelieved: 'Ha sido relevado por otro trabajador',
    sessionProgress: 'Progreso de la Sesión',
    materialWeight: 'Material de Entrada',
    remaining: 'Salida Restante Est.',
    pace: 'Ritmo',
    instructions: 'Instrucciones',
    operatorInstructions: 'Supervise la línea de producción y asegure los estándares de calidad. Coordine con el empacador para los pesos de las cajas.',
    qualityReminder: 'Verifique materiales extraños y asegure el empaque adecuado antes de sellar.',

    // Vista del Empacador
    packerView: 'Vista del Empacador',
    boxes: 'cajas',
    weightWindow: 'Rango de Peso',
    enterWeight: 'Ingrese peso de la caja',
    weightValid: 'El peso está dentro del rango',
    weightTooLow: 'El peso es muy bajo',
    weightTooHigh: 'El peso es muy alto',
    printLabel: 'Imprimir Etiqueta',
    packSubUnit: 'Empacar sub-unidad',
    subUnit: 'Sub-unidad',
    packed: 'empacada',
    subUnitsPacked: 'Sub-unidades empacadas',
    nowPackTheBox: 'Ahora empaca la caja',
    labelPrinted: '¡Etiqueta impresa!',
    printerUnavailableBoxCounted: 'Impresora no disponible — caja contada',
    printerUnavailableCannotProceed: 'Impresora no disponible — no se puede imprimir etiqueta. Por favor verifique la conexión de la impresora.',
    confirmLabel: 'Confirmar Etiqueta Aplicada',
    scanToConfirm: 'Escanee credencial y luego etiqueta para confirmar',
    step1ScanBadge: '1. Escanear Su Credencial',
    step2ScanLabel: '2. Escanear Etiqueta de Caja',
    waiting: 'Esperando...',
    verifying: 'Verificando...',
    scanBadgeFirst: 'Escanee credencial primero',
    badgeScanned: 'Credencial escaneada',
    scanLabelNotBadge: 'Por favor escanee la etiqueta, no la credencial',
    boxConfirmed: '¡Caja Confirmada!',
    boxNumber: 'Caja',
    scanBadgeForOptions: 'Escanee su credencial para opciones',
    scanStationForOptions: 'Escanee estación, luego credencial para opciones',
    nowScanBadge: 'Ahora escanee su credencial',
    stationScanned: 'Estación escaneada - ahora escanee su credencial',
    wrongStation: 'Estación incorrecta - escanee la estación correcta',
    wrongBadge: 'Credencial incorrecta - escanee su credencial',
    stationBarcode: 'Código de estación...',
    badgeNumber: 'Número de credencial...',
    scanStationFirst: 'Por favor escanee la estación primero',
    whatWouldYouLikeToDo: '¿Qué desea hacer?',
    backToPacker: 'Volver al Empacador',
    takeBreak: 'Tomar Descanso',
    pausing: 'Pausando...',
    breakStarted: 'Descanso iniciado',
    differentBadge: 'Credencial diferente escaneada',
    supervisorOverrideActivated: 'Anulación de supervisor activada',
    supervisorNoSession: 'No se encontró sesión activa',
    supervisorSessionError: 'Error al cargar datos de sesión',
    supervisorBadgeError: 'Error al verificar credencial',
    noOperatorAssigned: 'Aún no hay operador asignado a esta sesión',
    supervisor: 'Supervisor',
    supervisorOverride: 'Anulación de Supervisor',
    scanSupervisorBadgeToContinue: 'Escanee credencial de supervisor para continuar',
    notASupervisor: 'La credencial no pertenece a un supervisor',
    badgeVerificationFailed: 'Error de verificación de credencial',
    labelReprintsManualWeight: 'Reimpresión de etiquetas, peso manual, etc.',
    clockInAsWorker: 'Fichar como Trabajador',
    workAsOperatorPacker: 'Trabajar como operador o empacador',
    verifyingBadge: 'Verificando credencial...',
    wrongPackerBadge: 'Credencial incorrecta - solo el empacador registrado puede confirmar',
    resumingPendingBox: 'Reanudando caja anterior - escanee credencial para confirmar',
    previousBoxCancelled: 'La caja anterior no confirmada fue anulada',
    pendingLabelVoided: 'Etiqueta pendiente fue anulada por supervisor',
    boxCancelledCannotConfirm: 'Esta caja ha sido anulada y no se puede confirmar',
    packingInstructions: 'Instrucciones de Empaque',
    productionDetails: 'Detalles de Producción',
    itemNumber: 'Artículo #',
    englishName: 'Inglés',
    chineseName: 'Chino',
    rawMaterial: 'Materia Prima',
    packingSpec: 'Empaque',
    session: 'Sesión',
    progress: 'Progreso',
    weightPerBox: 'Peso/Caja',
    expectedBoxes: 'Cajas Esperadas',
    // Objetivo Alcanzado
    targetReached: '¡Objetivo Alcanzado!',
    targetReachedMessage: 'Has empacado todas las cajas objetivo de esta sesión.',
    continuePacking: 'Seguir Empacando',
    completeSession: 'Completar Sesión',
    finish: 'Finalizar',
    // Sesión Completada (por supervisor)
    sessionCompletedBySupervisor: 'Sesión Completada',
    sessionCompletedMessage: 'Esta sesión ha sido marcada como completada por un supervisor. Ya no puedes empacar cajas para esta sesión.',
    returnToClockIn: 'Volver a Escanear Estación',
    // Terminación Temprana (Terminar Sesión desde menú de credencial)
    endSession: 'Terminar Sesión',
    earlyCompletionWarning: 'Terminación Temprana de Sesión',
    earlyCompletionWarningDesc: 'El progreso es menor al 100% - La sesión se marcará como completada por anulación',
    earlyCompletionReason: 'Razón de Terminación Temprana',
    selectReason: 'Seleccionar una razón...',
    selectEarlyCompletionReason: 'Por favor seleccione una razón para la terminación temprana',
    selectReasonFirst: 'Seleccione una razón arriba antes de escanear',
    reasonShiftEnded: 'Turno Terminado',
    reasonMaterialShortage: 'Escasez de Material',
    reasonEquipmentIssue: 'Problema de Equipo',
    reasonOther: 'Otro',
    // Asistente de Registro de Desperdicio
    wasteTracking: 'Registro de Desperdicio',
    disposableWaste: 'Desperdicio Desechable',
    disposableDesc: 'Basura, material no recuperable',
    humanError: 'Error Humano',
    humanErrorDesc: 'No cuenta como desperdicio',
    trackingOnly: 'Solo registro',
    returnsToInventory: 'Regresa al Inventario',
    productionRemainder: 'Remanente de Producción',
    notWaste: 'No es desperdicio - regresa al lote',
    byProduct: 'Subproducto',
    byProductDesc: 'Subproducto vendible o reutilizable',
    byProductMarketable: 'Comercializable',
    byProductMarketableDesc: 'puede venderse',
    byProductProduction: 'Para Producción',
    byProductProductionDesc: 'reutilizado en producción',
    thisSession: 'Esta sesión',
    carryForward: 'Arrastre',
    fromPriorSessions: 'de sesiones anteriores',
    bufferTotal: 'Total del buffer',
    readyCases: 'Cajas listas',
    reserve: 'Reserva',
    addByproductEntry: 'Agregar subproducto',
    removeEntry: 'Eliminar',
    remainderNotIntact: 'Sobrante - No Intacto',
    remainderNotIntactDesc: 'Materias primas abiertas o parciales',
    finishProductNotIntact: 'Producto Terminado - No Intacto',
    finishProductNotIntactDesc: 'Sobrante de producto terminado que no llena una caja',
    intactBoxes: 'Sobrante - Intacto',
    intactBoxesDesc: 'Cajas de materia prima selladas devueltas al lote',
    scanIntactBox: 'Escanear código de caja intacta',
    boxesScanned: 'cajas escaneadas',
    totalWeight: 'lbs totales',
    removeBox: 'Eliminar',
    selectMaterial: 'Seleccionar Material',
    selectByproduct: 'Seleccionar subproducto',
    noLinkedByproducts: 'Sin subproductos vinculados',
    noByproductMappings: 'No hay subproductos vinculados a la materia prima utilizada en esta sub-sesión',
    enterWeightManually: 'Ingresar peso manualmente',
    manualAddCase: 'Agregar Caja Manual',
    manualEntry: 'Entrada Manual',
    scanBoxNotBadge: 'Escanee un código de caja, no una credencial',
    invalidBarcode: 'Código de barras inválido - no se pudo extraer el peso',
    boxAlreadyScanned: 'Esta caja ya fue escaneada',
    exceedsAllocatedWeight: 'No se puede escanear: el total excedería el peso asignado',
    gtinMismatch: 'El código de barras no corresponde a la materia prima asignada',
    caseWeightMustBePositive: 'El peso de la caja debe ser mayor que 0',
    caseWeightAboveMax: 'El peso de la caja supera el máximo permitido de {max} lbs',
    caseWeightOutOfRange: 'El peso de la caja debe estar entre {min} y {max} lbs',
    // Resumen de Desperdicio
    waterLiquid: 'Pérdida de Agua / Líquido',
    waterLiquidAuto: 'Calculado automáticamente',
    wasteSummary: 'Resumen de Desperdicio',
    yieldRate: 'Tasa de Rendimiento',
    initialMaterial: 'Material Inicial',
    totalOutput: 'Producción Total',
    lbsCarryover: 'lbs de arrastre',
    carryover: 'Arrastre',
    lbsFromSession: 'lbs de sesión',
    submitWaste: 'Enviar',
    submittingWaste: 'Enviando registro de desperdicio...',
    wasteSubmittedSuccess: '¡Sesión Completada!',
    redirecting: 'Redirigiendo...',
    weightsExceedWarning: 'Los pesos ingresados exceden el material inicial',
    goBackAndCorrect: 'Regrese y corrija los valores antes de enviar.',
    cannotSubmit: 'No se puede enviar',
    excessAmount: 'Exceso',
    // Aprobación de Supervisor
    yieldVarianceDetected: 'Variación de Rendimiento Detectada',
    yieldReviewRequired: 'Revisión de Rendimiento Requerida',
    yieldWithinTolerance: 'Rendimiento Dentro de Tolerancia',
    expectedYield: 'Rendimiento Esperado',
    actualYield: 'Rendimiento Real',
    scanSupervisorBadge: 'Escanee credencial de supervisor para aprobar',
    scanSupervisorBadgeToComplete: 'Escanee credencial de supervisor para completar sesión',
    supervisorApproval: 'Aprobación de Supervisor Requerida',
    supervisorSignOff: 'Firma de Supervisor Requerida',
    supervisorApproved: 'Aprobado por',
    supervisorOnlyCanApprove: 'Solo los Supervisores pueden aprobar el seguimiento de residuos',
    invalidBadge: 'Credencial inválida',
    // Modo de peso de balanza
    scaleWeight: 'Peso de Balanza',
    scaleWeightFromScale: 'Lectura en vivo de la balanza',
    noScaleConfigured: 'No hay balanza configurada para esta estación',
    scaleNotConnected: 'La balanza no está conectada',
    waitingForStableWeight: 'Esperando peso estable...',
    // Resumen de sesión
    sessionSummary: 'Resumen de Sesión',
    summaryTotalOutput: 'Producción Total',
    totalWaste: 'Desperdicio Total',
    inputWeight: 'Peso de Entrada',
    outputWeight: 'Peso de Salida',
    waste: 'Desperdicio',
    returns: 'Devoluciones',
    weightDiscrepancy: 'Diferencia',
    accounted: 'Contabilizado',
    boxCount: 'Cantidad de Cajas',
    summaryPace: 'Ritmo',
    elapsedTime: 'Tiempo Transcurrido',
    summaryProgress: 'Progreso',
    // Modo de peso
    fixedWeight: 'Peso Fijo',
    catchWeight: 'Peso Variable',
    fixedWeightFromProduct: 'De configuración del producto',
    readyToPrint: 'Listo para imprimir',
    readyToPackSubUnit: 'Listo para empacar sub-unidad',
  },

  // Modal de Detalles de Sesión
  sessionDetails: {
    title: 'Detalles de Sesión',
    assignment: 'Asignación',
    details: 'Detalles',
    productInfo: 'Información del Producto Terminado',
    scheduleInfo: 'Información del Horario',
    materialInfo: 'Información de Materia Prima',
    materialOnHoldAlert: 'Material pendiente de aprobación del gerente — la sesión no puede comenzar hasta que los artículos en espera sean aprobados o rechazados',
    existingInventory: 'de inventario HTE',
    inventoryTag: '(HTE)',
    allocated: 'Asignado',
    totalOnHold: 'Total en espera',
    assignStation: 'Asignar Estación',
    assignOperator: 'Asignar Operador',
    splitSession: 'Dividir Sesión',
    stationAssignments: 'Asignaciones de Estación',
    subSessions: 'Sub-Sesiones',
    selectStation: 'Seleccionar estación...',
    selectOperator: 'Seleccionar operador...',
    noStationAssigned: 'Sin estación asignada',
    noOperatorAssigned: 'Sin operador asignado',
    currentStation: 'Estación actual',
    currentOperator: 'Operador actual',
    materialWeight: 'Peso (lbs)',
    minWeight: 'Mín',
    alreadyUsed: 'Usado',
    weightMode: 'Modo de Peso',
    fixedWeight: 'Fijo',
    catchWeight: 'Variable',
    confirmSplit: 'Confirmar División',
    addStation: 'Agregar Estación',
    station: 'Estación',
    operator: 'Operador',
    totalWeight: 'Total Asignado',
    remaining: 'Restante por Asignar',
    weightMismatch: 'El peso total debe ser igual al peso del material de la sesión',
    minWeightWarning: '{{count}} sub-sesión(es) puede que no tenga suficiente peso para producir 1 caja (mín ~{{minWeight}} lbs)',
    stationAssigned: 'Estación asignada exitosamente',
    // Station change modal (for active/paused)
    reassignStation: 'Cambiar Estación',
    reassignStationWarning: 'Los trabajadores deberán volver a registrar entrada en la nueva estación.',
    stationChangeReason: 'Razón del cambio de estación',
    selectStationChangeReason: 'Seleccionar razón...',
    stationChangeReasons: {
      equipment_issue: 'Problema de Equipo',
      workload_balance: 'Balance de Carga de Trabajo',
      operator_request: 'Solicitud del Operador',
      supervisor_decision: 'Decisión del Supervisor',
      station_maintenance: 'Mantenimiento de Estación',
      other: 'Otro',
    },
    stationChangeOtherPlaceholder: 'Ingrese razón...',
    confirmStationChange: 'Cambiar Estación',
    // Add material modal
    addMaterial: 'Agregar Material',
    inputMode: 'Modo de Entrada',
    byWeight: 'Por Peso',
    byBox: 'Por Caja',
    selectLot: 'Seleccionar Material',
    weightToAdd: 'Peso a Agregar (lbs)',
    targetBoxes: 'Cajas Objetivo',
    requiredWeight: 'Peso requerido',
    availableWeight: 'Disponible',
    estBoxesPrefix: 'Est.',
    boxesUnit: 'cajas',
    insufficientStock: 'Stock insuficiente disponible',
    // WCO-2607: selector por lote
    selectLotsToAdd: 'Seleccionar lotes a agregar',
    perLotWeight: 'Peso (lbs)',
    lotCapExceeded: 'No puede exceder la cantidad del lote',
    lotIntact: 'Intacto',
    lotNotIntact: 'No intacto',
    lotByProduct: 'Subproducto',
    lotOnHold: 'En espera',
    lotTransfer: 'Transferencia',
    carriedToSession: '−{{cases}} cajas / −{{weight}} lbs trasladado a la sesión {{session}}',
    carriedToSessionPartial: '−{{weight}} lbs (parcial) trasladado a la sesión {{session}}',
    carriedToSessionWeightOnly: '−{{weight}} lbs trasladado a la sesión {{session}}',
    carriedFromSession: '+{{cases}} cajas / +{{weight}} lbs trasladado desde la sesión {{session}}',
    carriedFromSessionPartial: '+{{weight}} lbs (parcial) trasladado desde la sesión {{session}}',
    carriedFromSessionWeightOnly: '+{{weight}} lbs trasladado desde la sesión {{session}}',
    // WCO-2659: línea "material restante" (peso primero, cajas como calificador).
    remainderProduced: '{{weight}} lbs de material restante ({{breakdown}})',
    remainderProducedIntact: '{{weight}} lbs / {{cases}} cajas de material restante',
    remainderProducedPartial: '{{weight}} lbs (parcial) de material restante',
    remainderProducedWeightOnly: '{{weight}} lbs de material restante',
    remainderProducedIntactPart: '{{cases}} cajas intacto',
    remainderProducedIntactWeightPart: 'intacto',
    remainderProducedPartialPart: '{{weight}} parcial',
    lotCases: '{{n}} cajas',
    estUsable: 'Est. Utilizable (lbs)',
    noLotsAvailable: 'No hay lotes utilizables para este material',
    total: 'Total',
    lotsUnit: 'lotes',
    casesUnit: 'cajas',
    estOutputBoxes: 'cajas de salida',
    willDistribute: 'Se distribuirá a sub-sesiones existentes:',
    willAddToExisting: 'Se agregará a sub-sesión existente:',
    willCreateNew: 'Se creará nueva sub-sesión:',
    selectTargetSubSession: 'Seleccionar Sub-Sesión Destino',
    selectFinishProductSubSession: 'Seleccionar sub-sesión...',
    selectTargetSubSessions: 'Seleccionar Sub-Sesión(es) Destino',
    selectNoneForNew: 'Deseleccionar todo para crear una nueva sub-sesión',
    addMaterialReason: 'Razón',
    selectAddMaterialReason: 'Seleccionar razón...',
    addMaterialReasons: {
      insufficient_material: 'Material Insuficiente',
      production_increase: 'Aumento de Producción',
      quality_issue: 'Problema de Calidad',
      supervisor_decision: 'Decisión del Supervisor',
      leftover_previous_session: 'Sobrante de sesión anterior',
      other: 'Otro',
    },
    addMaterialOtherPlaceholder: 'Ingrese razón...',
    addMaterialTabRawMaterial: 'Materia Prima',
    addMaterialTabFinishProduct: 'Producto Terminado',
    selectProduct: 'Seleccionar Producto',
    addProduct: 'Agregar Producto',
    confirmAddMaterial: 'Agregar Material',
    materialDistributed: 'Material agregado y distribuido a sub-sesiones existentes',
    newSubSessionCreated: 'Material agregado como nueva sub-sesión',
    materialAddedToExisting: '{{weight}} lbs se agregarán a la sub-sesión existente (guardar para aplicar)',
    materialAddedAsNew: '{{weight}} lbs crearán una nueva sub-sesión (guardar para aplicar)',
    finishProductAdded: 'Producto terminado asignado a la sesión',
    // Subdivide modal
    subdivide: 'Subdividir',
    subdivideSession: 'Subdividir Sub-Sesión',
    subdivideDesc: 'Dividir el peso restante sin procesar a una nueva sub-sesión.',
    remainingWeight: 'Restante',
    minPerSubSession: 'Mín por sub-sesión',
    splitWeight: 'Peso a Dividir (lbs)',
    invalidSplitWeight: 'Cada sub-sesión debe tener suficiente peso para al menos 1 caja',
    targetStation: 'Estación para Nueva Sub-Sesión',
    assignLater: 'Asignar después',
    subdivideReason: 'Razón',
    selectSubdivideReason: 'Seleccionar razón...',
    subdivideReasons: {
      workload_balance: 'Balance de Carga de Trabajo',
      speed_up_production: 'Acelerar Producción',
      operator_availability: 'Disponibilidad de Operador',
      station_availability: 'Disponibilidad de Estación',
      other: 'Otro',
    },
    subdivideOtherPlaceholder: 'Ingrese razón...',
    confirmSubdivide: 'Subdividir',
    subdivideSuccess: 'Peso dividido exitosamente a nueva sub-sesión',
    subdivideStaged: 'División preparada. Haga clic en Guardar para aplicar.',
    cancelSubSession: 'Cancelar Sub-Sesión',
    cancelSubSessionDesc: '¿Está seguro de cancelar esta sub-sesión? El peso del material será devuelto al lote.',
    confirmCancelSubSession: '¿Está seguro de cancelar esta sub-sesión? El peso del material será devuelto al lote.',
    subSessionCancelled: 'Sub-sesión cancelada',
    splitWeightTooLarge: 'El peso a dividir debe ser menor que el peso original',
    unsavedChanges: 'Cambios sin Guardar',
    unsavedChangesMessage: 'Tiene cambios sin guardar. ¿Está seguro de cerrar sin guardar?',
    discardChanges: 'Descartar Cambios',
    // Station conflict (priority queue) modal
    stationConflictTitle: 'Estación Ya Activa',
    stationConflictMessage: 'La estación {station} tiene una sub-sesión activa ({subSession}).',
    stationQueueExists: 'Ya hay {count} sub-sesiones en cola.',
    stationPriorityQueue: 'Su sub-sesión tendrá PRIORIDAD y será la primera en la cola.',
    stationWillActivate: 'Cuando la sub-sesión activa actual termine, la suya comenzará.',
    confirmQueuePriority: 'Poner en Cola con Prioridad',
    priorityBadge: 'Prioridad',
    queuedWithPriority: 'Sub-sesión puesta en cola con prioridad',
    invalidWeight: 'Por favor ingrese un peso válido',
    operatorAssigned: 'Operador asignado exitosamente',
    sessionSplit: 'Sesión dividida en sub-sesiones exitosamente',
    sessionUpdated: 'Sesión actualizada exitosamente',
    failedToAssignStation: 'Error al asignar estación',
    failedToAssignOperator: 'Error al asignar operador',
    cannotClearOperator: 'No se puede remover el operador — se requiere un operador para que la sesión funcione',
    cannotClearPacker: 'No se puede remover el empacador — se requiere un empacador para que la sesión funcione',
    assignPacker: 'Asignar Empacador',
    selectPacker: 'Seleccionar empacador...',
    currentPacker: 'Empacador actual',
    noPackerAssigned: 'Sin empacador asignado',
    packerAssigned: 'Empacador asignado exitosamente',
    failedToAssignPacker: 'Error al asignar empacador',
    failedToSplitSession: 'Error al dividir sesión',
    cannotAddToMultiMaterial: 'No se pueden agregar sub-sesiones a sesiones con múltiples materiales',
    cannotSplitStarted: 'No se puede dividir una sesión que ya ha comenzado',
    startSplit: 'Dividir en múltiples estaciones',
    splitDescription: 'Asignar peso del material a múltiples estaciones. El total debe ser igual al peso de la sesión',
    splitByMaterialDescription: 'Asignar cada material a una estación. Seleccione una estación para cada material a continuación.',
    splitHint: 'Dividir esta sesión en múltiples estaciones para procesamiento paralelo',
    packing: 'Empaque',
    initialWeight: 'Peso Inicial',
    initialWeightTooltip: 'Peso de materia prima asignado a esta sesión',
    unitWeight: 'Peso por Unidad',
    yieldFactor: 'Factor de Rendimiento',
    estimatedOutput: 'Producción Estimada',
    carryover: 'arrastre',
    estimatedCases: 'Cajas Estimadas',
    actualCases: 'Cajas Reales',
    perSubSessionCases: 'Cajas por Sub-Sesión',
    expectedCasesShort: 'Estimado',
    actualCasesShort: 'Real',
    perOutputLocationCases: 'Cajas por ubicación de salida',
    outputLocation: 'Ubicación',
    noStationYet: 'Sin estación aún',
    currentProgress: 'Progreso Actual',
    cases: 'cajas',
    timestamps: 'Marcas de Tiempo',
    completedAt: 'Completado',
    productionResults: 'Resultados de Producción',
    actualOutput: 'Producción Real',
    wasteWeight: 'Desperdicio',
    notes: 'Notas',
    createdBy: 'Creado Por',
    createdAt: 'Creado El',
    date: 'Fecha',
    dateCode: 'Código de Fecha',
    brand: 'Marca',
    lotNumber: 'Número de Lote',
    location: 'Ubicación',
    transferBackLocation: 'Ubicación(es) de Devolución',
    // Control de sesión
    startSession: 'Iniciar',
    pauseSession: 'Pausar',
    resumeSession: 'Reanudar',
    cancelSession: 'Cancelar',
    sessionStarted: 'Sesión iniciada exitosamente',
    sessionPaused: 'Sesión pausada exitosamente',
    sessionResumed: 'Sesión reanudada exitosamente',
    sessionCancelled: 'Sesión cancelada exitosamente',
    failedToStart: 'Error al iniciar sesión',
    failedToPause: 'Error al pausar sesión',
    failedToResume: 'Error al reanudar sesión',
    failedToCancel: 'Error al cancelar sesión',
    vb6TransferReminder: 'Recuerde eliminar la transferencia en VB6',
    vb6TransferDetails: 'Transferencia',
    pauseSessionDesc: 'Seleccione una razón para pausar esta sesión.',
    cancelSessionDesc: 'Por favor proporcione una razón para cancelar esta sesión.',
    cancelActiveWarning: 'Advertencia: Esta sesión está actualmente activa. Cancelar liberará la estación y cualquier progreso no guardado se perderá.',
    cancelReasonPlaceholder: 'Ingrese razón de cancelación...',
    // Cancel reason dropdown (WCO-2706)
    selectCancelReason: 'Seleccionar razón...',
    cancelReasons: {
      wrong_product: 'Producto incorrecto',
      duplicate: 'Sesión duplicada',
      entered_in_error: 'Ingresada por error',
      other: 'Otro',
    },
    provideCancelReason: 'Por favor proporcione una razón de cancelación',
    sessionNotCancellable: 'Esta sesión ya no se puede cancelar porque su estado es "{{status}}". Solo se pueden cancelar las sesiones que aún no han comenzado.',
    confirmPause: 'Confirmar Pausa',
    confirmCancel: 'Confirmar Cancelación',
    // History tab
    history: 'Historial',
    boxes: 'Cajas',
    overrides: 'Anulaciones',
    activityLog: 'Registro de Actividad',
    packedBoxes: 'Cajas Empacadas',
    boxNumber: 'Caja #',
    barcode: 'Código de Barras',
    weight: 'Peso',
    packedAt: 'Empacado En',
    updatedAt: 'Actualizado En',
    packedBy: 'Empacado Por',
    updatedBy: 'Actualizado Por',
    noHistory: 'No se encontró historial de actividad',
    noBoxes: 'Aún no se han empacado cajas',
    noCases: 'Aún no se han empacado cajas',
    by: 'Por',
    subsession: 'Subsesión',
    noSubsession: 'Sin Subsesión',
    scanIn: 'Escaneo de Entrada',
    scanOut: 'Escaneo de Salida',
    breakStart: 'Inicio de Descanso',
    breakEnd: 'Fin de Descanso',
    assigned: 'Asignado',
    unassigned: 'Desasignado',
    reassigned: 'Reasignado',
    historyCreated: 'Creado',
    historySubmitted: 'Enviado',
    historyReceived: 'Material Recibido',
    historyReady: 'Listo',
    historyStarted: 'Iniciado',
    historyCompleted: 'Completado',
    historyCancelled: 'Cancelado',
    historyPaused: 'En Pausa',
    historyResumed: 'Reanudado',
    historyReprintsResolved: 'Reimpresiones Confirmadas',
    historySubdivided: 'Subdividido',
    historyMaterialAdded: 'Material Agregado',
    historyFinishProductAdded: 'Producto Terminado Agregado',
    historyTransferReminderCreated: 'Recordatorio de Transferencia Creado',
    historyTransferReminderResolved: 'Recordatorio de Transferencia Resuelto',
    historyEdited: 'Editado',
    historyStatusChanged: 'Estado Cambiado',
    historyStationAssigned: 'Estación Asignada',
    historyStationUnassigned: 'Estación Desasignada',
    historyOperatorAssigned: 'Operador Asignado',
    historyPackerAssigned: 'Empacador Asignado',
    historyWeightModeChanged: 'Modo de Peso Cambiado',
    boxPacked: 'Caja Empacada',
    boxCancelled: 'Caja Cancelada',
    box: 'Caja',
    packer: 'Empacador',
    override_manual_weight: 'Modo de Peso Cambiado',
    override_label_reprint: 'Etiqueta Reimpresa',
    override_yield_signoff: 'Firma de Rendimiento',
    override_session_completion: 'Anulación de Finalización de Sesión',
    override_eod_signoff: 'Anulación de Cierre de Día',
    materialIssue: 'Problema de Materia Prima',
    materialIssueDamagedWeight: 'Peso Dañado',
    materialIssueItem: 'Material',
    materialIssueLot: 'Lote',
    materialIssueInputWeight: 'Peso de Entrada',
    materialIssueTargetOutput: 'Producción Objetivo',
    materialIssueReportedBy: 'Reportado Por',
    materialIssueMethod: 'Método',
    materialIssueScan: 'Escaneo de Código',
    materialIssueManual: 'Entrada Manual',
    // Material Added event
    materialAddedItem: 'Material',
    materialAddedLot: 'Lote',
    materialAddedWeight: 'Peso',
    materialAddedReason: 'Razón',
    materialAddedNote: 'Nota',
    // Transfer Verified event
    transferVerified: 'Transferencia Verificada',
    materialReceived: 'Material Recibido',
    approved: 'Aprobado',
    received: 'Recibido',
    onHold: 'En Espera',
    rejected: 'Rechazado',
    // Weight Modified event
    weightSetTo: 'Peso ajustado a',
    // Subdivided event
    splitOff: 'separado',
    remainingAfterSplit: 'restante',
    progressAtEvent: 'Progreso',
    boxesPackedDuringShift: 'Empacado este turno',
    packerSummary: 'Resumen de Empacadores',
    employeeSummary: 'Resumen de Empleados',
    totalSessionTime: 'Tiempo total de sesión',
    timeActive: 'Tiempo activo',
    rolePacker: 'Empacador',
    roleOperator: 'Operador',
    showMoreCancelled: 'Mostrar {{count}} más cancelados',
    hideCancelled: 'Ocultar cancelados',
    // Terminación Temprana (desde panel de supervisor)
    completeSession: 'Completar',
    sessionCompleted: 'Sesión completada',
    earlyCompletionWarning: 'Terminación Temprana de Sesión',
    earlyCompletionWarningDesc: 'Esta sesión no ha alcanzado su objetivo. Se marcará como completada por anulación de supervisor.',
    wasteTrackingReminder: 'Nota: Asegúrese de que el registro de desperdicio se haya completado en la estación antes de cerrar esta sesión.',
    completionReason: 'Razón de Terminación Temprana',
    selectReason: 'Seleccionar una razón...',
    selectCompletionReason: 'Por favor seleccione una razón',
    reasonShiftEnded: 'Turno Terminado',
    reasonMaterialShortage: 'Escasez de Material',
    reasonEquipmentIssue: 'Problema de Equipo',
    reasonOther: 'Otro',
    confirmComplete: 'Completar Sesión',
    // Source Location
    sourceLocation: 'Ubicación de Origen',
    inboundTransferFrom: 'Transferencia entrante desde',
    sourceLocationDescription: 'Seleccione una ubicación de origen para crear automáticamente una transferencia entrante para materiales que no están en espera.',
    selectSourceLocation: 'Seleccionar ubicación de origen...',
    cannotEditActiveSession: 'No se pueden modificar sesiones activas/completadas',
    viewTransfer: 'Ver Transferencia',
    // PDF actions
    printPdf: 'Imprimir',
    downloadPdf: 'Descargar PDF',
    pdfError: 'Error al generar PDF',
    // Status dropdown
    statusDropdown: {
      next: 'Siguiente (Promover a Listo)',
      promoteSuccess: 'Sub-sesión promovida a listo',
      statusChanged: 'Estado cambiado exitosamente',
      demoteToPlanned: 'Volver a Planeado',
      promoteToReady: 'Promover a Listo',
    },
  },
  supervisorOverride: {
    title: 'Anulación de Supervisor',
    labelReprints: 'Reimpresión de Etiquetas',
    manualWeightMode: 'Modo de Peso Manual',
    endOfDaySummary: 'Resumen de Fin de Día',
    reprintButton: 'Reimprimir',
    reprinting: 'Reimprimiendo...',
    reprintReason: 'Razón de Reimpresión',
    reprintSuccess: 'Etiqueta enviada a impresora',
    reprintPrintFailed: 'Error de impresión',
    printerUnavailable: 'Impresora no disponible — verifique la conexión',
    viewBarcode: 'Ver Código de Barras',
    barcodeInfo: 'Información del Código de Barras',
    noBarcodeAvailable: 'Código de barras no disponible',
    reasons: {
      damaged: 'Etiqueta Dañada',
      misprint: 'Error de Impresión',
      illegible: 'Ilegible',
      wrongInfo: 'Información Incorrecta',
      other: 'Otro',
    },
    selectWeightMode: 'Seleccionar Modo de Peso',
    enableCatchWeight: 'Habilitar entrada de peso variable',
    manualModeActive: 'La entrada manual de peso está ACTIVA mientras este panel esté abierto',
    manualModeDescription: 'La entrada de peso aceptará entrada manual en lugar de requerir lecturas de báscula. Este modo se desactiva al cerrar el panel de anulación.',
    activateManualMode: 'Habilitar Peso Variable',
    manualModeReason: 'Razón del Modo Manual',
    manualModeRecorded: 'Anulación de modo de peso manual registrada',
    inputWeight: 'Peso de Entrada',
    outputWeight: 'Peso de Salida',
    waste: 'Desperdicio',
    yieldPercent: 'Rendimiento %',
    expectedYield: 'Rendimiento Esperado',
    actualYield: 'Rendimiento Real',
    variance: 'Variación',
    boxCount: 'Cantidad de Cajas',
    avgBoxWeight: 'Peso Promedio por Caja',
    pace: 'Ritmo',
    elapsedTime: 'Tiempo Transcurrido',
    progress: 'Progreso',
    reviewAndSignOff: 'Revisar rendimiento y firmar',
    signOff: 'Firmar',
    signOffSuccess: 'Firma de rendimiento registrada',
    signedOff: 'Firmado',
    pendingSignOff: 'Pendiente de Firma',
    badgeInvalid: 'No es una credencial de supervisor',
    overrideRecorded: 'Anulación registrada exitosamente',
    noActiveSession: 'No hay sesión activa para anular',
    selectReason: 'Por favor seleccione una razón',
    weightModeChanged: 'Modo de peso cambiado',
    weightModeChangeFailed: 'Error al cambiar el modo de peso',
    // Void label
    voidLabel: 'Anular Etiqueta',
    confirmVoid: 'Anular',
    voidSuccess: 'Etiqueta anulada exitosamente',
    voidFailed: 'Error al anular etiqueta',
  },

  // Material Issue
  materialIssue: {
    menuButton: 'Problema de Materia Prima',
    title: 'Problema de Materia Prima',
    description: 'Reportar materia prima dañada encontrada durante producción',
    scanBarcode: 'Escanear caja',
    scanBarcodeHint: 'Escanee el código de barras de la caja de materia prima dañada',
    manualWeight: 'Ingresar peso',
    weightLabel: 'Peso Dañado (lbs)',
    weightPlaceholder: 'Ingresar peso en lbs',
    reasonLabel: 'Razón del rechazo',
    reasonPlaceholder: 'Describa por qué se rechaza este material...',
    barcodeDetected: 'Código detectado',
    materialMatched: 'Material identificado',
    materialName: 'Material',
    transferNumber: 'Transfer #',
    weightExtracted: 'Peso del código',
    impactPreview: 'Vista Previa del Impacto',
    currentInputWeight: 'Peso de Entrada Actual',
    newInputWeight: 'Nuevo Peso de Entrada',
    currentTargetOutput: 'Producción Objetivo Actual',
    newTargetOutput: 'Nueva Producción Objetivo',
    currentExpectedBoxes: 'Cajas Esperadas Actuales',
    newExpectedBoxes: 'Nuevas Cajas Esperadas',
    submit: 'Enviar Problema de Material',
    submitting: 'Enviando...',
    success: 'Problema de material registrado exitosamente',
    error: 'Error al registrar problema de material',
    previousIssues: 'Problemas Anteriores',
    noPreviousIssues: 'No hay problemas anteriores para esta sesión',
    weightExceedsAvailable: 'El peso excede el material disponible',
    barcodeNotMatched: 'El código no coincide con ningún material en esta sesión',
    scanOrManual: 'Escanear código o ingresar peso manualmente',
    lbs: 'lbs',
    reasonSelectPlaceholder: 'Seleccione una razón...',
    reasonWrongMaterial: 'Material incorrecto',
    reasonWrongTemperature: 'Temperatura incorrecta',
    reasonMaterialDamaged: 'Material dañado',
    reasonMaterialExpired: 'Material vencido',
  },

  transferVerification: {
    title: 'Transferencias',
    subtitle: 'Recibir y verificar transferencias de materia prima',
    item: 'Artículo',
    scanBadge: 'Escanear Credencial de Supervisor',
    viewAllTransfers: 'Ver Todas las Transferencias',
    scanBadgeSubtitle: 'Autenticar para iniciar la verificación',
    pendingTransfers: 'Transferencias Pendientes',
    noTransfersPending: 'No hay transferencias pendientes de verificación',
    itemsPending: 'artículos pendientes',
    startVerification: 'Iniciar Verificación',
    expectedItems: 'Artículos Esperados',
    scannedItems: 'Artículos Escaneados',
    expected: 'Esperado',
    scanned: 'Escaneado',
    actual: 'Real',
    variance: 'Variación',
    boxes: 'cajas',
    approve: 'Aprobar',
    reject: 'Rechazar',
    approved: 'aprobados',
    rejected: 'rechazados',
    approveConfirm: '¿Confirmar que todos los artículos coinciden con la transferencia?',
    rejectConfirm: '¿Rechazar este artículo? Esta acción no se puede deshacer.',
    confirmSubmit: 'Confirmar Verificación',
    confirm: 'Confirmar',
    notesRequired: 'Proporcione notas explicando la discrepancia',
    notesPlaceholder: 'Describa lo encontrado (ej: 2 cajas dañadas, material incorrecto...)',
    notes: 'Notas',
    rejectReason: 'Razón del rechazo',
    selectRejectReason: 'Seleccione razón del rechazo',
    qualityIssue: 'Problema de Calidad',
    temperatureIssue: 'Problema de Temperatura',
    boxNotIntact: 'Caja no intacta',
    wrongItem: 'Artículo incorrecto',
    wrongMaterial: 'Material incorrecto',
    changeItemNumber: 'Número de Artículo Corregido',
    leaveBlankIfCorrect: 'Dejar en blanco si el artículo es correcto',
    actualQty: 'Cantidad Real',
    actualWeight: 'Peso Real (lbs)',
    verificationComplete: 'Verificación de transferencia completa',
    boxScanned: 'Caja escaneada',
    scanBoxes: 'Escanear cajas de materia prima',
    scanBoxBarcode: 'Escanear código de barras de caja (GS1-128)',
    waitingForScan: '[ ] Escanear código de caja',
    badgeNotBox: 'Credencial escaneada — escanee un código de caja',
    invalidBarcode: 'Formato de código de barras inválido',
    proceedToDecision: 'Proceder a Revisión',
    perItemDecision: 'Revisar Artículos',
    submitAll: 'Enviar Verificación',
    submitError: 'Error al enviar la verificación',
    checkpointSaveError: 'Error al guardar el progreso del escaneo — su progreso puede perderse si navega a otra página',
    loadError: 'Error al cargar transferencias',
    boxesMatch: 'Cajas coinciden',
    boxesMismatch: 'Discrepancia en cantidad de cajas',
    thisWeek: 'Esta Semana',
    lastWeek: 'Semana Pasada',
    weeksAgo: 'semanas atrás',
    scanTransferBarcode: 'Escanear código de transferencia o ingresar número',
    enterTransferNumber: 'Número de transferencia...',
    transferNotFound: 'Transferencia no encontrada',
    transferLookupError: 'Error al buscar transferencia',
    verifyTab: 'Verificar',
    historyTab: 'Historial',
    noHistory: 'Sin historial de verificación',
    historyLoadError: 'Error al cargar historial de verificación',
    transfer: 'Transferencia',
    received: 'Recibido',
    itemNotInTransfer: 'Este artículo no es parte de esta transferencia',
    noTransferSelected: 'No hay transferencia seleccionada',
    decidePendingFirst: 'Acepte o rechace la caja actual primero',
    accept: 'Aceptar',
    accepted: 'Aceptado',
    unknownBarcode: 'Código de barras no encontrado en el sistema',
    badWeight: 'No se pudo leer un peso válido de esta etiqueta. Vuelva a escanear la caja o use Agregar Manual (Etiqueta Dañada).',
    invalidBoxWeight: 'Una caja tiene un peso no válido. Vuelva a escanearla o recházela antes de enviar:',
    weightMissing: 'sin peso registrado',
    weightUnreadable: 'peso ilegible',
    notInTransfer: 'No en transferencia',
    notInTransferWarning: 'Este artículo NO está en esta orden de transferencia',
    itemsNotInTransfer: 'Artículos no en esta transferencia',
    perItemMode: 'Por Artículo',
    wholeTransferMode: 'Toda la Transferencia',
    itemsBreakdown: 'Desglose de artículos',
    alreadyVerified: 'Esta transferencia ya ha sido verificada',
    readyToSubmit: 'Listo para enviar',
    enterActualWeight: 'Ingrese el peso real',
    manualAdd: 'Agregar Manual (Etiqueta Dañada)',
    manualAddTitle: 'Entrada Manual',
    selectItem: 'Seleccione artículo:',
    enterWeight: 'Peso (lbs)',
    qty: 'cant',
    manualAddReason: 'Razón de entrada manual:',
    damagedLabel: 'Etiqueta Dañada',
    missingLabel: 'Etiqueta Faltante',
    labelUnreadable: 'Etiqueta Ilegible',
    manual: 'Manual',
    boxDetails: 'Detalle de cajas',
    hold: 'Retener',
    onHold: 'En Espera',
    holdReason: 'Razón de retención',
    selectHoldReason: 'Seleccione razón de retención',
    holdReasonRequired: 'Por favor seleccione una razón para retener este artículo',
    onHoldReasons: {
      temperature: 'Problema de temperatura',
      wrongItemTomorrow: 'Artículo incorrecto (producción de mañana)',
      other: 'Otro',
    },
    scanSummary: 'Resumen de Escaneo',
    scanSummarySubtitle: 'Revise los totales escaneados vs esperados antes de continuar',
    totalWeight: 'Peso Total',
    discrepancyWarning: 'Discrepancia detectada — revise antes de confirmar',
    confirmProceed: 'Confirmar y Continuar',
    goBackToScanning: 'Volver',
    noDiscrepancies: 'Todos los totales coinciden',
    notInTransferBoxes: 'Cajas no incluidas en la transferencia',
    resumeTitle: '¿Reanudar sesión anterior?',
    resumeMessage: 'Se encontraron {count} cajas escaneadas por {name}. ¿Reanudar o empezar de nuevo?',
    resume: 'Reanudar',
    startFresh: 'Empezar de Nuevo',
    otherSupervisorWarning: '{name} está recibiendo esta transferencia. ¿Tomar el control?',
  },

  // Manager Approval Queue
  managerApproval: {
    title: 'Cola de Aprobación',
    subtitle: 'Revisar y aprobar artículos en espera',
    itemsPending: 'artículo(s) pendiente(s) de aprobación',
    noPendingItems: 'No hay artículos pendientes de aprobación',
    pendingApproval: 'Pendiente de Aprobación',
    itemNumber: 'Número de Artículo',
    itemName: 'Nombre del Artículo',
    transferNumber: 'Transferencia #',
    quantity: 'Cantidad',
    weight: 'Peso',
    holdReason: 'Razón de Retención',
    receivedBy: 'Recibido Por',
    receivedAt: 'Recibido El',
    notes: 'Notas',
    approve: 'Aprobar',
    reject: 'Rechazar',
    approveConfirm: '¿Aprobar este artículo para producción?',
    rejectConfirm: '¿Rechazar este artículo y devolver al almacén?',
    approvalNotes: 'Notas de aprobación (opcional)',
    rejectionNotes: 'Notas de rechazo (requerido)',
    rejectionNotesRequired: 'Por favor proporcione una razón para el rechazo',
    approved: 'Artículo aprobado exitosamente',
    rejected: 'Artículo rechazado exitosamente',
    approveError: 'Error al aprobar artículo',
    rejectError: 'Error al rechazar artículo',
    loadError: 'Error al cargar aprobaciones pendientes',
  },

  // Reports
  reports: {
    title: 'Reportes',
  },

  // End of Day Summary
  endOfDaySummary: {
    title: 'Resumen del Día',
    selectDate: 'Seleccionar Fecha',
    today: 'Hoy',
    previousDay: 'Día Anterior',
    nextDay: 'Día Siguiente',

    // Summary cards
    totalSessions: 'Total de Sesiones',
    completedSessions: 'Completadas',
    totalBoxes: 'Cajas Empacadas',
    voided: 'anuladas',
    totalWeight: 'Peso Total',
    waste: 'desperdicio',
    avgYield: 'Rendimiento Promedio',
    onTarget: 'En Meta',
    belowTarget: 'Bajo Meta',
    ofMaterial: 'del material',

    // Tabs
    byProduct: 'Productos',
    byStation: 'Estaciones',
    byWorker: 'Operadores',
    allSessions: 'Todas las Sesiones',
    wasteLog: 'Registro de Desperdicio',

    // Waste table
    session: 'Sesión',
    product: 'Producto',
    output: 'Producción',
    wastePercent: '% Desperdicio',
    totalWaste: 'Total Desperdicio',
    noWasteLogged: 'Sin desperdicio registrado para esta fecha',
    wasteBreakdown: 'Desglose de Desperdicio por Tipo',
    wasteBySession: 'Desperdicio por Sesión',

    // Table headers
    productSku: 'SKU',
    productItemNumber: 'Número de Artículo',
    productName: 'Producto',
    stationName: 'Estación',
    location: 'Ubicación',
    workerName: 'Trabajador',
    employeeNumber: 'No. Empleado',
    sessionsCount: 'Sesiones',
    boxesPacked: 'Cajas',
    weight: 'Peso',
    yield: 'Rendimiento',
    pace: 'Ritmo',
    paceUnit: 'lb/hr',
    activeHours: 'Horas Activas',
    status: 'Estado',
    sessionNumber: 'Sesión #',
    operators: 'Operadores',
    topPerformer: 'Mejor Rendimiento',
    createdAt: 'Creado',
    completedAt: 'Completado',

    // Alerts
    alerts: 'Alertas',
    noAlerts: 'Sin problemas detectados',
    alertLowYield: 'La sesión {{session}} tiene bajo rendimiento ({{pct}}%)',
    alertHighVoidRate: 'La sesión {{session}} tiene alta tasa de anulación ({{pct}}%)',
    alertIncompleteSessions: '{{count}} sesión(es) aún sin completar',
    alertByproductAging: '{{item}} ({{lbs}} lbs) - {{days}} días de antigüedad',
    lowYield: 'Bajo rendimiento',
    highVoidRate: 'Alta tasa de anulación',
    incompleteSessions: 'Sesiones incompletas',
    viewSession: 'Ver',

    // Export
    export: 'Exportar',
    print: 'Imprimir',
    downloadCsv: 'Descargar CSV',
    downloadPdf: 'Descargar PDF',
    pdfDownloadError: 'Error al descargar PDF',

    // Material Tracking
    rawMaterial: 'Materia Prima',
    materialTracking: 'Seguimiento de Materiales',
    initialRawMaterial: 'Material Inicial',
    finalProduct: 'Producto Final',
    actualWaste: 'Desperdicio Real',
    returnsAndByProducts: 'Devoluciones y Subproductos',
    materialUtilization: 'Utilización de Material',
    ofInitialMaterial: 'del material inicial',
    byMaterial: 'Por Material',
    allocated: 'Asignado',
    remainder: 'Sobrante',
    used: 'Usado',
    noMaterialData: 'Sin datos de material para esta fecha',
    noMaterialLotData: 'Sin datos de lotes de material',
    returns: 'Devoluciones',
    byProducts: 'Subproductos',

    // Empty states
    noData: 'Sin datos de producción para esta fecha',
    noSessions: 'No se encontraron sesiones',
    errorLoading: 'Error al cargar datos del resumen',

    // Transfer Out Summary
    transferOutSummary: 'Resumen de Transferencia',
    noTransferData: 'No hay datos de transferencia para esta fecha',
    expQty: 'Cant. Esp.',
    actQty: 'Cant. Real',
    expWeight: 'Peso Esp.',
    actWeight: 'Peso Real',
    rawMaterialsKpi: 'Materias Primas',
    expected: 'Esperado',
    received: 'Recibido',
    totalOutput: 'Salida Total',
    efficiency: 'Eficiencia',
    onHold: 'En Espera',
  },

  // Override History (Mobile)
  overrideHistory: {
    labelReprint: 'Reimpresión de Etiqueta',
    manualWeight: 'Peso Manual',
    sessionComplete: 'Sesión Completada',
    wasteRecord: 'Registro de Desperdicio',
    noOverrides: 'No se encontraron anulaciones para esta fecha',
  },

  // Warehouse Transfer Management
  warehouseTransfer: {
    title: 'Gestión de Transferencias de Almacén',
    subtitle: 'Crear y gestionar transferencias entre Way Fong y HTE',
    createTransfer: 'Crear Transferencia',
    editTransfer: 'Editar Transferencia',
    transferDetails: 'Detalles de Transferencia',
    transferList: 'Lista de Transferencias',
    transferNotFound: 'Transferencia no encontrada',
    direction: 'Dirección',
    wfToHte: 'Way Fong → HTE',
    hteToWf: 'HTE → Way Fong',
    wfToHteShort: 'WF → HTE',
    hteToWfShort: 'HTE → WF',
    status: 'Estado',
    draft: 'Borrador',
    pending: 'Pendiente',
    scanned: 'Escaneado',
    complete: 'Completado',
    cancelled: 'Cancelado',
    transferNumber: 'Número de Transferencia',
    transferDate: 'Fecha de Transferencia',
    requestDate: 'Fecha de Solicitud',
    warehouseFrom: 'Almacén Origen',
    warehouseTo: 'Almacén Destino',
    locationFrom: 'Ubicación Origen',
    locationTo: 'Ubicación Destino',
    locationUpdated: 'Ubicación de destino actualizada',
    locationUpdateError: 'Error al actualizar la ubicación de destino',
    clearCheckpointError: 'Error al borrar el progreso de escaneo anterior — es posible que vea un aviso de reanudación desactualizado',
    memo: 'Nota',
    requestBy: 'Solicitado Por',
    receiveBy: 'Recibido Por',
    createdBy: 'Creado Por',
    completedBy: 'Completado Por',
    completedAt: 'Completado En',
    lineItems: 'Artículos',
    addItem: 'Agregar Artículo',
    itemNumber: 'Número de Artículo',
    itemName: 'Nombre de Artículo',
    itemSearch: 'Buscar artículos...',
    quantityRequest: 'Cant. Solicitada',
    quantityShipped: 'Cant. Enviada',
    weightShipped: 'Peso Enviado',
    useSubUnit: 'Usar Sub Unidad',
    isFrozen: 'Congelado',
    dateCode: 'Código de Fecha',
    remark: 'Observación',
    unit: 'Unidad',
    brand: 'Marca',
    description: 'Descripción',
    noItems: 'No se han agregado artículos',
    weights: 'Pesos',
    addWeight: 'Agregar Peso',
    weight: 'Peso',
    weightLb: 'Peso (lb)',
    pieceWeights: 'Pesos por Pieza',
    noWeights: 'No se han registrado pesos',
    submit: 'Enviar',
    markComplete: 'Marcar Completo',
    cancelTransfer: 'Cancelar Transferencia',
    downloadPdf: 'Descargar PDF',
    print: 'Imprimir',
    printPdf: 'Imprimir PDF',
    receiveTransfer: 'Recibir Transferencia',
    receive: 'Recibir',
    saveAsDraft: 'Guardar como Borrador',
    confirmCancel: '¿Está seguro de que desea cancelar esta transferencia?',
    confirmDelete: '¿Eliminar esta transferencia borrador?',
    deleteSuccess: 'Transferencia eliminada',
    confirmComplete: '¿Marcar esta transferencia como completada? Esta acción no se puede deshacer.',
    confirmSubmit: '¿Enviar esta transferencia? Cambiará de borrador a pendiente.',
    confirmDeleteItem: '¿Eliminar este artículo de la transferencia?',
    totalTransfers: 'Total de Transferencias',
    drafts: 'Borradores',
    pendingTransfers: 'Pendientes',
    pendingTransferBacks: 'Devoluciones Pendientes',
    completedTransfers: 'Completadas',
    lines: 'Líneas',
    created: 'Creado',
    noTransfers: 'No se encontraron transferencias',
    noTransfersDesc: 'Cree una nueva transferencia de almacén para comenzar.',
    allDirections: 'Todas las Direcciones',
    dateRange: 'Rango de Fechas',
    searchPlaceholder: 'Buscar por número de transferencia o nota...',
    pdfTitle: 'WAREHOUSE TRANSFER',
    pdfTitleCn: '存貨倉庫轉移',
    pdfPage: 'Página',
    pdfDate: 'Fecha',
    pdfRequestDate: 'Fecha de Solicitud',
    pdfTransferNo: 'No. de Transferencia',
    pdfRequestedBy: 'Solicitado Por',
    pdfReceivedBy: 'Recibido Por',
    pdfFrom: 'ORIGEN',
    pdfTo: 'DESTINO',
    pdfSubtotal: 'Subtotal',
    pdfSignature: 'Firma',
    directionRequired: 'Por favor seleccione una dirección',
    warehouseFromRequired: 'Almacén Origen es requerido',
    warehouseToRequired: 'Almacén Destino es requerido',
    itemRequired: 'Por favor seleccione un artículo',
    weightPositive: 'El peso debe ser un número positivo',
    cannotEditNonDraft: 'Solo se pueden editar transferencias en estado borrador',
    needLineItems: 'La transferencia debe tener al menos un artículo',
    createSuccess: 'Transferencia creada exitosamente',
    updateSuccess: 'Transferencia actualizada exitosamente',
    cancelSuccess: 'Transferencia cancelada',
    completeSuccess: 'Transferencia marcada como completada',
    submitSuccess: 'Transferencia enviada',
    itemAdded: 'Artículo agregado a la transferencia',
    itemUpdated: 'Artículo actualizado',
    itemRemoved: 'Artículo eliminado de la transferencia',
    weightAdded: 'Registro de peso agregado',
    weightRemoved: 'Registro de peso eliminado',

    // Report tab
    transfersTab: 'Transferencias',
    transfersInTab: 'Transferencias de Entrada',
    transferBacksTab: 'Devoluciones / Producción',
    reportTab: 'Reporte',
    reportTitle: 'Reporte de Transferencias',
    reportSubtitle: 'Reporte a nivel de detalle de transferencias completadas',
    dateFrom: 'Fecha Desde',
    dateTo: 'Fecha Hasta',
    itemFrom: 'Artículo Desde',
    itemTo: 'Artículo Hasta',
    brandFilter: 'Marca',
    warehouseFromFilter: 'Almacén Origen',
    warehouseToFilter: 'Almacén Destino',
    searchReport: 'Buscar',
    exportCsv: 'Exportar CSV',
    transferFrom: 'Transferencia Desde',
    qty: 'Cant.',
    totalItems: 'Total Artículos',
    totalQty: 'Total Cantidad',
    totalWeight: 'Total Peso',
    noReportData: 'No se encontraron datos. Ajuste los filtros y busque nuevamente.',
    reportDateRequired: 'El rango de fechas es obligatorio para buscar el reporte.',

    // ICS Transfers tab
    icsTransfersTab: 'Transferencias VB6',
    searchType: 'Buscar por',
    searchByWarehouse: 'Código de Almacén',
    searchByTransferNo: 'No. de Transferencia',
    searchByRequestDate: 'Fecha de Solicitud',
    searchByTransferDate: 'Fecha de Transferencia',
    searchByHte: 'Transferencias HTE',
    searchByPending: 'Solicitudes Pendientes',
    selectWarehouse: 'Seleccionar almacén...',
    selectLocation: 'Seleccionar ubicación...',
    searchIcs: 'Buscar',
    allLocations: 'Todas las Ubicaciones',
    allStatuses: 'Todos',
    itemCodeFilter: 'Código de Artículo',
    itemCodePlaceholder: 'Filtrar por código de artículo...',
    transferNumberSearch: 'Transfer #',
    transferNumberPlaceholder: 'Buscar transfer #...',
    icsTransferDetails: 'Detalle de Transferencia',
    itemCount: 'Artículos',
    noIcsResults: 'No se encontraron transferencias',
    enterSearchValue: 'Ingrese valor de búsqueda',
    frozen: 'Congelado',
    backToResults: 'Volver a Búsqueda',
    packing: 'Empaque',
    weightsCount: 'Pesos',
    itemsFound: 'Registros encontrados',
    goToRecord: 'Ir al registro',
    searchTitle: 'Buscar Registro de Transferencia de Almacén',
    operator: 'Operador',
    dateTimeRequested: 'Fecha/Hora Solicitada',
    totalWeightLabel: 'Peso Total',
    from: 'Origen',
    to: 'Destino',
    today: 'Hoy',
    week: '1 Semana',
    month: 'Mes',
    completeCheck: 'Completo',
    specialRequest: 'Especial',
    newTransfer: 'Nueva Transferencia',
    saveAndSubmit: 'Guardar y Enviar',
    savingTransfer: 'Guardando...',
    backToList: 'Volver a la Lista',
    searchItemPlaceholder: 'Buscar por número o nombre de artículo...',

    // Transfer detail form
    selectItemToEdit: 'Haga clic en una fila de artículo para ver/editar sus detalles',
    additionalDetails: 'Detalles Adicionales',
    avgSold: 'Prom. Vendido',
    avgBack: 'Prom. Devuelto',
    qsType: 'Tipo QS',
    duration: 'Duración',
    scanComplete: 'Escaneo Completo',
    qsPend: 'QS Pendiente',
    qsRecNumber: 'QS Reg. #',
    salespersonQs1: 'Vendedor QS1',
    qItem: 'Q-Artículo',
    findItem: 'Buscar...',
    searchItems: 'Buscar Artículos',
    cs: 'CS',
    pc: 'PC',
    noSearchResults: 'No se encontraron artículos',
  },

  // Planificación de Producción
  planning: {
    title: 'Planificación Semanal de Producción',
    planMode: 'Modo Planificación',
    viewMode: 'Modo Vista',
    addRow: 'Agregar Fila',
    savePlan: 'Guardar Plan',
    date: 'Fecha',
    productSku: 'SKU Producto',
    productName: 'Nombre del Producto',
    packing: 'Empaque',
    cases: 'Cajas',
    estProductionLbs: 'Lbs Est. Producción',
    material: 'Material',
    materialName: 'Nombre del Material',
    supplierBrand: 'Proveedor/Marca',
    location: 'Ubicación',
    fulfillment: 'Estado de Materiales',
    stockWarning: 'Alerta de Stock',
    yieldFactor: 'Factor de Rendimiento',
    required: 'Requerido',
    available: 'Disponible',
    shortfall: 'Faltante',
    transferPending: 'Transferencia Pendiente',
    fulfilled: 'Completo',
    partial: 'Parcial',
    unfulfilled: 'Sin Asignar',
    pending: 'Pendiente',
    notRequired: 'N/A',
    noProductSelected: 'Seleccione un producto',
    sessionCreated: 'Sesión de plan creada',
    sessionsFailed: 'Error al crear sesión de plan',
    removeRow: 'Eliminar fila',
    selectProduct: 'Seleccionar producto...',
    autoResolved: 'Resuelto automáticamente desde insumos del producto',
    planOnlySession: 'Solo plan (sin asignación de material)',
    materialFulfillment: 'Estado de Material',
    listView: 'Lista',
    calendarView: 'Calendario',
    oneDay: 'Día',
    oneWeekShort: 'Sem',
    oneWeek: '1 Sem',
    twoWeek: '2 Sem',
    month: 'Mes',
    today: 'Hoy',
    more: 'más',
    legend: 'Leyenda',
    statusPending: 'Pendiente',
    statusSubmitted: 'Enviado',
    statusReceived: 'Recibido',
    statusPlanned: 'Enviado', // legacy alias (WCO-2146)
    statusReady: 'Listo',
    statusActive: 'Activo',
    statusPaused: 'Pausado',
    statusCompleted: 'Completado',
    statusCancelled: 'Cancelado',
    finishedProduct: 'Producto Terminado',
    rawMaterial: 'Materia Prima',
    viewFullDetails: 'Ver Detalles Completos',
    productInfo: 'Información del Producto',
    materialInfo: 'Información del Material',
  },

  // Transferencia Diaria de Salida
  dailyTransferOut: {
    title: 'Transferencia Diaria de Salida',
    finishedProducts: 'Productos Terminados',
    finishedProductsNotIntact: 'Productos Terminados no intactos',
    finishedNotIntactBadge: 'No Intacto',
    // WCO-2623: supervisor Reprint override
    reprint: 'Reimprimir',
    reprintOverrideTooltip: 'Reimprimir esta etiqueta — reemplaza la actual',
    reprintDialogTitle: 'Reimprimir etiqueta',
    reprintDialogBody: '¿Reimprimir la etiqueta de {{item}}? Esto reemplaza la etiqueta actual — la anterior dejará de ser válida.',
    reprintReasonLabel: 'Motivo',
    reprintReasonPlaceholder: 'p. ej. etiqueta extraviada',
    reprintConfirm: 'Reimprimir y reemplazar',
    reprinting: 'Reimprimiendo…',
    reprintSuccess: 'Etiqueta reimpresa',
    reprintFailed: 'Error al reimprimir la etiqueta',
    niLabelsAlreadyPrinted: 'Etiquetas ya impresas',
    niLabelsPrinted: 'Se imprimieron {{count}} etiqueta(s)',
    niLabelsPrintFailed: 'Error al imprimir etiquetas',
    rejectedMaterials: 'Materiales Rechazados',
    remainingMaterials: 'Material Restante Disponible',
    remainderProducedToday: 'Remanente de Hoy',
    expectedQty: 'Cant. Est.',
    expectedWeight: 'Peso Est.',
    actualQty: 'Cant. Real',
    actualWeight: 'Peso Real',
    variance: 'Var. Rendimiento',
    source: 'Origen',
    refreshActuals: 'Actualizar Reales',
    finalizeTransferOut: 'Finalizar Transferencia de Salida',
    submitTransfer: 'Enviar Transferencia',
    confirmSubmit: 'Esto creará el documento de transferencia ICS y lo hará visible para el almacén. ¿Continuar?',
    submitSuccess: 'Transferencia enviada exitosamente',
    submitFailed: 'Error al enviar la transferencia',
    outputDestinations: 'Destinos de Salida',
    destination: 'Destino',
    expectedCases: 'Esperado',
    actualCases: 'Real',
    casesVariance: 'Variación',
    tombstoned: 'Cancelado',
    unscannedBoxesWarning: 'caja(s) sin escanear a un destino — escanéalas antes de enviar',
    allBoxesScanned: 'Todas las cajas producidas escaneadas a un destino',
    outputLabel: 'Salida',
    transferLabel: 'Transferencia',
    noTransferForDay: 'Aún no hay documento de transferencia para este día.',
    transferNotSubmittedYet: 'Esta transferencia aún no se ha enviado — escanee cajas y luego envíela para generar su documento.',
    selectTransfer: 'Transferencia:',
    noOutputForDay: 'Aún no hay producción para este día.',
    outputNoRecordYet: 'Esta producción aún no tiene registro — se crea al enviar la salida.',
    selectOutput: 'Salida:',
    newTransferBack: 'Nueva Transferencia de Salida',
    newLabel: 'Nuevo',
    typeLabel: 'Tipo',
    selectDestination: 'Seleccionar destino',
    create: 'Crear',
    transferCreated: 'Transferencia creada',
    outputCreated: 'Salida creada',
    createFailed: 'Error al crear',
    rawMaterialTransfer: 'Transferir',
    newRawMaterialTransfer: 'Nueva Transferencia de Materia Prima',
    noRawMaterialsToTransfer: 'No hay materias primas para transferir',
    createTransfer: 'Crear Transferencia',
    rawTransferCreated: 'Transferencia de materia prima creada',
    rawTransferFailed: 'Error al crear la transferencia de materia prima',
    incompleteSessionsWarning: 'No se puede finalizar — algunas sesiones de producción no están completadas',
    status: 'Estado',
    type: 'Tipo',
    prePopulated: 'Pre-llenado',
    actualsWithinTolerance: 'Dentro de Tolerancia',
    varianceWarning: 'Alerta de Variación',
    finalized: 'Enviado',
    notShipped: 'No Enviado',
    complete: 'Completo',
    noDataForDate: 'Sin datos de transferencia para esta fecha',
    confirmFinalize: '¿Está seguro de finalizar esta transferencia diaria de salida?',
    finalizeSuccess: 'Transferencia diaria de salida finalizada exitosamente',
    pdfDownloadFailed: 'Error al descargar el PDF de transferencia',
    downloadTransferPdf: 'Descargar PDF de transferencia',
    finalizeFailed: 'Error al finalizar la transferencia diaria de salida',
    refreshSuccess: 'Valores reales actualizados exitosamente',
    refreshFailed: 'Error al actualizar valores reales',
    noItemsToRefresh: 'No hay elementos para actualizar — complete una sesión primero',
    autoGenerated: 'Auto-generado',
    manual: 'Manual',
    dailyOut: 'Transferencia de Regreso',
    sourceFilter: 'Filtro de Origen',
    linkedSessions: 'Sesiones Vinculadas',
    itemNumber: 'No. Art.',
    itemName: 'Nombre del Artículo',
    category: 'Categoría',
    notes: 'Notas',
    expectedYF: 'YF Est.',
    actualYF: 'YF Real',
    estimate: 'Estimado',
    completed: 'Completado',
    rejected: 'Rechazado',
    remainder: 'Restante',
    byProduct: 'Subproducto',
    byProducts: 'Subproductos',
    byProductMarketable: 'Comercializable',
    byProductProduction: 'Para Produccion',
    packing: 'Empaque',
    tabSummary: 'Resumen de Producción',
    tabTransferDetail: 'Detalle de Transferencia',
    tabOutputDetail: 'Detalle de Producción',
    transfer: 'Transferir',
    excludeFailed: 'Error al actualizar la exclusión',
    reserve: 'Reserva',
    casesRow: 'Cajas',
    bufferRow: 'Búfer',
  },

  // Box Search
  boxSearch: {
    title: 'Búsqueda de Cajas',
    subtitle: 'Buscar y filtrar cajas de productos terminados',
    filters: 'Filtros',
    item: 'Artículo',
    selectItem: 'Seleccionar artículo...',
    allItems: 'Todos los Artículos',
    dateCode: 'Código de Fecha',
    dateCodePlaceholder: 'ej., 26037',
    packedFrom: 'Empacado Desde',
    packedTo: 'Empacado Hasta',
    location: 'Ubicación',
    selectLocation: 'Seleccionar ubicación...',
    allLocations: 'Todas las Ubicaciones',
    includeVoided: 'Incluir Anuladas',
    search: 'Buscar',
    exportExcel: 'Exportar Excel',
    print: 'Imprimir',
    summary: 'Resumen',
    totalBoxes: 'Total de Cajas',
    totalWeight: 'Peso Total',
    boxNumber: 'Número de Caja',
    itemNumber: 'No. de Artículo',
    productName: 'Nombre del Producto',
    weight: 'Peso',
    packedAt: 'Empacado En',
    operator: 'Operador',
    packer: 'Empacador',
    packedBy: 'Empacado Por',
    status: 'Estado',
    session: 'Sesión',
    station: 'Estación',
    noResults: 'No se encontraron cajas con los criterios seleccionados',
    lbs: 'lbs',
    barcode: 'Código de Barras',
    clearFilters: 'Limpiar',
  },

  // Yield Variance Report
  yieldVariance: {
    title: 'Reporte de Variación de Rendimiento',
    description: 'Sesiones con ±1% o más de variación de rendimiento respecto al esperado',
    fetchError: 'Error al cargar datos de variación de rendimiento',
    totalVariances: 'Total de Variaciones',
    overYield: 'Sobre Rendimiento',
    underYield: 'Bajo Rendimiento',
    avgVariance: 'Variación Promedio',
    startDate: 'Fecha Inicio',
    endDate: 'Fecha Fin',
    operator: 'Operador',
    station: 'Estación',
    varianceType: 'Tipo de Variación',
    allVariances: 'Todas las Variaciones',
    overYieldOnly: 'Solo Sobre Rendimiento',
    underYieldOnly: 'Solo Bajo Rendimiento',
    noData: 'No se encontraron registros de variación de rendimiento',
    session: 'Sesión',
    product: 'Producto',
    variance: 'Variación',
    lfExpected: 'LF Esperado',
    lfActual: 'LF Real',
    lfVariance: 'LF Variación',
    needsReview: 'Requiere revisión',
    anomalyTooltip: 'El factor de mano de obra real se desvía ±20% del estándar',
    observedThroughput: 'Rendimiento (lb/h-trab)',
    productiveTime: 'Tiempo Productivo',
    workers: 'Trabajadores',
    throughputLabour: 'Rendimiento y Mano de Obra',
    throughputCalc: {
      title: 'Rendimiento (lb/h-trab) — cómo se calcula',
      output: 'Salida',
      productiveTime: 'Tiempo productivo',
      hrs: 'h',
      workers: 'Trabajadores',
      step1: 'Paso 1 — tasa por trabajador = salida ÷ h ÷ trabajadores',
      perWorkerHour: 'lb por hora-trabajador',
      step2: 'Paso 2 — × tamaño estándar de cuadrilla (2)',
      why: '÷trabajadores da una tasa honesta por persona; ×2 la lleva a la base estándar de 2 trabajadores, de modo que una cuadrilla en estándar obtiene FM ≈ 1.0 con cualquier número de personas.',
      notMeasurable: 'No medible — faltan salida, número de trabajadores o tiempo productivo para esta producción.',
      roundingNote: 'Los valores se redondean para mostrarlos; el resultado se calcula con precisión completa, por lo que volver a multiplicar a mano los números de 2 decimales mostrados puede diferir en ~0.01.',
    },
    rawMaterial: 'Materia Prima',
    inputWeight: 'Peso de Entrada',
    outputWeight: 'Peso de Salida',
    carryover: 'Arrastre',
    targetWeight: 'Peso Objetivo',
    wasteBreakdown: 'Desglose de Desperdicio',
    approvedBy: 'Aprobado Por',
    suggestionsTitle: 'Variaciones de Rendimiento Recurrentes',
    suggestionsDescription: 'material(es) tienen variaciones de rendimiento recurrentes — revise las actualizaciones sugeridas',
    suggestionsLoading: 'Verificando variaciones recurrentes...',
    suggestionsError: 'Error al cargar sugerencias',
    finishedProduct: 'Producto Terminado',
    currentYield: 'Rendimiento Actual',
    suggestedYield: 'Rendimiento Sugerido',
    occurrences: 'Ocurrencias',
    lastOccurrence: 'Última Ocurrencia',
    recentHistory: 'Historial de Variaciones Recientes',
    yieldSource: 'Fuente',
    hideSuggestions: 'Ocultar',
    showSuggestions: 'Revisar',
    // i18n parity — keys present in en.ts, previously untranslated in es
    date: 'Fecha',
    expectedYield: 'Esperado',
    actualYield: 'Real',
    weightDetails: 'Detalles de Peso',
    noWasteData: 'No se registraron datos de merma',
    approvalDetails: 'Detalles de Aprobación',
    approvedAt: 'Aprobado En',
    reason: 'Motivo',
    overrideNoDetails: 'Finalización con anulación (sin detalles de aprobación)',
    noApprovalRequired: 'No se requiere aprobación',
    wasteTypes: {
      byProduct: 'Subproducto',
      byProductMarketable: 'Subproducto (Comercializable)',
      byProductProduction: 'Subproducto (Usado para Producción)',
      disposable: 'Desperdicio Desechable',
      waterLiquid: 'Pérdida de Agua / Líquido',
      humanError: 'Error Humano',
      remainderIntact: 'Sobrante (Intacto)',
      remainderNotIntact: 'Sobrante - No Intacto',
      finishProductNotIntact: 'Producto Terminado - No Intacto',
    },
  },

  // Work Schedule
  workSchedule: {
    title: 'Horario de Trabajo',
    weeklySchedule: 'Horario de Trabajo Semanal',
    employee: 'Empleado',
    operators: 'Operadores',
    packers: 'Empacadores',
    stations: 'Estaciones',
    activeStations: 'Estaciones Activas',
    off: 'Libre',
    cutRole: 'Operador (CUT)',
    packRole: 'Empacador (PACK)',
    stationActive: 'Estación Activa',
    copyToNextWeek: 'Copiar a la Próxima Semana',
    unsavedChanges: 'Tiene cambios sin guardar',
    loadError: 'Error al cargar el horario',
    saveSuccess: 'Horario guardado exitosamente',
    saveError: 'Error al guardar el horario',
    copySuccess: 'Se copiaron {{count}} asignaciones a la próxima semana',
    copyError: 'Error al copiar el horario',
    summary: 'Resumen',
  },

  // Approval History Report
  approvalHistory: {
    title: 'Historial de Aprobaciones',
    subtitle: 'Registro de auditoría de aprobaciones y rechazos de artículos en espera',
    dateRange: 'Rango de Fechas',
    dateFrom: 'Desde',
    dateTo: 'Hasta',
    actionFilter: 'Acción',
    searchPlaceholder: 'Buscar por # de artículo o nombre...',
    date: 'Fecha',
    itemNumber: 'Artículo #',
    itemName: 'Nombre del Artículo',
    transferNumber: 'Transferencia #',
    quantity: 'Cant.',
    weight: 'Peso',
    holdReason: 'Razón de Retención',
    action: 'Acción',
    manager: 'Gerente',
    receivedBy: 'Recibido Por',
    receivedAt: 'Recibido El',
    notes: 'Notas',
    approved: 'Aprobado',
    rejected: 'Rechazado',
    all: 'Todos',
    noRecords: 'No se encontró historial de aprobaciones',
    noRecordsDesc: 'No hay registros de aprobación o rechazo que coincidan con sus filtros.',
    holdReasons: {
      temperature: 'Temperatura',
      damaged: 'Dañado',
      wrong_quantity: 'Cantidad Incorrecta',
      quality: 'Calidad',
      expiration: 'Vencimiento',
      other: 'Otro',
    },
  },

  // Item Summary Report
  itemSummaryReport: {
    title: 'Informe Resumen de Artículos',
    rawMaterials: 'Materias Primas',
    finishedProducts: 'Productos Terminados',
    itemNumber: 'Artículo #',
    itemName: 'Nombre',
    brand: 'Marca',
    location: 'Ubicación',
    yieldFactor: 'Factor de Rendimiento',
    laborFactor: 'Factor de Mano de Obra',
    lastUsed: 'Último Uso',
    lastProduced: 'Última Producción',
    materials: 'Materiales',
    search: 'Buscar por artículo # o nombre...',
    allBrands: 'Todas las Marcas',
    allLocations: 'Todas las Ubicaciones',
    startDate: 'Fecha de Inicio',
    endDate: 'Fecha de Fin',
    noData: 'No se encontraron artículos',
    noDataHint: 'Intenta ajustar los filtros',
    laborPlaceholder: 'Próximamente',
    source: 'Fuente',
    expandMaterials: 'Mostrar materiales',
    collapseMaterials: 'Ocultar materiales',
    page: 'Página',
    of: 'de',
    showing: 'Mostrando',
    items: 'artículos',
  },

  // Clock In Modal (from Daily Queue row click)
  clockInModal: {
    title: 'Fichar en Sesión',
    subSessionInfo: 'Info de Sub-Sesión',
    scanBadge: 'Escanear Credencial',
    scanBadgeHint: 'Escanee credencial o ingrese número de empleado manualmente',
    enterManually: 'O ingrese manualmente:',
    badgePlaceholder: 'Número de empleado...',
    lookingUp: 'Buscando empleado...',
    selectRole: 'Seleccionar Rol',
    operator: 'Operador',
    packer: 'Empacador',
    clockIn: 'Fichar',
    clockingIn: 'Fichando...',
    currentAssignments: 'Asignaciones Actuales',
    notAssigned: 'No asignado',
    since: 'desde',
    noStation: 'No hay estación asignada a esta sub-sesión',
    sessionNotActive: 'Esta sesión no puede aceptar fichajes (estado: {status})',
    employeeFound: 'Empleado encontrado',
    relieveConfirm: '¿Relevar a {name}?',
    relieveDescription: '{name} está trabajando actualmente como {role}. Se le fichará la salida.',
    yesRelieve: 'Sí, Relevar y Fichar',
    alreadyHere: 'Ya fichado en esta sesión',
    transferConfirm: '¿Transferir desde {station}?',
    transferDescription: 'Actualmente fichado en {station} como {role}. ¿Transferir aquí?',
    yesTransfer: 'Sí, Transferir',
    alreadyHerePrompt: '¿Qué desea hacer?',
    scanOut: 'Escanear Salida',
    takeBreak: 'Tomar Descanso',
    scanOutSuccess: 'Salida exitosa',
    breakStarted: 'Descanso iniciado',
    currentlyAs: 'Actualmente escaneado como',
    onBreak: 'En descanso',
    success: 'Escaneo exitoso',
    error: 'Error al fichar',
    errorSessionPlanned: 'La sesión no está lista — asigne un operador y empacador primero',
    errorSessionCompleted: 'Esta sesión ya ha sido completada',
    errorSessionCancelled: 'Esta sesión ha sido cancelada',
    errorNoActiveSession: 'No hay sesión activa en esta estación',
    materialsNotReceived: 'Las materias primas para la sub-sesión {subSessionNumber} aún no han sido recibidas. La producción no puede comenzar.',
    awaitingAssignment: 'La transferencia para la sub-sesión {subSessionNumber} ha sido recibida, pero la sub-sesión está esperando la asignación de Operador/Empacador.',
    scheduledFuture: 'La sub-sesión {subSessionNumber} está programada para una fecha futura y aún no puede iniciarse.',
  },

  // Mapeo de Subproductos a Materia Prima
  byproductMapping: {
    title: 'Mapeo de Subproductos',
    subtitle: 'Vincular subproductos a sus materias primas de origen',
    selectRawMaterial: 'Seleccionar materia prima',
    searchRawMaterials: 'Buscar materias primas...',
    linkedByproducts: 'Subproductos Vinculados',
    noByproductsLinked: 'No hay subproductos vinculados aún',
    addByproduct: 'Agregar Subproducto',
    removeByproduct: 'Eliminar subproducto',
    confirmRemove: '¿Eliminar?',
    mappingCreated: 'Subproducto vinculado exitosamente',
    mappingDeleted: 'Subproducto desvinculado exitosamente',
    searchItems: 'Buscar artículos...',
    notes: 'Notas',
    noResults: 'No se encontraron resultados',
    alreadyLinked: 'Todos los artículos coincidentes ya están vinculados',
    existingLinkages: 'Vínculos Existentes',
    byproductCount: '{{count}} subproducto(s)',
    noMappingsYet: 'No se han creado vínculos aún',
    productMappingTitle: 'Mapeo de Productos',
    byproductTab: 'Mapeo de Subproductos',
    inputOutputTab: 'Mapeo Entrada / Salida',
    packingMaterialTab: 'Mapeo de Material de Empaque',
    comingSoon: 'Próximamente',
    comingSoonDescription: 'Esta función está en desarrollo y estará disponible pronto.',
    inputOutputDescription: 'Definir qué materias primas se utilizan para producir cada producto terminado. Este mapeo se usará para la planificación de producción y requerimientos de materiales.',
    packingMaterialDescription: 'Vincular materiales de empaque (cajas, bolsas, etiquetas) a sus productos asociados. Este mapeo se usará para los requerimientos de empaque y planificación de inventario.',
  },

  // Mapeo Entrada / Salida
  inputOutputMapping: {
    subtitle: 'Ver qué materias primas se utilizan para producir cada producto terminado HTE (desde ICS)',
    selectProduct: 'Seleccionar un producto',
    searchProducts: 'Buscar productos...',
    noResults: 'No se encontraron resultados',
    selectProductPrompt: 'Seleccione un producto de la lista para ver sus materias primas',
    rawMaterials: 'Materias Primas',
    noRawMaterials: 'No se encontraron materias primas para este producto',
    itemNumber: 'N.° Artículo',
    name: 'Nombre',
    yieldFactor: 'Rendimiento',
    laborFactor: 'Mano de Obra',
    batchSize: 'Tamaño de Lote',
    teamSize: 'Tamaño de Equipo',
    comments: 'Comentarios',
    addRawMaterial: 'Agregar Materia Prima',
    searchRawMaterials: 'Buscar materias primas...',
    preference: 'Preferencia #',
    alreadyLinked: 'Ya vinculado',
    mappingCreated: 'Materia prima vinculada exitosamente',
  },

  // Gestión del Factor de Mano de Obra (modelo basado en estándar, WCO-2474)
  labourFactor: {
    tabTitle: 'Factor de Mano de Obra',
    subtitle: 'Establezca el rendimiento estándar de SALIDA (lb/h para un equipo de 2 trabajadores, rendimiento ya incluido) para cada materia prima de un producto. El Factor de Mano de Obra se deriva automáticamente.',
    selectProduct: 'Seleccionar un producto',
    searchProducts: 'Buscar productos...',
    selectProductPrompt: 'Seleccione un producto de la lista para establecer sus factores de mano de obra',
    noResults: 'No se encontraron resultados',
    materials: 'Materias Primas',
    noMaterials: 'No se encontraron materias primas para este producto',
    itemNumber: 'N.° Artículo',
    name: 'Nombre',
    throughput: 'lb/h (2-equipo)',
    allowance: 'Margen %',
    labourFactor: 'Factor de Mano de Obra',
    baseline: 'Referencia',
    noBaselineHint: 'Aún no se ha seleccionado una referencia — elija un insumo como referencia para derivar los factores de mano de obra.',
    baselineNeedsThroughput: 'Establezca el lb/h de este insumo antes de convertirlo en la referencia.',
    invalidThroughput: 'Ingrese un número positivo o borre el campo para desactivarlo.',
    saved: 'Rendimiento guardado',
    allowanceSaved: 'Margen guardado',
    invalidAllowance: 'Ingrese un porcentaje entre 0 y 100.',
    baselineSet: 'Referencia actualizada',
    saveFailed: 'Error al guardar',
    history: 'Historial',
    historyTitle: 'Historial de cambios',
    historyEmpty: 'Aún no hay cambios registrados',
    historyLoading: 'Cargando…',
    historyThroughput: 'lb/h',
    historyBaselineSet: 'Establecido como referencia',
    historyBaselineUnset: 'Quitado como referencia',
    close: 'Cerrar',
  },

  // Mapeo de Material de Empaque
  packingMaterialMapping: {
    title: 'Mapeo de Material de Empaque',
    subtitle: 'Vincular materiales de empaque (cajas, etiquetas, bolsas) a productos terminados HTE',
    defaultAllProducts: 'Predeterminado (Todos los Productos)',
    selectProduct: 'Seleccionar un producto',
    searchProducts: 'Buscar productos...',
    linkedPackingMaterials: 'Materiales de Empaque Vinculados',
    noPackingMaterialsLinked: 'No hay materiales de empaque vinculados aún',
    addPackingMaterial: 'Agregar Material de Empaque',
    removePackingMaterial: 'Eliminar material de empaque',
    confirmRemove: '¿Eliminar?',
    mappingCreated: 'Material de empaque vinculado exitosamente',
    mappingDeleted: 'Material de empaque desvinculado exitosamente',
    searchItems: 'Buscar materiales de empaque...',
    notes: 'Notas',
    noResults: 'No se encontraron resultados',
    alreadyLinked: 'Todos los artículos coincidentes ya están vinculados',
    existingLinkages: 'Vínculos Existentes',
    packingMaterialCount: '{{count}} material(es) de empaque',
    noMappingsYet: 'No se han creado vínculos aún',
    level_case: 'Por Caja',
    level_subunit: 'Por Sub-unidad',
    qtyPerBox: 'Cant. por caja',
    packingMaterials: 'Materiales de Empaque',
    qtyNeeded: 'Necesario',
    qtyToTransfer: 'Transferir',
    available: 'Disponible',
    stockSufficient: 'Stock suficiente',
    stockInsufficient: 'Stock insuficiente',
  },

  // Gestión de Usuarios (Supervisores gestionando operadores)
  userManagement: {
    title: 'Gestión de Usuarios',
    subtitle: 'Gestionar cuentas de operadores',
    addOperator: 'Agregar Operador',
    selectEmployee: 'Seleccionar Empleado',
    searchEmployees: 'Buscar empleados...',
    searchOperators: 'Buscar operadores...',
    noEmployeesAvailable: 'No hay empleados disponibles para agregar',
    noOperators: 'No se encontraron operadores',
    userAdded: 'Operador agregado exitosamente',
    userUpdated: 'Usuario actualizado exitosamente',
    generatedPassword: 'Contraseña',
    userDeleted: 'Operador eliminado exitosamente',
    employeeNumber: 'Empleado #',
    username: 'Usuario',
    fullName: 'Nombre Completo',
    lastModified: 'Última Modificación',
    createdAt: 'Creado',
    name: 'Nombre',
    email: 'Correo Electrónico',
    active: 'Activo',
    inactive: 'Inactivo',
    activate: 'Activar',
    deactivate: 'Desactivar',
    confirmDelete: 'Eliminar Usuario',
    deleteWarning: '¿Está seguro que desea eliminar a {{name}}? Esta acción no se puede deshacer.',
    defaultPasswordNote: 'La contraseña por defecto será el número de empleado. El operador debe cambiarla en su primer inicio de sesión.',
    userId: 'ID de Usuario',
    userIdPlaceholder: 'Ingrese ID de usuario...',
    userIdTooShort: 'El ID de usuario debe tener al menos 3 caracteres',
    userIdTaken: 'El ID de usuario ya está en uso',
    passwordFromUserId: 'La contraseña por defecto será el ID de Usuario + un número aleatorio de 4 dígitos. El operador debe cambiarla en su primer inicio de sesión.',
    userDetails: 'Detalles del Usuario',
    editUser: 'Editar Usuario',
    password: 'Contraseña',
    showPassword: 'Mostrar contraseña',
    hidePassword: 'Ocultar contraseña',
    enterNewPassword: 'Ingrese nueva contraseña...',
    enterNewPasswordHint: 'Ingrese una nueva contraseña y haga clic en el botón de edición para guardar.',
    confirmPasswordChange: 'Cambiar Contraseña',
    confirmPasswordChangeMessage: '¿Está seguro que desea cambiar la contraseña de este usuario?',
    newPassword: 'Nueva contraseña',
    passwordSaved: 'Contraseña guardada exitosamente',
    passwordEncrypted: 'La contraseña está encriptada',
  },

  icsUserManagement: {
    title: 'Acceso de Usuarios ICS',
    subtitle: 'Habilitar empleados ICS para acceder al sistema de producción',
    searchPlaceholder: 'Buscar por nombre, ID de usuario o # de empleado...',
    noResults: 'No se encontraron usuarios',
    userId: 'ID de Usuario',
    name: 'Nombre',
    employeeNum: 'Empleado #',
    icsRole: 'Rol ICS',
    prodRole: 'Rol Producción',
    active: 'Activo',
    disabled: 'Deshabilitado',
    notEnabled: 'No Habilitado',
    icsDisabled: 'Deshabilitado en ICS',
    pendingPassword: 'Contraseña Pendiente',
    enable: 'Habilitar',
    disable: 'Deshabilitar',
    reEnable: 'Rehabilitar',
    enableUser: 'Habilitar Usuario',
    userCreated: 'Cuenta de Usuario Creada',
    userEnabled: 'Usuario habilitado exitosamente',
    statusUpdated: 'Estado actualizado',
    assignRole: 'Asignar Rol de Producción',
    tempPassword: 'Contraseña Temporal',
    tempPasswordInfo: 'Comparta esta contraseña temporal con el usuario. Deberán establecer una nueva contraseña en su primer inicio de sesión.',
    tempPasswordNote: 'Esta contraseña solo se mostrará una vez. Asegúrese de anotarla o compartirla con el usuario.',
    addUser: 'Agregar Usuario',
    allEnabled: 'Todos los empleados ICS han sido habilitados',
    deleteUser: 'Eliminar Usuario',
    deleteWarning: '¿Está seguro de que desea eliminar permanentemente la cuenta de producción de {{name}}? Esto eliminará sus credenciales de inicio de sesión y no se puede deshacer.',
    userDeleted: 'Cuenta de usuario eliminada',
    changeRole: 'Haga clic para cambiar el rol',
    roleUpdated: 'Rol actualizado exitosamente',
    resetPassword: 'Restablecer Contraseña',
    resetPasswordConfirm: 'Esto restablecerá la contraseña a una temporal. El usuario deberá cambiarla en su próximo inicio de sesión.',
    passwordResetDone: 'Contraseña Restablecida',
    passwordReset: 'Contraseña restablecida exitosamente',
    lastModified: 'Última Modificación',
  },

  changePassword: {
    title: 'Establezca Su Contraseña',
    subtitle: 'Debe establecer una nueva contraseña antes de continuar.',
    newPassword: 'Nueva Contraseña',
    newPasswordPlaceholder: 'Ingrese su nueva contraseña',
    confirmPassword: 'Confirmar Contraseña',
    confirmPasswordPlaceholder: 'Ingrese la contraseña nuevamente',
    requirements: 'Requisitos de Contraseña:',
    minLength: 'Al menos 8 caracteres',
    uppercase: 'Al menos una letra mayúscula',
    lowercase: 'Al menos una letra minúscula',
    digit: 'Al menos un número',
    special: 'Al menos un carácter especial (!@#$%^&*)',
    passwordsMatch: 'Las contraseñas coinciden',
    submit: 'Establecer Contraseña',
    success: 'Contraseña establecida exitosamente. Por favor inicie sesión nuevamente.',
  },

  // Escáner de código de barras con cámara
  cameraScanner: {
    title: 'Escanear Código de Barras',
    instruction: 'Apunte la cámara al código de barras',
    permissionDenied: 'Permiso de cámara denegado. Por favor permita el acceso a la cámara en la configuración de su navegador.',
    noCamera: 'No se encontró cámara en este dispositivo.',
    error: 'Error al iniciar la cámara.',
    openCamera: 'Usar Cámara',
  },

  // Registro de escaneo de despacho
  productionOutputScan: {
    title: 'Escanear Salidas de Producción',
    selectOutput: 'Seleccionar Salida',
    scanCases: 'Escanear Cajas',
    selectPrompt: 'Elige una transferencia',
    outputRow: 'Salida',
    transferRow: 'Transferencia',
    cases: 'cajas',
    noRows: 'No hay salidas ni transferencias para este día',
    switch: 'Cambiar',
    scanPrompt: 'Escanear una caja...',
    noScans: 'Aún no hay escaneos',
    extrasHint: 'FP-NI / subproductos (extra — no cuentan para las cajas esperadas)',
    fpniTag: 'FP-NI',
    byproductTag: 'Subproducto',
    send: 'Enviar',
    sent: 'Enviado',
    sentBadge: 'Enviado',
    sentHint: 'Ya enviado al almacén',
    confirmStep: 'Confirmar',
    confirmPrompt: 'Revise cada salida y transferencia antes de enviar. Todas deben estar completamente escaneadas.',
    allSentComplete: 'Todas las salidas y transferencias de este día ya se enviaron — no queda nada por escanear.',
    complete: 'Completo',
    incomplete: 'Incompleto',
    reviewConfirm: 'Confirmar',
    reviewStep: 'Revisar',
    backToScan: 'Atrás',
    confirmSend: 'Confirmar y Enviar',
    sendAllReady: 'Enviar todos los listos',
    noneReady: 'Ningún destino está completamente escaneado aún',
    confirmSendAll: '¿Enviar {{count}} contenedor(es) listo(s)?',
    incompleteBlocked: 'No todas las salidas/transferencias están completamente escaneadas',
    confirmComingSoon: 'Revisión completa — el envío se conecta en la siguiente fase',
    confirmPopupBody: 'Esto escribe los registros de producción, ventas y transferencia, y envía todo al almacén. ¿Continuar?',
    delete: 'Eliminar',
    deleted: 'Eliminado',
    confirmDelete: '¿Eliminar este borrador? Su número se reutilizará.',
    // WCO-2412: conciliación por sesión (vista agrupada + tooltip de objetivo)
    plannedSurplus: '{{planned}} planificado, +{{delta}} excedente',
    plannedDeficit: '{{planned}} planificado, −{{delta}} déficit',
    extrasGroup: 'Extras (FP-NI / subproductos)',
    targetBreakdown: 'Desglose real',
    targetTotal: 'Total real',
    colPlan: 'Esperado',
    colTarget: 'Real',
  },

  shipOutScan: {
    title: 'Escanear Artículos de Transferencia',
    scanTransfer: 'Escanear Código de Transferencia',
    enterTransferNumber: 'Ingrese o escanee número de transferencia...',
    orSelectTransfer: 'O seleccione una transferencia pendiente',
    scanBadge: 'Escanee Su Credencial',
    enterBadge: 'Escanee su credencial de empleado...',
    scanBoxes: 'Escanear Cajas',
    scanBoxBarcode: 'Escanear código de barras de caja...',
    totalScanned: 'Total Escaneado',
    duplicateBox: 'Esta caja ya fue escaneada para esta transferencia',
    boxScanned: 'Caja escaneada',
    scanFailed: 'No se pudo registrar el escaneo',
    // WCO-2465 — mensajes de error de escaneo específicos (asignados desde códigos del backend)
    errWrongTargetOutput_finished: 'Esto es una caja de producto terminado — escanéala en la salida de producción, no en la transferencia de materia prima.',
    errWrongTargetOutput_byproduct: 'Esto es una caja de subproducto — escanéala en la salida de producción, no en la transferencia de materia prima.',
    errWrongTargetOutput_fpni: 'Esto es un artículo FP-NI — escanéalo en la salida de producción, no en la transferencia de materia prima.',
    errWrongTargetOutput: 'Este artículo pertenece a una salida de producción — escanéalo allí, no en la transferencia de materia prima.',
    errWrongTargetTransfer: 'Esto es una etiqueta de materia prima — escanéala en su transferencia de almacén, no en la salida de producción.',
    errWrongDay: 'Este material pertenece a la transferencia de otro día ({{otherDate}}), no a esta.',
    errUnrecognized: 'Código de barras no reconocido — no coincide con nada para este escaneo.',
    // WCO-2545 — agregar caja dañada manualmente (etiqueta no escaneable)
    addDamagedCase: 'Agregar caja dañada (sin código)',
    damagedCasesAvailable: 'Cajas dañadas (haga clic para agregar)',
    addToTransfer: 'Agregar a la transferencia',
    manualDamagedItem: 'Artículo',
    manualDamagedItemPlaceholder: 'Seleccionar artículo…',
    manualDamagedWeight: 'Peso',
    manualDamagedItemRequired: 'Seleccione el artículo de la caja dañada',
    manualDamagedWeightRequired: 'Ingrese el peso de la caja dañada',
    manualDamagedAdded: 'Caja dañada agregada a la transferencia',
    undoScan: 'Deshacer',
    transferNotFound: 'Transferencia no encontrada',
    invalidBadge: 'Credencial inválida',
    employeeNotFound: 'Empleado no encontrado',
    scanRemoved: 'Escaneo eliminado',
    clearAll: 'Borrar Todo',
    clearAllConfirm: '¿Está seguro de que desea borrar todos los escaneos de esta transferencia?',
    clearAllSuccess: 'Todos los escaneos han sido borrados',
    noScansYet: 'Aún no se han escaneado cajas',
    loadingTransfer: 'Cargando transferencia...',
    scannedBy: 'Escaneado por',
    step: 'Paso',
    barcodeNotFound: 'Código de barras no encontrado en inventario de producción',
    itemNotInTransfer: 'Este artículo no está en la transferencia',
    sessionsNotCompleted: 'Las sesiones de producción deben completarse antes de escanear',
    confirmScan: 'Confirmar Escaneo',
    scanConfirmed: 'Escaneo de despacho confirmado',
    remainingMaterial: 'Material Restante',
    loggedFromWaste: 'Registrado del seguimiento de desperdicios',
    summaryTitle: 'Esperado vs Escaneado',
    item: 'Artículo',
    expectedQty: 'Cant Esp',
    scannedQty: 'Escaneado',
    expectedWt: 'Peso Esp',
    scannedWt: 'Peso Esc',
    remainingIntact: 'Restante (Intacto)',
    remainingNotIntact: 'Restante (No Intacto)',
    unusedLot: 'Lote No Utilizado',
    confirmOnPalette: 'Confirmar en Paleta',
    manualConfirm: 'Confirmación Manual',
    byProduct: 'Subproducto',
    byProductMarketable: 'Subproducto (Comercializable)',
    byProductProduction: 'Subproducto (Producción)',
    rejectedMaterial: 'Material Rechazado',
  },

  // Herramientas de Desarrollo
  devTools: {
    title: 'Herramientas Dev',
    resetHteData: 'Restablecer Datos HTE',
    resetDescription: 'Eliminar todos los datos generados por HTE en Edge y la base de datos en la nube. Las tablas de producción se limpian completamente. Los registros ICS (>= 900001) se eliminan. Las secuencias se restablecen. No se puede deshacer.',
    resetConfirmTitle: 'Confirmar Restablecimiento de Datos HTE',
    resetConfirmWarning: 'Esto eliminará permanentemente todos los datos de producción HTE del Edge, y los registros ICS generados por HTE (>= 900001) del Edge y la base de datos en la nube. Las secuencias se restablecerán a 900001.',
    typeToConfirm: 'Escriba RESET para confirmar',
    resetButton: 'Restablecer Todos los Datos',
    resetting: 'Restableciendo...',
    resetSuccess: 'Datos HTE restablecidos exitosamente',
    resetPartial: 'Datos HTE restablecidos con errores',
    resetError: 'Error al restablecer datos HTE',
    resetSummary: 'Filas eliminadas por tabla:',
    rowsDeleted: 'filas',
    sequencesReset: 'Secuencias restablecidas',
    stationsReset: 'Estaciones restablecidas a inactivo',
    dangerZone: 'Zona de Peligro',
    dangerZoneDescription: 'Acciones irreversibles solo para desarrollo y pruebas.',
    edgeLocal: 'BD Local Edge',
    stagingVm: 'Base de datos en la nube',
    gcpProd: 'GCP Prod (10.142.0.5)',
    oracle: 'Oracle',
    noRecords: 'No se encontraron registros HTE',
    targetLabel: 'Bases de datos objetivo:',
    cloudDbTarget: 'Base de datos en la nube objetivo:',
    targetAll: 'Todas (Edge + Nube)',
    targetEdge: 'Solo Edge',
    targetCloud: 'Toda la Nube (GCP + Staging VM + Oracle)',
    targetGcpProd: 'Solo GCP Prod',
    targetStagingVm: 'Nube (dev/staging)',
    targetOracle: 'Solo Oracle',
  },

  // Eficiencia de Operador
  operatorEfficiency: {
    sortBy: 'Ordenar por',
    yield: 'Rendimiento',
    speed: 'Velocidad',
    both: 'Ambos',
    noHistory: 'Sin historial',
    avgYield: 'Rend. Prom.',
    avgSpeed: 'Vel. Prom.',
    lbsPerHour: 'lbs/hr',
    sessions: 'sesiones',
    rank: 'Ranking',
  },
  sync: {
    cloudOffline: 'Nube sin conexión',
    synced: 'Nube sincronizada',
    pending: 'pendiente(s)',
    issues: 'problema(s) de sincronización',
    syncing: 'Sincronizando...',
    lastPull: 'Última descarga',
    neverPulled: 'Nunca descargado',
    failed: 'fallido',
    pullFailed: 'Descarga fallida',
    pullStale: 'Descarga obsoleta',
    offlineWorkNotConfirmed: 'Trabajo sin conexión no confirmado en la nube',
    offlineWorkNotConfirmedDetail: 'Los cambios hechos mientras no había internet aún no se han confirmado en la nube. Contacte a soporte antes de volver a ingresar datos.',
  },
  offline: {
    youAreOffline: 'Sin conexión — las acciones se guardarán localmente',
    backOnline: 'Conexión restablecida',
    pendingActions: 'acción(es) pendiente(s)',
    syncing: 'Sincronizando...',
    allSynced: 'Todas las acciones sincronizadas',
    offlineLabel: 'Sin conexión',
  },

  // Tutorial / Walkthrough
  tutorial: {
    skip: 'Saltar Tour',
    pageTitle: 'Tutorial',
    pageSubtitle: 'Aprende a usar el sistema de producción con guías paso a paso.',
    replayTour: 'Repetir Tour',
    completed: 'Entrenamiento completado',
    tourInfo: 'El tour interactivo tiene {{count}} pasos y te guiará por las funciones clave de tu rol.',

    sections: {
      dailyQueue: 'Cola Diaria',
      dailyQueueDesc: 'Ve tus sesiones de producción asignadas para hoy. Cada tarjeta muestra el producto, estación y peso objetivo.',
      weeklySchedule: 'Horario Semanal',
      weeklyScheduleDesc: 'Ve el horario completo de la semana de un vistazo. Planifica y conoce las sesiones que vienen.',
      production: 'Producción',
      productionDesc: 'Registra tu entrada a una estación, inicia sesiones de producción, escanea cajas, registra desperdicios y completa sesiones.',
      supervisorDashboard: 'Panel del Supervisor',
      supervisorDashboardDesc: 'Monitorea todas las estaciones activas, ve el progreso en tiempo real y gestiona la producción desde una pantalla.',
      productionPlanning: 'Planificación de Producción',
      productionPlanningDesc: 'Crea y programa sesiones de producción. Asigna productos, estaciones, operadores y pesos objetivo.',
      schedule: 'Horario',
      scheduleDesc: 'Ve el horario completo de producción en todas las estaciones en formato diario o semanal.',
      transfers: 'Transferencias de Almacén',
      transfersDesc: 'Gestiona transferencias de almacén — escanea cajas dentro y fuera del almacén frío y rastrea el estado.',
      inventory: 'Inventario',
      inventoryDesc: 'Ve seguimiento de lotes, productos terminados, búsqueda de cajas y materiales de empaque.',
      reports: 'Reportes',
      reportsDesc: 'Accede a resúmenes de fin de día, reportes de varianza de rendimiento e historial de anulaciones.',
      productionRecords: 'Registros de Producción',
      productionRecordsDesc: 'Busca y revisa datos históricos de sesiones de producción.',
      managerDashboard: 'Panel del Gerente',
      managerDashboardDesc: 'Revisa aprobaciones pendientes, solicitudes de transferencia y estado de producción.',
      adminDashboard: 'Panel de Administrador',
      adminDashboardDesc: 'Vista general de actividad del sistema, estadísticas de usuarios y métricas clave.',
      userManagement: 'Gestión de Usuarios',
      userManagementDesc: 'Ve y gestiona todas las cuentas de usuario. Asigna roles y monitorea actividad de inicio de sesión.',
      stationManagement: 'Gestión de Estaciones',
      stationManagementDesc: 'Crea, edita y configura estaciones de producción. Establece materiales permitidos y ubicaciones.',
      settings: 'Configuración',
      settingsDesc: 'Configura preferencias del sistema, gestiona cuentas de usuario ICS y ve información del sistema.',
    },

    operator: {
      dailyQueue: { title: 'Cola Diaria', content: 'Esta es tu cola de trabajo diaria. Verás todas las sesiones asignadas para hoy.' },
      sessionCard: { title: 'Tarjeta de Sesión', content: 'Cada tarjeta es una sesión de producción. Toca para ver detalles como producto, estación y peso objetivo.' },
      sessionCardScanIn: { title: 'Modal de Registro', content: 'Esto se abre al tocar una tarjeta de sesión. Puedes ver los detalles, quién está asignado, y escanear tu credencial o ingresar tu número de empleado para registrarte.' },
      weeklyView: { title: 'Horario Semanal', content: 'Cambia aquí para ver tu horario completo de la semana.' },
      clockIn: { title: 'Escanear Entrada', content: 'Escanea un código QR de estación o selecciona tu estación para escanear y comenzar a trabajar.' },
      scanBadge: { title: 'Escanear Credencial', content: 'Después de escanear una estación, verás la información de la sesión. Ahora escanea tu credencial de empleado para registrarte.' },
      scanSuccess: { title: '¡Registrado!', content: 'Ya estás registrado y serás redirigido a tu vista de producción. ¡Puedes comenzar a trabajar!' },
      sessionInfo: { title: 'Información de la Sesión', content: 'Esta barra muestra los detalles de tu sesión actual — producto, materia prima, número de lote, especificaciones de empaque y cajas esperadas.' },
      startSession: { title: 'Iniciar Sesión', content: 'Una vez asignado a una sesión, toca Iniciar para comenzar la producción.' },
      boxScanning: { title: 'Escaneo de Cajas', content: 'Ingresa o pesa cada caja aquí. Cuando el peso esté dentro del rango objetivo, se pone verde y puedes imprimir la etiqueta.' },
      printLabel: { title: 'Imprimir Etiqueta', content: 'Cuando el peso sea válido, toca Imprimir Etiqueta para imprimir una etiqueta de código de barras. La etiqueta incluye producto, lote, peso y código de fecha.' },
      badgeLabelScan: { title: 'Escaneo de Credencial y Etiqueta', content: 'Después de imprimir, escanea tu credencial y luego la etiqueta en la caja para confirmar que está aplicada. Esto asegura que cada caja esté correctamente etiquetada.' },
      finishSession: { title: 'Finalizar Sesión', content: 'Cuando hayas empacado todas las cajas objetivo, aparece la pantalla de Meta Alcanzada. Toca Completar Sesión para continuar al registro de desperdicios.' },
      wasteTracking: { title: 'Registro de Desperdicios', content: 'Registra todos los desperdicios y subproductos paso a paso — desperdicio desechable, error humano, subproductos y sobrantes. Un supervisor revisará y firmará al final.' },
      completeSession: { title: 'Completar Sesión', content: 'Cuando termines, toca Completar. Registrarás desperdicios y subproductos, luego un supervisor puede necesitar aprobar si el rendimiento está fuera de rango.' },
    },

    supervisor: {
      dashboard: { title: 'Panel del Supervisor', content: 'Este es tu panel. Ve todas las estaciones activas y su estado actual de un vistazo.' },
      stationCards: { title: 'Tarjetas de Estación', content: 'Cada tarjeta muestra la sesión actual de una estación, operador y progreso de producción.' },
      productionPlanning: { title: 'Planificación de Producción', content: 'Crea nuevas sesiones de producción aquí. Asigna producto, estación, operador y peso objetivo.' },
      sessionList: { title: 'Lista de Sesiones', content: 'Ve todas las sesiones planificadas, activas y completadas. Reordena la cola según sea necesario.' },
      schedule: { title: 'Horario', content: 'Ve el horario completo de producción en todas las estaciones.' },
      transfers: { title: 'Transferencias de Almacén', content: 'Gestiona transferencias de almacén — escanea cajas dentro y fuera del almacén frío.' },
      inventory: { title: 'Inventario', content: 'Ve seguimiento de lotes, productos terminados y materiales de empaque.' },
      reports: { title: 'Reportes', content: 'Accede a todos los reportes de producción desde esta página.' },
      reportEod: { title: 'Reporte de Fin de Día', content: 'Revisa el resumen diario de producción — producción, rendimiento y desempeño del operador.' },
      reportYield: { title: 'Varianza de Rendimiento', content: 'Las sesiones marcadas para revisión de rendimiento aparecen aquí. Aprueba o investiga según sea necesario.' },
      productionRecords: { title: 'Registros de Producción', content: 'Busca y revisa datos históricos de producción.' },
      settings: { title: 'Configuración', content: 'Configura tus preferencias y ajustes del sistema.' },
    },

    manager: {
      dashboard: { title: 'Panel del Gerente', content: 'Tu cola de aprobación y vista general de producción. Los elementos pendientes aparecen aquí.' },
      approvalCards: { title: 'Cola de Aprobación', content: 'Revisa y aprueba o rechaza solicitudes de transferencia y otras acciones de nivel gerente.' },
      productionPlanning: { title: 'Planificación de Producción', content: 'Ve y crea sesiones de producción, mismo acceso que supervisor.' },
      schedule: { title: 'Horario', content: 'Horario completo de producción en todas las estaciones y fechas.' },
      transfers: { title: 'Transferencias de Almacén', content: 'Gestiona transferencias de almacén y movimientos de almacén frío.' },
      inventory: { title: 'Inventario', content: 'Rastrea lotes, productos terminados y consumo de materiales.' },
      reports: { title: 'Reportes', content: 'Accede a reportes de producción — fin de día, varianza de rendimiento y anulaciones.' },
      productionRecords: { title: 'Registros de Producción', content: 'Busca sesiones de producción pasadas y datos de desempeño.' },
    },

    admin: {
      dashboard: { title: 'Panel de Administrador', content: 'Vista general del sistema con estadísticas de usuarios y métricas clave.' },
      users: { title: 'Gestión de Usuarios', content: 'Ve y gestiona todas las cuentas de usuario en el sistema.' },
      inventory: { title: 'Inventario', content: 'Gestión completa de inventario — lotes, productos terminados y materiales.' },
      stations: { title: 'Gestión de Estaciones', content: 'Crea, edita y configura estaciones de producción.' },
      schedule: { title: 'Horario', content: 'Ve el horario de producción en todas las estaciones.' },
      settings: { title: 'Configuración', content: 'Configura preferencias del sistema y gestiona cuentas de usuario ICS.' },
      icsUsers: { title: 'Gestión de Usuarios ICS', content: 'Habilita empleados ICS como usuarios del sistema de producción. Asigna roles y contraseñas temporales.' },
    },
  },
  // Manager Guide (step-by-step workflow)
  managerGuide: {
    title: 'Guía de Producción',
    next: 'Siguiente Paso',
    previous: 'Anterior',
    steps: {
      plan: 'Planificar',
      transfers: 'Transferencias',
      production: 'Producción',
      review: 'Revisar',
    },
    plan: {
      sessionsToday: 'Sesiones Hoy',
      sessionsOnDate: 'Sesiones del {{date}}',
      planned: 'enviadas',
      active: 'activas',
      completed: 'completadas',
      operators: 'Operadores',
      packers: 'Empacadores',
      stations: 'Estaciones',
      scheduledToday: 'programadas hoy',
      scheduledOnDate: 'programadas el {{date}}',
      todaysSessions: 'Sesiones de Hoy',
      sessionsForDate: 'Sesiones del {{date}}',
      createSession: 'Crear Sesión',
      viewAll: 'Ver Todo',
      noSessions: 'No hay sesiones planificadas para hoy',
      createFirst: 'Crear tu primera sesión',
      sessionCreated: 'Sesión creada exitosamente',
      cancelled: 'Canceladas',
    },
    transfers: {
      title: 'Transferencias',
      thisWeek: 'Esta Semana',
      pending: 'Pendientes',
      scanned: 'Escaneadas',
      completed: 'Completadas',
      recentTransfers: 'Transferencias Recientes',
      last7Days: 'últimos 7 días',
      viewAll: 'Ver Todas las Transferencias',
      noTransfers: 'No hay transferencias en los últimos 7 días',
      transferNo: 'Transferencia #',
      date: 'Fecha',
      from: 'Origen',
      to: 'Destino',
      items: 'Artículos',
      status: 'Estado',
      lastEdited: 'Última Edición',
      showVb6: 'Mostrar Transferencias VB6',
    },
    produce: {
      activeStations: 'Estaciones Activas',
      boxesPacked: 'Cajas Empacadas',
      expectedOutput: 'Producción Esperada',
      actualOutput: 'Producción Real',
      totalWeight: 'Peso Total',
      waitingToStart: 'esperando inicio',
      openStations: 'Abrir Estaciones',
      allStarted: 'Todas las sesiones iniciadas',
      promoteFailed: 'Error al abrir estaciones',
      liveProgress: 'Progreso en Vivo',
      fullView: 'Vista Completa',
      noActive: 'No hay sesiones activas ahora',
    },
    review: {
      totalOutput: 'Producción Total',
      of: 'de',
      expected: 'esperado',
      completion: 'Completado',
      sessionsCompleted: 'Sesiones Completadas',
      pendingApprovals: 'Aprobaciones Pendientes',
      approvalsTitle: 'Artículos Pendientes de Aprobación',
      quickLinks: 'Accesos Rápidos',
      endOfDay: 'Resumen del Día',
      endOfDayDesc: 'Ver reporte de producción diario',
      records: 'Registros de Producción',
      recordsDesc: 'Explorar registros históricos',
      transfers: 'Transferencias',
      transfersDesc: 'Ver y gestionar transferencias',
      productionSummary: 'Resumen de Producción',
      materialFlow: 'Flujo de Materiales',
      input: 'Entrada',
      output: 'Salida',
      waste: 'Desperdicio',
      returns: 'Devoluciones y Subproductos',
      utilization: 'Utilización',
      byProduct: 'Por Producto',
      product: 'Producto',
      sessions: 'Sesiones',
      boxes: 'Cajas',
      weight: 'Peso',
      yield: 'Rendimiento',
      wasteBreakdown: 'Desglose de Desperdicio',
      wasteType: 'Tipo',
      alerts: 'Alertas',
      noData: 'Sin datos de producción para hoy',
      viewFullReport: 'Ver Reporte Completo',
      complete: 'Completar',
    },
  },

  // Indicadores de frescura para lotes de subproductos
  freshness: {
    fresh: 'Fresco',
    useSoon: 'Usar Pronto',
    oldStock: 'Stock Antiguo',
    alertByProductAging: 'El subproducto necesita ser usado en producción',
    resolveForToday: 'Resolver por Hoy',
  },
  // WCO-2618: per-row (i) print-audit popover on the Print Labels sections.
  printAudit: {
    title: 'Historial de impresión de etiquetas',
    empty: 'Aún no se han impreso etiquetas.',
    printedColumn: 'Impreso',
    printed: 'Impreso',
    notPrinted: 'No impreso',
    by: 'por',
    statusActive: 'Activo',
    statusSuperseded: 'Reemplazado',
    statusVoided: 'Anulado',
  },
} as const;
